/* eslint-disable no-lone-blocks */
import React, { useEffect, useRef, useState } from "react";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import HideSourceIcon from "@mui/icons-material/HideSource";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import styled from "styled-components";
import HelpIcon from "@mui/icons-material/Help";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import StarsIcon from "@mui/icons-material/Stars";
import PaidIcon from "@mui/icons-material/Paid";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import BatteryCharging50Icon from "@mui/icons-material/BatteryCharging50";
import {
  Col,
  DatePicker,
  Row,
  Flex,
  Typography,
  Tooltip,
  Badge,
  Avatar,
} from "antd";
import { Button as BtnMobile, Dropdown as DropdownMobile } from "antd-mobile";
import dayjs from "dayjs";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import CloudSyncTwoToneIcon from "@mui/icons-material/CloudSyncTwoTone";
import type { RadioChangeEvent } from "antd";
import type { Dayjs } from "dayjs";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";

import customParseFormat from "dayjs/plugin/customParseFormat";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import { Radio } from "antd";

import SettingsIcon from "@mui/icons-material/Settings";
import type { TableProps } from "antd/es/table";
import { Dropdown, Form, Modal, message } from "antd";
import { AppstoreOutlined, SearchOutlined } from "@ant-design/icons";
import { Skeleton } from "antd";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import type { MenuProps } from "antd";

import type { FilterValue, SorterResult } from "antd/es/table/interface";

import Highlighter from "react-highlight-words";
import type { InputRef } from "antd";
import { Button, Input, Space, Table } from "antd";
import type { ColumnType, ColumnsType } from "antd/es/table";
import type { FilterConfirmProps } from "antd/es/table/interface";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { gridRowCountSelector } from "@mui/x-data-grid";

import axios from "axios";

import Globais, {
  AlterarFormatoData,
  CalcularDiferencaDias,
  VerificarPeriodo,
  adicionarDiasData,
  atualizarPeriodoUsuario,
  definirFasePeriodoUsuario,
  deletarSomenteFracionados,
  deletarSomentePeriodosUsuarios,
  enviarEmail,
  exibirMoeda,
  formatarData,
  formatarMoeda,
  naoFracione,
  qualSituacao,
  retornaDiaDaSemana,
  retornarValorAtualizado,
  validateDataCheckOutMaior,
  validatePeriodoFracionado,
  validateToken,
  venderCota,
  verificarSeTemPeriodoDivulgado,
} from "../../components/Globais";

import MenuItem from "@mui/material/MenuItem";
import { NumberParam, StringParam, useQueryParams } from "use-query-params";
import TextArea from "antd/es/input/TextArea";

import { green, grey, red } from "@mui/material/colors";
import { useWarning } from "../../uteis/mensagens/useWarning";
import { useMediaQuery } from "react-responsive";
import { Container, ContainerItems, Icon, Items } from "./styles";
import ModalAcoes from "./components/ModalAcoes";

import { useReservadoMC } from "./hooks/useReservadoMC";

const ContainerTitulo = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  grid-column-start: 2;
  grid-row-start: 1;
`;
const ContainerSeta = styled.div`
  width: 100%;
  height: 100%;

  grid-column-start: 1;
  grid-row-start: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ContainerLista = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  min-width: 20rem;
  overflow: scroll;
  padding: 1rem;
  grid-template: 10% 90% / auto;
`;

const BotoesAcoes = styled.button`
  border: none;
  color: blue;
  background-color: transparent;
  &: hover {
    cursor: pointer;
  }
`;

interface DataType {
  active: string;
  alterado: boolean;
  origem: any;
  periodoId: number;
  periodoUsuarioId: number;
  key: string;
  checkIn: string;
  checkOut: string;
  situacao: string;
  divulgado: string;
  valorMin: string;
  status: string;
  icone: string;
  tarefa: string;
  statusAnterior: string;
  especial: string;
  dataSugestao: string;
  valorSugerido: string;
  valorSugeridoSistema: string;
  dataEspecial: string;
  fracionamento: number;

  created_at: string;

  id: number;
  idPEU: number;
  idUs: number;
  nomeUs: string;
  sobrenome: string;
  celular: string;
  email: string;
  nomeEP: string;
  numeroCota: number;
  checked: string;

  updated_at: Date;

  idPE: number;
  idCTU: number;
}

type DataIndex = keyof DataType;

type MenuItem = Required<MenuProps>["items"][number];

interface Values {
  title: string;
  description: string;
  // modifier: string;
}
interface ValuesValor {
  valorMin: string;
  // title: string;
  // description: string;
  // description: string;
  // modifier: string;
}
interface ValuesFracao {
  checkIn1: string;
  checkOut1: string;
  valorMin1: string;
  checkIn2: string;
  checkOut2: string;
  valorMin2: string;
}
interface ValuesValoresAnunciado {
  checkIn1: string;
  checkOut1: string;
  valorMin1: string;
  checkIn2: string;
  checkOut2: string;
  valorMin2: string;
}
interface ValuesFracaoCompleta {
  checkInPrincipal: string;
  checkOutPrincipal: string;
  valorMinPrincipal: string;
  checkIn1: string;
  checkOut1: string;
  valorMin1: string;
  checkIn2: string;
  checkOut2: string;
  valorMin2: string;
}
interface ValuesFracaoCompletaAtualizar {
  checkInPrincipal: string;
  checkOutPrincipal: string;
  valorMinPrincipal: string;
  checkIn1: string;
  checkOut1: string;
  valorMin1: string;
  checkIn2: string;
  checkOut2: string;
  valorMin2: string;
}
interface ValuesMaisPeriodo {
  checkIn: string;
  checkOut: string;
}

interface CollectionCreateFormProps {
  open: boolean;
  onCreate: (values: Values) => void;
  onCancel: () => void;
}
interface CollectionCreateFormPropsValor {
  open: boolean;
  onCreate: (valuesValor: ValuesValor) => void;
  onCancel: () => void;
}

interface CollectionCreateFormPropsValoresAnunciado {
  open: boolean;
  onCreate: (valuesValoresAnunciado: ValuesValoresAnunciado) => void;
  onCancel: () => void;
}
interface CollectionCreateFormPropsFracao {
  open: boolean;
  onCreate: (valuesFracao: ValuesFracao) => void;
  onCancel: () => void;
}
interface CollectionCreateFormPropsFracaoCompleta {
  open: boolean;
  onCreate: (valuesFracaoCompleta: ValuesFracaoCompleta) => void;
  onCancel: () => void;
}
interface CollectionCreateFormPropsFracaoCompletaAtualizar {
  open: boolean;
  onCreate: (
    valuesFracaoCompletaAtualizar: ValuesFracaoCompletaAtualizar
  ) => void;
  onCancel: () => void;
}
interface CollectionCreateFormPropsMaisPeriodo {
  open: boolean;
  onCreate: (valuesMaisPeriodo: ValuesMaisPeriodo) => void;
  onCancel: () => void;
}

export default function ViewGerenciarPeriodosUsuarios() {
  const { verificarReserva } = useReservadoMC();

  //variavies
  const [nUserId, setNUserid] = useQueryParams({
    userId: NumberParam,
  });
  const [titleFracaoCompleta, setTitleFracaoCompleta] = useState(false);
  const { Title } = Typography;
  const [nNumeroCota, setNNumeroCota] = useQueryParams({
    numeroCota: NumberParam,
  });
  const [nCotaUsuarioId, setNCotaUsuarioId] = useQueryParams({
    cotaUsuarioId: NumberParam,
  });
  const [nNome, setNome] = useQueryParams({ nomeProp: StringParam });
  const [nNomeEmpreend, setNomeEmpreend] = useQueryParams({
    nomeEmpreend: StringParam,
  });
  const [periodoData, setPeriodoData] = useState<any>();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  dayjs.extend(customParseFormat);
  const [Aluguel, setAluguel] = useState<any>();
  const dateFormat = "DD/MM/YYYY";
  const [status, setStatus] = useState("");

  const valor = useRef("");
  const valorSugeridoSistema = useRef("");
  const specialDate = useRef("");
  const contadorVerificar = useRef(0);
  const contadorAlterando = useRef(0);
  const contadorAlterado = useRef(0);
  const contadorAguardando = useRef(0);

  const valorSugeridoSistema1Fracao = useRef("");
  const valorSugeridoSistema2Fracao = useRef("");
  const [semFiltros, setSemFiltros] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  const diariaExibida = useRef("");
  const diariaAirbnb = useRef(0.0);
  const diariaBooking = useRef(0.0);
  const diariaDecolar = useRef(0.0);
  const diariaExpedia = useRef(0.0);

  const novoValorAirbnb = useRef(0.0);
  const novoValorParcelado = useRef(0.0);
  const novoValorBooking = useRef(0.0);
  const novoValorDecolar = useRef(0.0);
  const novoValorExpedia = useRef(0.0);
  const valorDiariaAjustadaExibida = useRef("");
  const dataSugestao = useRef("");
  const valorSugerido = useRef("");
  const valorSugeridoFracao = useRef("");
  const valorSugerido1Fracao = useRef("");
  const valorSugerido2Fracao = useRef("");

  const emLote = useRef(0);
  const fracionamento = useRef(0);
  const cotaUsuarioId = useRef(0);
  const alugarOuTrocar = useRef(0);
  const checkInPeriodo = useRef("");
  const atualizando = useRef(false);

  const alterando = useRef(false);

  const checkOutPeriodo = useRef("");

  const checkInPrimeiroPeriodo = useRef("");
  const checkOutPrimeiroPeriodo = useRef("");
  const checkInSegundoPeriodo = useRef("");
  const checkOutSegundoPeriodo = useRef("");
  const valorPrimeiroPeriodo = useRef("");
  const valorSegundoPeriodo = useRef("");
  const checkInPeriodoAdicionado = useRef("");
  const checkOutPeriodoAdicionado = useRef("");
  const situacaoAnterior = useRef("");
  const tipoEmail = useRef(0);

  const [messageApi, contextHolder] = message.useMessage();
  const [openExcluir, setOpenExcluir] = useState(false);

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);
  const periodoUsuario = useRef(0);
  const periodoUsuario1Fracao = useRef(0);
  const periodoUsuario2Fracao = useRef(0);
  const periodo = useRef(0);
  const situacao = useRef("");
  const active = useRef(0);
  const statusAtual = useRef("");
  const statusAnterior = useRef("");
  const divulgado = useRef("");
  const [open, setOpen] = useState(false);
  const [openValor, setOpenValor] = useState(false);
  const [openFracao, setOpenFracao] = useState(false);
  const [openMaisPeriodo, setOpenMaisPeriodo] = useState(false);
  const [openValoresAnunciado, setOpenValoresAnunciado] = useState(false);
  const [valueValoresAnunciado, setValueValoresAnunciado] = useState(1);

  const [openModalPerguntaFracaoCompleta, setOpenModalPerguntaFracaoCompleta] =
    useState(false);

  const [openModalFracaoCompleta, setOpenModalFracaoCompleta] = useState(false);
  const [
    openModalFracaoCompletaAtualizar,
    setOpenModalFracaoCompletaAtualizar,
  ] = useState(false);
  const [openFracaoCompleta, setOpenFracaoCompleta] = useState(false);

  const userId = useRef(0);
  const situacaoDesejada = useRef("");
  const [isLoading, setIsLoading] = useState(true);
  const { RangePicker } = DatePicker;
  const [filteredInfo, setFilteredInfo] = useState<
    Record<string, FilterValue | null>
  >({});
  const [valueStatus, setValueStatus] = useState("AGUARDANDO_SUGESTAO");
  const [sortedInfo, setSortedInfo] = useState<SorterResult<DataType>>({});
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [loading, setLoading] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [sugestaoCheckOut, setSugestaoCheckOut] = useState("");
  const contador = useRef(0);

  const [textoData, setTextoData] = useState("");

  const isMobile = useMediaQuery({ maxWidth: 768 });
  const isDesktop = useMediaQuery({ query: "(min-width: 769px)" });

  const excluirPeriodo = async () => {
    const Token = validateToken();

    const periodoUsuarioId = periodoUsuario.current;

    if (
      statusAtual.current === "AGUARDANDO_SUGESTAO" ||
      statusAtual.current === "AGUARDANDO_PEDIDO"
    ) {
      error(
        "Esse período não pode ser excluído pois está aguardando resposta do proprietário"
      );
    } else {
      if (nCotaUsuarioId.cotaUsuarioId === 0) {
        Aluguel.filter(async (p: any) => {
          if (p.id === periodoUsuario.current) {
            if (p.children) {
              error(
                "Esse período não pode ser excluído pois tenho períodos fracionados. Exclua-os para poder excluir esse."
              );
            } else {
              if (Token) {
                const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;

                let formData = {
                  active: 0,
                };

                try {
                  const response = await axios.put(URL, formData, {
                    headers: { Authorization: Token.AuthStr },
                  });
                  if (response) {
                    success("Período exclúido com sucesso!");
                    setTimeout(() => {
                      document.location.reload();
                    }, 2000);
                  } else {
                    error("Algo deu errado!");
                  }
                } catch (error) {
                  error("Algo deu errado!");
                }
              } else {
                document.location.href = "/";
              }
            }
          }
        });
      } else {
        periodoData.filter(async (p: any) => {
          if (p.id === periodoUsuario.current) {
            if (p.children) {
              error(
                "Esse período não pode ser excluído pois tenho períodos fracionados. Exclua-os para poder excluir esse."
              );
            } else {
              if (Token) {
                const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;

                let formData = {
                  active: 0,
                };

                try {
                  const response = await axios.put(URL, formData, {
                    headers: { Authorization: Token.AuthStr },
                  });
                  if (response) {
                    success("Período exclúido com sucesso!");
                    setTimeout(() => {
                      document.location.reload();
                    }, 2000);
                  } else {
                    error("Algo deu errado!");
                  }
                } catch (error) {
                  error("Algo deu errado!");
                }
              } else {
                document.location.href = "/";
              }
            }
          }
        });
      }
    }
  };

  const onChangeStatus = (e: RadioChangeEvent) => {
    setValueStatus(e.target.value);
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const onRangeChangePeriodoPrincipal = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[]
  ) => {
    console.log(dateStrings[0], dateStrings[1]);
  };
  const onRangeChangePrimeiroPeriodo = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[]
  ) => {
    if (dates) {
      if (
        validatePeriodoFracionado(
          checkInPeriodo.current,
          checkOutPeriodo.current,
          dateStrings[0],
          dateStrings[1],
          "",
          ""
        ) === "ok"
      ) {
        checkInPrimeiroPeriodo.current = dateStrings[0];
        checkOutPrimeiroPeriodo.current = dateStrings[1];
        setSugestaoCheckOut(dateStrings[1]);
      } else {
        error(
          validatePeriodoFracionado(
            checkInPeriodo.current,
            checkOutPeriodo.current,
            dateStrings[0],
            dateStrings[1],
            "",
            ""
          )
        );
      }
    }

    // console.log(new Date("2023-11-23") > new Date(date1));
  };
  const onRangeChangeSegundoPeriodo = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[]
  ) => {
    if (dates) {
      if (
        validatePeriodoFracionado(
          checkInPeriodo.current,
          checkOutPeriodo.current,
          "",
          "",
          dateStrings[0],
          dateStrings[1]
        )
      ) {
        checkInSegundoPeriodo.current = dateStrings[0];
        checkOutSegundoPeriodo.current = dateStrings[1];
        setSugestaoCheckOut(dateStrings[0]);
      } else {
        error(
          validatePeriodoFracionado(
            checkInPeriodo.current,
            checkOutPeriodo.current,
            "",
            "",
            dateStrings[0],
            dateStrings[1]
          )
        );
      }
    }
  };
  const onRangeChangeMaisPeriodo = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[]
  ) => {
    if (dates) {
      let diferenca = CalcularDiferencaDias(
        AlterarFormatoData(dateStrings[1]),
        AlterarFormatoData(dateStrings[0])
      );
      if (diferenca > 7) {
        error("O período deve ser menor ou igual a 7 dias.");
      } else {
        checkInPeriodoAdicionado.current = dateStrings[0];
        checkOutPeriodoAdicionado.current = dateStrings[1];
      }
    }
  };

  const onCancelFracaoCompleta = () => {
    setOpenModalFracaoCompleta(false);
  };
  const onCancelFracaoCompletaAtualizar = () => {
    atualizando.current = false;
    setOpenModalFracaoCompletaAtualizar(false);
  };

  const CollectionCreateForm: React.FC<CollectionCreateFormProps> = ({
    open,
    onCreate,
    onCancel,
  }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={open}
        title="Mandar E-mail"
        okText="Enviar"
        cancelText="Cancelar"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              form.resetFields();
              onCreate(values);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          name="form_in_modal"
          // initialValues={{ modifier: "public" }}
        >
          <Form.Item
            name="title"
            label="Assunto"
            rules={[
              { required: true, message: "Por favor insira um assunto!" },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="description"
            label="Mensagem"
            rules={[
              { required: true, message: "Por favor insira uma mensagem!" },
            ]}
          >
            <TextArea size="large" autoSize={{ minRows: 2, maxRows: 6 }} />
          </Form.Item>
          {/* <Form.Item
            name="modifier"
            className="collection-create-form_last-form-item"
          ></Form.Item> */}
        </Form>
      </Modal>
    );
  };
  const CollectionCreateFormValor: React.FC<CollectionCreateFormPropsValor> = ({
    open,
    onCreate,
    onCancel,
  }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={openValor}
        title="Incluir valor do aluguel"
        okText="Incluir"
        cancelText="Cancelar"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((valuesValor) => {
              form.resetFields();
              onCreate(valuesValor);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          // name="form_in_modal"
          initialValues={{ modifier: "public" }}
        >
          <Row>
            <Col span={16}>
              <Form.Item
                name="valorMin"
                label="Valor"
                rules={[
                  { required: true, message: "Por favor insira um valor!" },
                ]}
              >
                <TextArea size="small" autoSize={{ minRows: 2, maxRows: 2 }} />
              </Form.Item>
            </Col>
            <Col
              span={6}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Form.Item name="valorSugerido" label="Sugestão">
                {valorSugeridoSistema.current}
              </Form.Item>
            </Col>
          </Row>

          <Radio.Group onChange={onChangeStatus} value={valueStatus}>
            <Radio
              disabled={statusAtual.current === "NAO_PERTUBE" ? true : false}
              value={"AGUARDANDO_SUGESTAO"}
            >
              {statusAtual.current === "DELEGADO" ? "Delegado" : "Sugestão"}
            </Radio>
            <Radio value={"AGUARDANDO_PEDIDO"}>A Pedido</Radio>
          </Radio.Group>
          {/* <Form.Item
            name="modifier"
            className="collection-create-form_last-form-item"
          ></Form.Item> */}
        </Form>
      </Modal>
    );
  };

  const CollectionCreateFormFracao: React.FC<
    CollectionCreateFormPropsFracao
  > = ({ open, onCreate, onCancel }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={openFracao}
        title="Fracionar período"
        okText="Fracionar"
        cancelText="Cancelar"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((valuesFracao) => {
              form.resetFields();
              onCreate(valuesFracao);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          // name="form_in_modal"
          // initialValues={{ modifier: "public" }}
        >
          <Row gutter={16}>
            <Col span={16}>
              <Form.Item
                name="periodo1"
                label="Primeiro período"
                // {...{ wrapperCol: { span: 9, offset: 2 } }}
              >
                <RangePicker
                  placeholder={["check-in", "check-out"]}
                  format={dateFormat}
                  size={"large"}
                  onChange={onRangeChangePrimeiroPeriodo}
                  defaultValue={[
                    dayjs(checkInPeriodo.current, dateFormat),
                    dayjs(sugestaoCheckOut, dateFormat),
                  ]}
                  disabled={[true, true]}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="valorMin1"
                label="Valor"
                rules={[
                  { required: true, message: "Por favor insira um valor!" },
                ]}
              >
                <TextArea size="small" autoSize={{ minRows: 2, maxRows: 2 }} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={16}>
              <Form.Item
                name="periodo2"
                label="Segundo período"
                // {...{ wrapperCol: { span: 9, offset: 2 } }}
              >
                <RangePicker
                  placeholder={["check-in", "check-out"]}
                  format={dateFormat}
                  size={"large"}
                  onChange={onRangeChangeSegundoPeriodo}
                  defaultValue={[
                    dayjs(sugestaoCheckOut, dateFormat),
                    dayjs(checkOutPeriodo.current, dateFormat),
                  ]}
                  disabled={[true, true]}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="valorMin2"
                label="Valor"
                rules={[
                  { required: true, message: "Por favor insira um valor!" },
                ]}
              >
                <TextArea size="small" autoSize={{ minRows: 2, maxRows: 2 }} />
              </Form.Item>
            </Col>
          </Row>
          <Radio.Group onChange={onChangeStatus} value={valueStatus}>
            <Radio
              disabled={statusAtual.current === "NAO_PERTUBE" ? true : false}
              value={"AGUARDANDO_SUGESTAO"}
            >
              {statusAtual.current === "DELEGADO" ? "Delegado" : "Sugestão"}
            </Radio>
            <Radio value={"AGUARDANDO_PEDIDO"}>A Pedido</Radio>
          </Radio.Group>
        </Form>
      </Modal>
    );
  };

  const { showWarning, contextHolder: contextWarning } = useWarning();

  //como o que preciso é um modal informativo que você não deve ter inputs então não precisa de onChange. Veja um exemplo de modal
  const CollectionCreateFormFracaoCompleta: React.FC<
    CollectionCreateFormPropsFracaoCompleta
  > = ({ open, onCreate, onCancel }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={openModalFracaoCompleta}
        title="Alugar período e fracionados"
        okText="Ok"
        cancelText="Cancelar"
        onCancel={onCancelFracaoCompleta}
        onOk={() => {
          form
            .validateFields()
            .then((valuesFracaoCompleta) => {
              form.resetFields();
              onCreate(valuesFracaoCompleta);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <>{contextWarning}</>
        <Form
          form={form}
          layout="vertical"
          // name="form_in_modal"
          // initialValues={{ modifier: "public" }}
        >
          <Row gutter={16}>
            <Col span={14}>
              <Form.Item
                name="periodo_pai"
                label="Período principal"
                // {...{ wrapperCol: { span: 9, offset: 2 } }}
              >
                <RangePicker
                  placeholder={["check-in", "check-out"]}
                  format={dateFormat}
                  size={"large"}
                  onChange={onRangeChangePeriodoPrincipal}
                  defaultValue={[
                    dayjs(checkInPeriodo.current, dateFormat),
                    dayjs(checkOutPeriodo.current, dateFormat),
                  ]}
                  disabled={[true, true]}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="valorMinPrincipal"
                label="Valor"
                rules={[
                  { required: true, message: "Por favor insira um valor!" },
                ]}
              >
                <Input size="large" />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="valorSugerido" label="Sugestão">
                {valorSugeridoSistema.current}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={14}>
              <Form.Item
                name="periodo1"
                label="Primeiro período"
                // {...{ wrapperCol: { span: 9, offset: 2 } }}
              >
                <RangePicker
                  placeholder={["check-in", "check-out"]}
                  format={dateFormat}
                  size={"large"}
                  onChange={onRangeChangePrimeiroPeriodo}
                  defaultValue={[
                    dayjs(checkInPeriodo.current, dateFormat),
                    dayjs(sugestaoCheckOut, dateFormat),
                  ]}
                  disabled={[true, true]}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="valorMin1"
                label="Valor"
                rules={[
                  { required: true, message: "Por favor insira um valor!" },
                ]}
              >
                <Input size="large" />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="valorSugerido" label="Sugestão">
                {valorSugeridoSistema1Fracao.current}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={14}>
              <Form.Item
                name="periodo2"
                label="Segundo período"
                // {...{ wrapperCol: { span: 9, offset: 2 } }}
              >
                <RangePicker
                  placeholder={["check-in", "check-out"]}
                  format={dateFormat}
                  size={"large"}
                  onChange={onRangeChangeSegundoPeriodo}
                  defaultValue={[
                    dayjs(sugestaoCheckOut, dateFormat),
                    dayjs(checkOutPeriodo.current, dateFormat),
                  ]}
                  disabled={[true, true]}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="valorMin2"
                label="Valor"
                rules={[
                  { required: true, message: "Por favor insira um valor!" },
                ]}
              >
                <Input size="large" />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="valorSugerido" label="Sugestão">
                {valorSugeridoSistema2Fracao.current}
              </Form.Item>
            </Col>
          </Row>
          <Radio.Group onChange={onChangeStatus} value={valueStatus}>
            <Radio
              disabled={statusAtual.current === "NAO_PERTUBE" ? true : false}
              value={"AGUARDANDO_SUGESTAO"}
            >
              {statusAtual.current === "DELEGADO" ? "Delegado" : "Sugestão"}
            </Radio>
            <Radio value={"AGUARDANDO_PEDIDO"}>A Pedido</Radio>
          </Radio.Group>
        </Form>
      </Modal>
    );
  };
  const CollectionCreateFormFracaoCompletaAtualizar: React.FC<
    CollectionCreateFormPropsFracaoCompletaAtualizar
  > = ({ open, onCreate, onCancel }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={openModalFracaoCompletaAtualizar}
        title="Alugar período e fracionados"
        okText="Ok"
        cancelText="Cancelar"
        onCancel={onCancelFracaoCompletaAtualizar}
        onOk={() => {
          form
            .validateFields()
            .then((valuesFracaoCompletaAtualizar) => {
              form.resetFields();
              onCreate(valuesFracaoCompletaAtualizar);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          // name="form_in_modal"
          // initialValues={{ modifier: "public" }}
        >
          <Row gutter={16}>
            <Col span={14}>
              <Form.Item
                name="periodo_pai"
                label="Período principal"
                // {...{ wrapperCol: { span: 9, offset: 2 } }}
              >
                <RangePicker
                  placeholder={["check-in", "check-out"]}
                  format={dateFormat}
                  size={"large"}
                  onChange={onRangeChangePeriodoPrincipal}
                  defaultValue={[
                    dayjs(checkInPeriodo.current, dateFormat),
                    dayjs(checkOutPeriodo.current, dateFormat),
                  ]}
                  disabled={[true, true]}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="valorMinPrincipal"
                label="Valor"
                rules={[
                  { required: true, message: "Por favor insira um valor!" },
                ]}
              >
                <Input size="large" />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="valorSugerido" label="Sugestão">
                {valorSugeridoSistema.current}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={14}>
              <Form.Item
                name="periodo1"
                label="Primeiro período"
                // {...{ wrapperCol: { span: 9, offset: 2 } }}
              >
                <RangePicker
                  placeholder={["check-in", "check-out"]}
                  format={dateFormat}
                  size={"large"}
                  onChange={onRangeChangePrimeiroPeriodo}
                  defaultValue={[
                    dayjs(checkInPeriodo.current, dateFormat),
                    dayjs(sugestaoCheckOut, dateFormat),
                  ]}
                  disabled={[true, true]}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="valorMin1"
                label="Valor"
                rules={[
                  { required: true, message: "Por favor insira um valor!" },
                ]}
              >
                <Input size="large" />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="valorSugerido" label="Sugestão">
                {valorSugeridoSistema1Fracao.current}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={14}>
              <Form.Item
                name="periodo2"
                label="Segundo período"
                // {...{ wrapperCol: { span: 9, offset: 2 } }}
              >
                <RangePicker
                  placeholder={["check-in", "check-out"]}
                  format={dateFormat}
                  size={"large"}
                  onChange={onRangeChangeSegundoPeriodo}
                  defaultValue={[
                    dayjs(sugestaoCheckOut, dateFormat),
                    dayjs(checkOutPeriodo.current, dateFormat),
                  ]}
                  disabled={[true, true]}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="valorMin2"
                label="Valor"
                rules={[
                  { required: true, message: "Por favor insira um valor!" },
                ]}
              >
                <Input size="large" />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="valorSugerido" label="Sugestão">
                {valorSugeridoSistema2Fracao.current}
              </Form.Item>
            </Col>
          </Row>
          <Radio.Group onChange={onChangeStatus} value={valueStatus}>
            <Radio
              disabled={statusAtual.current === "NAO_PERTUBE" ? true : false}
              value={"AGUARDANDO_SUGESTAO"}
            >
              {statusAtual.current === "DELEGADO" ? "Delegado" : "Sugestão"}
            </Radio>
            <Radio value={"AGUARDANDO_PEDIDO"}>A Pedido</Radio>
          </Radio.Group>
        </Form>
      </Modal>
    );
  };
  const CollectionCreateFormMaisPeriodo: React.FC<
    CollectionCreateFormPropsMaisPeriodo
  > = ({ open, onCreate, onCancel }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={openMaisPeriodo}
        title="Adicionar período"
        okText="Adicionar"
        cancelText="Cancelar"
        onCancel={onCancel}
        width={300}
        onOk={() => {
          form
            .validateFields()
            .then((valuesMaisPeriodo) => {
              form.resetFields();
              onCreate(valuesMaisPeriodo);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          // name="form_in_modal"
          // initialValues={{ modifier: "public" }}
        >
          <Form.Item
            name="periodo"
            label="Período"
            // {...{ wrapperCol: { span: 9, offset: 2 } }}
          >
            <RangePicker
              placeholder={["check-in", "check-out"]}
              format={dateFormat}
              size={"large"}
              onChange={onRangeChangeMaisPeriodo}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: "group"
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }

  const success = (texto: string) => {
    messageApi.open({
      type: "success",
      content: texto,
    });
  };
  const warning = (texto: string) => {
    messageApi.open({
      type: "warning",
      content: texto,
    });
  };
  const error = (texto: string) => {
    messageApi.open({
      type: "error",
      content: texto,
    });
  };
  const errorLongaDuracao = (texto: string) => {
    messageApi.open({
      type: "error",
      content: texto,
      duration: 8,
    });
  };

  const atualizarSituacao = async (
    situacaoPeriodo: number,
    periodoUsuarioId: number
  ) => {
    //1 já utilizei ou reservei em parte
    //utilizado
    //reservado pelo próprio
    let formData;
    let resultadoAtualizacao;
    switch (situacaoPeriodo) {
      case 1:
        //utilizei ou reservei em parte
        formData = {
          status: "FRACAO_FINALIZADA",
          caso: 2,
          dataSugestao: null,
          periodoUsuario: periodoUsuarioId,
        };
        resultadoAtualizacao = atualizarPeriodoUsuario(formData);

        break;
      case 2:
        //utilizado
        formData = {
          alugar: 0,
          trocar: 0,
          concluido: 0,
          alterado: 0,
          utilizar: 1,
          status: "FINALIZADO",
          caso: 2,
          dataSugestao: null,
          periodoUsuario: periodoUsuarioId,
        };
        resultadoAtualizacao = atualizarPeriodoUsuario(formData);
        break;
      case 3:
        //reservado pelo próprio
        if (valorSugeridoFracao.current === "") {
          formData = {
            alugar: 0,
            trocar: 0,
            concluido: 1,
            utilizar: 0,
            status: "FINALIZADO",
            alterado: 0,

            caso: 2,

            periodoUsuario: periodoUsuarioId,
          };
        } else {
          formData = {
            alugar: 0,
            trocar: 0,
            concluido: 1,
            utilizar: 0,
            status: "FINALIZADO",
            alterado: 0,
            valorMin: valorSugeridoFracao.current,
            caso: 2,
            dataSugestao: null,
            periodoUsuario: periodoUsuarioId,
          };
        }

        resultadoAtualizacao = atualizarPeriodoUsuario(formData);
        break;
      case 4:
        //troca
        formData = {
          alugar: 0,
          trocar: 1,
          concluido: 0,
          utilizar: 0,
          status: "SEM_STATUS",
          alterado: 0,

          caso: 2,

          periodoUsuario: periodoUsuarioId,
        };
        resultadoAtualizacao = atualizarPeriodoUsuario(formData);
        break;
    }
    if (resultadoAtualizacao) {
      return resultadoAtualizacao;
    } else {
      error("Erro ao atualizar período 2.");
      return 2;
    }
  };

  const confirmarPeriodo = async (
    periodoUsuarioId: number,
    valorSugerido: string,
    tipo: string
  ) => {
    //tipos: delegado, confirmado, rejeitado
    let formData = {};
    let result;

    if (tipo === "delegado") {
      if (dataSugestao.current === "" || dataSugestao.current === null) {
        formData = {
          valorMin: formatarMoeda(valorSugerido),
          status: "DELEGADO",
          periodoUsuario: periodoUsuarioId,
          caso: 2,
          alterado: 0,
        };
      } else {
        const checkIn = checkInPeriodo.current;

        let fase = definirFasePeriodoUsuario({
          confirmando: true,
          checkIn,
        });
        let novaFase;

        switch (await fase) {
          case "FASE0":
            novaFase = "FASE0";
            break;
          case "FASE1":
            novaFase = "FASE1";
            break;
          case "FASE2":
            novaFase = "FASE2";
            break;
          case "FASE3":
            novaFase = "FASE3";
            break;
          case "FASE4":
            novaFase = "FASE4";
            break;
          case "FASE5":
            novaFase = "FASE5";
            break;
        }

        if (await fase) {
          formData = {
            valorMin: formatarMoeda(valorSugerido),
            status: "DELEGADO",
            periodoUsuario: periodoUsuarioId,
            caso: 2,
            fase: novaFase,
            dataSugestao: null,
            alterado: 0,
          };
        } else {
          console.log("Algo deu errado.");
        }
      }

      result = atualizarPeriodoUsuario(formData);
      if (await result) {
        return result;
      } else {
        error("Não foi possível atualizar período.");
      }
    } else {
      if (tipo === "confirmado") {
        if (dataSugestao.current === "" || dataSugestao.current === null) {
          formData = {
            valorMin: formatarMoeda(valorSugerido),
            status:
              statusAnterior.current === "NAO_PERTUBE"
                ? "NAO_PERTUBE"
                : "SEM_STATUS",
            periodoUsuario: periodoUsuarioId,
            caso: 3,
            alterado: 0,
          };
        } else {
          const checkIn = checkInPeriodo.current;

          let fase = definirFasePeriodoUsuario({
            confirmando: true,
            checkIn,
          });
          let novaFase;

          switch (await fase) {
            case "FASE0":
              novaFase = "FASE0";
              break;
            case "FASE1":
              novaFase = "FASE1";
              break;
            case "FASE2":
              novaFase = "FASE2";
              break;
            case "FASE3":
              novaFase = "FASE3";
              break;
            case "FASE4":
              novaFase = "FASE4";
              break;
            case "FASE5":
              novaFase = "FASE5";
              break;
          }

          if (await fase) {
            formData = {
              valorMin: formatarMoeda(valorSugerido),
              status:
                statusAnterior.current === "NAO_PERTUBE"
                  ? "NAO_PERTUBE"
                  : "SEM_STATUS",
              periodoUsuario: periodoUsuarioId,
              caso: 3,
              fase: novaFase,
              dataSugestao: null,
              alterado: 0,
            };
          } else {
            console.log("Algo deu errado.");
          }
        }
      } else {
        if (tipo === "rejeitado") {
          if (dataSugestao.current === "" || dataSugestao.current === null) {
            formData = {
              status: "SEM_STATUS",
              periodoUsuario: periodoUsuarioId,
              caso: 3,
              alterado: 0,
            };
          } else {
            const checkIn = checkInPeriodo.current;

            let fase = definirFasePeriodoUsuario({
              confirmando: true,
              checkIn,
            });
            let novaFase;

            switch (await fase) {
              case "FASE0":
                novaFase = "FASE0";
                break;
              case "FASE1":
                novaFase = "FASE1";
                break;
              case "FASE2":
                novaFase = "FASE2";
                break;
              case "FASE3":
                novaFase = "FASE3";
                break;
              case "FASE4":
                novaFase = "FASE4";
                break;
              case "FASE5":
                novaFase = "FASE5";
                break;
            }

            if (await fase) {
              formData = {
                status: "SEM_STATUS",
                periodoUsuario: periodoUsuarioId,
                caso: 3,
                fase: novaFase,
                dataSugestao: null,
                alterado: 0,
              };
            } else {
              console.log("Algo deu errado.");
            }
          }
        } else {
          if (tipo === "naoPertube") {
            if (dataSugestao.current === "" || dataSugestao.current === null) {
              if (alterando.current) {
                formData = {
                  status: "NAO_PERTUBE",
                  periodoUsuario: periodoUsuarioId,
                  caso: 3,
                  alterado: 0,
                  valorMin: formatarMoeda(valorSugerido),
                };
              } else {
                formData = {
                  status: "NAO_PERTUBE",
                  periodoUsuario: periodoUsuarioId,
                  caso: 3,
                  alterado: 0,
                };
              }
            } else {
              const checkIn = checkInPeriodo.current;

              let fase = definirFasePeriodoUsuario({
                confirmando: true,
                checkIn,
              });
              let novaFase;

              switch (await fase) {
                case "FASE0":
                  novaFase = "FASE0";
                  break;
                case "FASE1":
                  novaFase = "FASE1";
                  break;
                case "FASE2":
                  novaFase = "FASE2";
                  break;
                case "FASE3":
                  novaFase = "FASE3";
                  break;
                case "FASE4":
                  novaFase = "FASE4";
                  break;
                case "FASE5":
                  novaFase = "FASE5";
                  break;
              }

              if (await fase) {
                formData = {
                  status: "NAO_PERTUBE",
                  periodoUsuario: periodoUsuarioId,
                  caso: 3,
                  fase: novaFase,
                  dataSugestao: null,
                  alterado: 0,
                };
              } else {
                console.log("Algo deu errado.");
              }
            }
          } else {
            error("Não foi possível definir o tipo de operação.");
          }
        }
      }
    }

    result = atualizarPeriodoUsuario(formData);
    if (result) {
      return result;
    } else {
      error("Erro ao atualizar período 3.");
    }
  };
  const atualizarValorAluguel = async (periodoUsuarioId: any, tipo: number) => {
    setOpenValor(false);
    const Token = validateToken();
    let situacaoAnterior;
    switch (situacao.current) {
      case "Alugar":
        situacaoAnterior = "ALUGAR";
        break;
      case "Alugar ou trocar":
        situacaoAnterior = "ALUGAR_TROCAR";
        break;
      case "Trocar":
        situacaoAnterior = "TROCAR";
        break;
      case "Não definido":
        situacaoAnterior = "NAO_DEFINIDO";
        break;
      case "Reservado pelo próprio":
        situacaoAnterior = "CONCLUIDO_PELO_PROPRIO";
        break;
      case "Será utilizado":
        situacaoAnterior = "UTILIZADO";
        break;
    }

    const valorSugerido = valor.current;
    if (tipo === 1) {
      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
        let formData = {};
        if (valueStatus === "AGUARDANDO_SUGESTAO") {
          if (statusAtual.current === "DELEGADO") {
            formData = {
              alugar: 1,
              trocar: 0,
              concluido: 0,
              utilizar: 0,

              valorMin: valorSugerido,
            };
          } else {
            if (statusAtual.current === "Não pertube") {
              console.log("Não pertube");
            } else {
              formData = {
                alugar: 1,
                trocar: 0,
                concluido: 0,
                utilizar: 0,
                statusAnterior:
                  statusAtual.current === "alterado"
                    ? "SEM_STATUS"
                    : statusAtual.current,
                dataSugestao: AlterarFormatoData(
                  new Date().toLocaleDateString()
                ),
                valorSugerido: valorSugerido,
                status: valueStatus,
                situacaoAnterior: situacaoAnterior,
              };
            }
          }
        } else {
          if (valueStatus === "AGUARDANDO_PEDIDO") {
            formData = {
              alugar: 1,
              trocar: 0,
              concluido: 0,
              utilizar: 0,
              statusAnterior:
                statusAtual.current === "alterado"
                  ? "SEM_STATUS"
                  : statusAtual.current,

              valorSugerido: valorSugerido,
              status: valueStatus,
              situacaoAnterior: situacaoAnterior,
            };
          }
        }

        ////

        try {
          const response = await axios.put(URL, formData, {
            headers: { Authorization: Token.AuthStr },
          });
          if (response) {
            return true;
          } else {
            error("Algo deu errado!");
          }
        } catch (error) {
          error("Algo deu errado!");
        }
      } else {
        document.location.href = "/";
      }
    } else {
      if (tipo === 2) {
        if (Token) {
          const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
          let formData = {};
          if (valueStatus === "AGUARDANDO_SUGESTAO") {
            if (statusAtual.current === "DELEGADO") {
              formData = {
                alugar: 1,
                trocar: 1,
                concluido: 0,
                utilizar: 0,

                valorMin: valorSugerido,
              };
            } else {
              formData = {
                alugar: 1,
                trocar: 1,
                concluido: 0,
                utilizar: 0,
                statusAnterior:
                  statusAtual.current === "alterado"
                    ? "SEM_STATUS"
                    : statusAtual.current,
                dataSugestao: AlterarFormatoData(
                  new Date().toLocaleDateString()
                ),
                valorSugerido: valorSugerido,
                status: valueStatus,
                situacaoAnterior: situacaoAnterior,
              };
            }

            ////
          } else {
            if (valueStatus === "AGUARDANDO_PEDIDO") {
              formData = {
                alugar: 1,
                trocar: 1,
                concluido: 0,
                utilizar: 0,
                statusAnterior:
                  statusAtual.current === "alterado"
                    ? "SEM_STATUS"
                    : statusAtual.current,

                valorSugerido: valorSugerido,
                status: valueStatus,
                situacaoAnterior: situacaoAnterior,
              };
              ////
            }
          }

          try {
            const response = await axios.put(URL, formData, {
              headers: { Authorization: Token.AuthStr },
            });
            if (response) {
              return true;
            } else {
              error("Algo deu errado!");
            }
          } catch (error) {
            error("Algo deu errado!");
          }
        } else {
          document.location.href = "/";
        }
      }
    }
  };

  const onClick: MenuProps["onClick"] = async ({ key }) => {
    const Token = validateToken();

    // const situacao = active.current;
    const periodoUsuarioId = periodoUsuario.current;
    const periodoId = periodo.current;
    const situacaoAtual = situacao.current;
    const divulgadoAtual = divulgado.current;
    if (
      periodoUsuarioId === 0 &&
      selectedRowKeys.length === 0 &&
      emLote.current === 1
    ) {
      error("Selecione um item!");
    } else {
      switch (key) {
        case "2":
          //alugar
          setTitleFracaoCompleta(false);

          let antigo2 = validateDataCheckOutMaior(
            checkOutPeriodo.current,
            hoje
          );

          valorSugeridoSistema1Fracao.current = "";
          valorSugeridoSistema2Fracao.current = "";

          if (antigo2) {
            error("Esse período já passou!");
          } else {
            if (situacaoAtual === "Reservado por MC") {
              error(
                "Esse período já foi reservado pela Multicotas. Não pode ser alterado."
              );
            } else {
              if (situacaoAtual === "Alugado ou utilizado parcialmente") {
                error(
                  "Esse período tem alguma fração que não está mais disponível e por isso não pode ser alterado."
                );
              } else {
                if (situacaoAtual === "Períodos fracionados reservados") {
                  error(
                    "Esse período tem frações reservadas e por isso não pode ser alterado."
                  );
                } else {
                  if (statusAtual.current === "ALTERANDO") {
                    errorLongaDuracao("Favor confirmar as alterações antes. ");
                  } else {
                    alugarOuTrocar.current = 1;
                    if (nCotaUsuarioId.cotaUsuarioId === 0) {
                      Aluguel.filter(async (p: any) => {
                        if ((await p.id) === periodoUsuario.current) {
                          if (await p.children) {
                            atualizando.current = true;
                          }

                          let dias = retornaDiaDaSemana(checkInPeriodo.current);

                          let checkOutNovo;

                          switch (dias) {
                            case 0:
                              checkOutNovo = adicionarDiasData(
                                checkInPeriodo.current,
                                4
                              );
                              setSugestaoCheckOut(checkOutNovo);

                              if (valorSugeridoSistema.current) {
                                valorSugeridoSistema1Fracao.current =
                                  await retornarValorAtualizado(
                                    valorSugeridoSistema.current,
                                    checkInPeriodo.current,
                                    checkOutNovo,
                                    3
                                  );
                                valorSugeridoSistema2Fracao.current =
                                  await retornarValorAtualizado(
                                    valorSugeridoSistema.current,
                                    checkOutNovo,
                                    checkOutPeriodo.current,
                                    3
                                  );
                              }

                              break;
                            case 4:
                            case 5:
                            case 6:
                              checkOutNovo = adicionarDiasData(
                                checkInPeriodo.current,
                                3
                              );
                              setSugestaoCheckOut(
                                adicionarDiasData(checkInPeriodo.current, 3)
                              );
                              if (valorSugeridoSistema.current) {
                                valorSugeridoSistema1Fracao.current =
                                  await retornarValorAtualizado(
                                    valorSugeridoSistema.current,
                                    checkInPeriodo.current,
                                    checkOutNovo,
                                    3
                                  );
                                valorSugeridoSistema2Fracao.current =
                                  await retornarValorAtualizado(
                                    valorSugeridoSistema.current,
                                    checkOutNovo,
                                    checkOutPeriodo.current,
                                    3
                                  );
                              }
                              break;
                          }

                          situacaoDesejada.current = "ALUGAR";

                          setOpenModalPerguntaFracaoCompleta(true);
                        } else {
                          if (p.children) {
                            p.children.filter((q: any) => {
                              if (q.id === periodoUsuario.current) {
                                AbrirModalValor();
                              }
                            });
                          }
                        }
                        // console.log("Não tem filho");
                      });
                    } else {
                      periodoData.filter(async (p: any) => {
                        if ((await p.id) === periodoUsuario.current) {
                          if (await p.children) {
                            atualizando.current = true;
                          }

                          let dias = retornaDiaDaSemana(checkInPeriodo.current);
                          let checkOutNovo;

                          switch (dias) {
                            case 0:
                              checkOutNovo = adicionarDiasData(
                                checkInPeriodo.current,
                                4
                              );
                              setSugestaoCheckOut(checkOutNovo);

                              if (valorSugeridoSistema.current) {
                                valorSugeridoSistema1Fracao.current =
                                  await retornarValorAtualizado(
                                    valorSugeridoSistema.current,
                                    checkInPeriodo.current,
                                    checkOutNovo,
                                    3
                                  );
                                valorSugeridoSistema2Fracao.current =
                                  await retornarValorAtualizado(
                                    valorSugeridoSistema.current,
                                    checkOutNovo,
                                    checkOutPeriodo.current,
                                    3
                                  );
                              }

                              break;
                            case 4:
                            case 5:
                            case 6:
                              checkOutNovo = adicionarDiasData(
                                checkInPeriodo.current,
                                3
                              );
                              setSugestaoCheckOut(
                                adicionarDiasData(checkInPeriodo.current, 3)
                              );
                              if (valorSugeridoSistema.current) {
                                valorSugeridoSistema1Fracao.current =
                                  await retornarValorAtualizado(
                                    valorSugeridoSistema.current,
                                    checkInPeriodo.current,
                                    checkOutNovo,
                                    3
                                  );
                                valorSugeridoSistema2Fracao.current =
                                  await retornarValorAtualizado(
                                    valorSugeridoSistema.current,
                                    checkOutNovo,
                                    checkOutPeriodo.current,
                                    3
                                  );
                              }
                              break;
                          }

                          situacaoDesejada.current = "ALUGAR";

                          setOpenModalPerguntaFracaoCompleta(true);
                        } else {
                          if (p.children) {
                            p.children.filter((q: any) => {
                              if (q.id === periodoUsuario.current) {
                                AbrirModalValor();
                              }
                            });
                          }
                        }
                      });
                    }
                  }
                }
              }
            }
          }

          break;
        case "3":
          //trocar

          let divulgando = verificarSeTemPeriodoDivulgado(
            periodoUsuario.current
          );

          if (periodoUsuarioId === 0 && emLote.current === 1) {
            error("Essa funcionalidade só pode ser feita um por um.");
            return;
          } else {
            //colocar na situação de trocar
            if (situacaoAtual === "Trocar") {
              error("A situação já está como trocar.");
              return;
            } else {
              if (situacaoAtual === "Reservado por MC") {
                error(
                  "Esse período já foi reservado pela Multicotas. Não pode ser alterado. Fale com administrador"
                );
                return;
              } else {
                if (await divulgando) {
                  error(
                    "Esse período ou algumas de suas frações, se houver, está sendo divulgado. Portanto, antes de alterar a situação retire o anúncio."
                  );
                  return;
                } else {
                  if (Token) {
                    const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
                    let formData = {
                      alugar: 0,
                      trocar: 1,
                      utilizar: 0,
                      concluido: 0,
                      divulgado: 0,
                      status: "SEM_STATUS",
                    };
                    ////

                    try {
                      const response = await axios.put(URL, formData, {
                        headers: { Authorization: Token.AuthStr },
                      });
                      if (response) {
                        success("Período atualizado com sucesso!");
                        setTimeout(() => {
                          document.location.reload();
                        }, 2000);
                      } else {
                        error("Algo deu errado!");
                        return;
                      }
                    } catch (error) {
                      error("Algo deu errado!");
                      return;
                    }
                  } else {
                    document.location.href = "/";
                  }
                }
              }
            }
          }

          break;

        case "4":
          //alugar ou trocar
          setTitleFracaoCompleta(false);

          let antigo4 = validateDataCheckOutMaior(
            checkOutPeriodo.current,
            hoje
          );

          valorSugeridoSistema1Fracao.current = "";
          valorSugeridoSistema2Fracao.current = "";

          if (antigo4) {
            error("Esse período já passou!");
            return;
          } else {
            if (situacaoAtual === "Reservado por MC") {
              error(
                "Esse período já foi reservado pela Multicotas. Não pode ser alterado."
              );
              return;
            } else {
              if (situacaoAtual === "Alugado ou utilizado parcialmente") {
                error(
                  "Esse período tem alguma fração que não está mais disponível e por isso não pode ser alterado."
                );
                return;
              } else {
                if (situacaoAtual === "Períodos fracionados reservados") {
                  error(
                    "Esse período tem frações reservadas e por isso não pode ser alterado."
                  );
                  return;
                } else {
                  if (statusAtual.current === "ALTERANDO") {
                    errorLongaDuracao("Favor confirmar as alterações antes. ");
                    return;
                  } else {
                    alugarOuTrocar.current = 2;
                    if (nCotaUsuarioId.cotaUsuarioId === 0) {
                      Aluguel.filter(async (p: any) => {
                        if ((await p.id) === periodoUsuario.current) {
                          if (await p.children) {
                            atualizando.current = true;
                          }

                          let dias = retornaDiaDaSemana(checkInPeriodo.current);
                          let checkOutNovo;

                          switch (dias) {
                            case 0:
                              checkOutNovo = adicionarDiasData(
                                checkInPeriodo.current,
                                4
                              );
                              setSugestaoCheckOut(checkOutNovo);

                              if (valorSugeridoSistema.current) {
                                valorSugeridoSistema1Fracao.current =
                                  await retornarValorAtualizado(
                                    valorSugeridoSistema.current,
                                    checkInPeriodo.current,
                                    checkOutNovo,
                                    3
                                  );
                                valorSugeridoSistema2Fracao.current =
                                  await retornarValorAtualizado(
                                    valorSugeridoSistema.current,
                                    checkOutNovo,
                                    checkOutPeriodo.current,
                                    3
                                  );
                              }

                              break;
                            case 4:
                            case 5:
                            case 6:
                              checkOutNovo = adicionarDiasData(
                                checkInPeriodo.current,
                                3
                              );
                              setSugestaoCheckOut(
                                adicionarDiasData(checkInPeriodo.current, 3)
                              );
                              if (valorSugeridoSistema.current) {
                                valorSugeridoSistema1Fracao.current =
                                  await retornarValorAtualizado(
                                    valorSugeridoSistema.current,
                                    checkInPeriodo.current,
                                    checkOutNovo,
                                    3
                                  );
                                valorSugeridoSistema2Fracao.current =
                                  await retornarValorAtualizado(
                                    valorSugeridoSistema.current,
                                    checkOutNovo,
                                    checkOutPeriodo.current,
                                    3
                                  );
                              }
                              break;
                          }
                          situacaoDesejada.current = "ALUGAR_TROCAR";
                          setOpenModalPerguntaFracaoCompleta(true);
                        } else {
                          if (p.children) {
                            await p.children.filter((q: any) => {
                              if (q.id === periodoUsuario.current) {
                                AbrirModalValor();
                              }
                            });
                          }
                        }
                      });
                    } else {
                      periodoData.filter(async (p: any) => {
                        if ((await p.id) === periodoUsuario.current) {
                          if (await p.children) {
                            atualizando.current = true;
                          }

                          let dias = retornaDiaDaSemana(checkInPeriodo.current);
                          let checkOutNovo;

                          switch (dias) {
                            case 0:
                              checkOutNovo = adicionarDiasData(
                                checkInPeriodo.current,
                                4
                              );
                              setSugestaoCheckOut(checkOutNovo);

                              if (valorSugeridoSistema.current) {
                                valorSugeridoSistema1Fracao.current =
                                  await retornarValorAtualizado(
                                    valorSugeridoSistema.current,
                                    checkInPeriodo.current,
                                    checkOutNovo,
                                    3
                                  );
                                valorSugeridoSistema2Fracao.current =
                                  await retornarValorAtualizado(
                                    valorSugeridoSistema.current,
                                    checkOutNovo,
                                    checkOutPeriodo.current,
                                    3
                                  );
                              }

                              break;
                            case 4:
                            case 5:
                            case 6:
                              checkOutNovo = adicionarDiasData(
                                checkInPeriodo.current,
                                3
                              );
                              setSugestaoCheckOut(
                                adicionarDiasData(checkInPeriodo.current, 3)
                              );
                              if (valorSugeridoSistema.current) {
                                valorSugeridoSistema1Fracao.current =
                                  await retornarValorAtualizado(
                                    valorSugeridoSistema.current,
                                    checkInPeriodo.current,
                                    checkOutNovo,
                                    3
                                  );
                                valorSugeridoSistema2Fracao.current =
                                  await retornarValorAtualizado(
                                    valorSugeridoSistema.current,
                                    checkOutNovo,
                                    checkOutPeriodo.current,
                                    3
                                  );
                              }
                              break;
                          }
                          situacaoDesejada.current = "ALUGAR_TROCAR";
                          setOpenModalPerguntaFracaoCompleta(true);
                        } else {
                          if (p.children) {
                            await p.children.filter((q: any) => {
                              if (q.id === periodoUsuario.current) {
                                AbrirModalValor();
                              }
                            });
                          }
                        }
                      });
                    }
                  }
                }
              }
            }
          }

          break;

        case "5":
          //será utilizado
          if (periodoUsuarioId === 0 && emLote.current === 1) {
            error("Essa funcionalidade só pode ser feita um por um.");
            return;
          } else {
            if (situacaoAtual === "Será utilizado") {
              error("A situação já está como 'Será utilizado'.");
              return;
            } else {
              if (situacaoAtual === "Reservado por MC") {
                error(
                  "Esse período já foi reservado pela Multicotas. Não pode ser alterado. Fale com administrador"
                );
                return;
              } else {
                if (divulgadoAtual === "Sim") {
                  error(
                    "Esse período está sendo divulgado antes de alterar a situação retire o anúncio."
                  );
                  return;
                } else {
                  if (Token) {
                    const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
                    let formData = {
                      alugar: 0,
                      trocar: 0,
                      utilizar: 1,
                      concluido: 0,
                      divulgado: 0,
                      status: "SEM_STATUS",
                    };
                    ////

                    try {
                      const response = await axios.put(URL, formData, {
                        headers: { Authorization: Token.AuthStr },
                      });
                      if (response) {
                        success("Período atualizado com sucesso!");
                        setTimeout(() => {
                          document.location.reload();
                        }, 2000);
                      } else {
                        error("Algo deu errado!");
                        return;
                      }
                    } catch (error) {
                      error("Algo deu errado!");
                      return;
                    }
                  } else {
                    document.location.href = "/";
                  }
                }
              }
            }
          }

          break;
        case "6":
          //Reservado pelo próprio
          if (periodoUsuarioId === 0 && emLote.current === 1) {
            error("Essa funcionalidade só pode ser feita um por um.");
            return;
          } else {
            if (situacaoAtual === "Reservado pelo próprio") {
              error("A situação já está como 'Reservado pelo próprio'.");
              return;
            } else {
              if (situacaoAtual === "Reservado por MC") {
                error(
                  "Esse período já foi reservado pela Multicotas. Não pode ser alterado. Fale com administrador"
                );
                return;
              } else {
                if (divulgadoAtual === "Sim") {
                  error(
                    "Esse período está sendo divulgado antes de alterar a situação retire o anúncio."
                  );
                  return;
                } else {
                  if (Token) {
                    const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
                    let formData = {
                      alugar: 0,
                      trocar: 0,
                      utilizar: 0,
                      concluido: 1,
                      divulgado: 0,
                      status: "SEM_STATUS",
                    };
                    ////

                    try {
                      const response = await axios.put(URL, formData, {
                        headers: { Authorization: Token.AuthStr },
                      });
                      if (response) {
                        success("Período atualizado com sucesso!");
                        setTimeout(() => {
                          document.location.reload();
                        }, 2000);
                      } else {
                        error("Algo deu errado!");
                        return;
                      }
                    } catch (error) {
                      error("Algo deu errado!");
                      return;
                    }
                  } else {
                    document.location.href = "/";
                  }
                }
              }
            }
          }

          break;
        case "7":
          //Reservado por MC
          if (periodoUsuarioId === 0 && emLote.current === 1) {
            error("Essa funcionalidade só pode ser feita um por um.");
            return;
          } else {
            if (situacaoAtual === "Reservado por MC") {
              error("A situação já está como 'Reservado por MC'.");
              return;
            } else {
              {
                if (Token) {
                  const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
                  let formData = {
                    alugar: 0,
                    trocar: 0,
                    utilizar: 0,
                    concluido: 2,
                    divulgado: 0,
                    status: "FINALIZADO",
                  };
                  ////

                  try {
                    const response = await axios.put(URL, formData, {
                      headers: { Authorization: Token.AuthStr },
                    });
                    if (response) {
                      success("Período atualizado com sucesso!");
                      setTimeout(() => {
                        verificarReserva(periodoUsuarioId);
                      }, 3000);
                    } else {
                      error("Algo deu errado!");
                      return;
                    }
                  } catch (error) {
                    error("Algo deu errado!");
                    return;
                  }
                } else {
                  document.location.href = "/";
                }
              }
            }
          }

          break;
        case "8":
          //não divulgado
          if (periodoUsuarioId === 0 && emLote.current === 1) {
            // error("Essa funcionalidade só pode ser feita um por um.");
            let formData = {
              divulgado: 0,
            };
            if (Token) {
              for (let i = 0; i < selectedRowKeys.length; i++) {
                const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${selectedRowKeys[i]}`;

                try {
                  const response = await axios.put(URL, formData, {
                    headers: { Authorization: Token.AuthStr },
                  });
                  if (response) {
                    if (i === selectedRowKeys.length - 1) {
                      success("Períodos atualizados com sucesso!");
                      setTimeout(() => {
                        document.location.reload();
                      }, 2000);
                    }
                  } else {
                    error("Algo deu errado!");
                    return;
                  }
                } catch (error) {
                  error("Algo deu errado!");
                  return;
                }
              }
            }
          } else {
            if (divulgadoAtual === "Não") {
              error("Esse período não está sendo divulgado mesmo.");
              return;
            } else {
              if (Token) {
                const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
                let formData = {
                  divulgado: 0,
                };
                ////

                try {
                  const response = await axios.put(URL, formData, {
                    headers: { Authorization: Token.AuthStr },
                  });
                  if (response) {
                    warning(
                      "Feito. Não esqueça de retirar o anúncio do período!"
                    );

                    setTimeout(() => {
                      document.location.reload();
                    }, 2000);
                  } else {
                    error("Algo deu errado!");
                    return;
                  }
                } catch (error) {
                  error("Algo deu errado!");
                  return;
                }
              } else {
                document.location.href = "/";
              }
            }
          }

          break;
        case "9":
          //dilvulgado
          if (periodoUsuarioId === 0 && emLote.current === 1) {
            // error("Essa funcionalidade só pode ser feita um por um.");
            let formData = {
              divulgado: 1,
            };
            if (Token) {
              for (let i = 0; i < selectedRowKeys.length; i++) {
                const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${selectedRowKeys[i]}`;

                try {
                  const response = await axios.put(URL, formData, {
                    headers: { Authorization: Token.AuthStr },
                  });
                  if (response) {
                    if (i === selectedRowKeys.length - 1) {
                      success("Períodos atualizados com sucesso!");
                      setTimeout(() => {
                        document.location.reload();
                      }, 2000);
                    }
                  } else {
                    error("Algo deu errado!");
                  }
                } catch (error) {
                  error("Algo deu errado!");
                }
              }
            }
          } else {
            if (situacaoAtual === "Reservado por MC") {
              error(
                "Esse período já foi reservado pela Multicotas. Não pode ser alterado. Fale com administrador"
              );
              return;
            } else {
              if (divulgadoAtual === "Sim") {
                error("Esse período já está sendo divulgado.");
                return;
              } else {
                if (
                  situacaoAtual === "Alugar" ||
                  situacaoAtual === "Alugar ou trocar"
                ) {
                  if (Token) {
                    const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
                    let formData = {
                      divulgado: 1,
                    };
                    ////

                    try {
                      const response = await axios.put(URL, formData, {
                        headers: { Authorization: Token.AuthStr },
                      });
                      if (response) {
                        success("Período atualizado com sucesso!");
                        setTimeout(() => {
                          document.location.reload();
                        }, 2000);
                      } else {
                        error("Algo deu errado!");
                      }
                    } catch (error) {
                      error("Algo deu errado!");
                    }
                  } else {
                    document.location.href = "/";
                  }
                } else {
                  error(
                    "Somente poderá ser dilvulgado os períodos que estão em situação 'Alugar' ou 'Alugar ou trocar'."
                  );
                }
              }
            }
          }
          break;
        case "10":
          //excluir
          if (periodoUsuarioId === 0 && emLote.current === 1) {
            error("Essa funcionalidade só pode ser feita um por um.");
            return;
          } else {
            if (situacaoAtual === "Reservado por MC") {
              error(
                "Esse período já foi reservado pela Multicotas. Não pode ser alterado. Fale com administrador"
              );
              return;
            } else {
              if (divulgadoAtual === "Sim") {
                error(
                  "Antes de excluir esse período deve-se retirá-lo da divulgação."
                );
                return;
              } else {
                showModal();
              }
            }
          }

          break;
        case "11":
          if (nUserId.userId) {
            userId.current = +nUserId.userId;
            setOpen(true);
          }
          break;
        case "12":
          //alterar valor

          let antigo12 = validateDataCheckOutMaior(
            checkOutPeriodo.current,
            hoje
          );

          valorSugeridoSistema1Fracao.current = "";
          valorSugeridoSistema2Fracao.current = "";

          if (antigo12) {
            error("Esse período já passou!");
          } else {
            if (situacaoAtual === "Reservado por MC") {
              error(
                "Esse período já foi reservado pela Multicotas. Não pode ser alterado."
              );
            } else {
              if (situacaoAtual === "Alugado ou utilizado parcialmente") {
                error(
                  "Esse período tem alguma fração que não está mais disponível e por isso não pode ser alterado."
                );
              } else {
                if (situacaoAtual === "Períodos fracionados reservados") {
                  error(
                    "Esse período tem frações reservadas e por isso não pode ser alterado."
                  );
                } else {
                  if (divulgadoAtual === "Sim") {
                    warning(
                      "Esse período está sendo divulgado. Não esqueça de alterar o valor nas plataformas."
                    );
                  }
                  if (
                    !(
                      situacaoAtual === "Alugar" ||
                      situacaoAtual === "Alugar ou trocar"
                    )
                  ) {
                    error(
                      "Só é possivel alterar o valor de períodos que estejam com a situação 'Alugar' ou 'Alugar ou trocar'"
                    );
                  } else {
                    atualizando.current = true;
                    if (nCotaUsuarioId.cotaUsuarioId === 0) {
                      Aluguel.filter(async (p: any) => {
                        if (p.id === periodoUsuario.current) {
                          if (p.children) {
                            if (situacaoAtual === "Alugar") {
                              alugarOuTrocar.current = 1;
                              let dias = retornaDiaDaSemana(
                                checkInPeriodo.current
                              );

                              let checkOutNovo;

                              switch (dias) {
                                case 0:
                                  checkOutNovo = adicionarDiasData(
                                    checkInPeriodo.current,
                                    4
                                  );
                                  setSugestaoCheckOut(checkOutNovo);

                                  if (valorSugeridoSistema.current) {
                                    valorSugeridoSistema1Fracao.current =
                                      await retornarValorAtualizado(
                                        valorSugeridoSistema.current,
                                        checkInPeriodo.current,
                                        checkOutNovo,
                                        3
                                      );
                                    valorSugeridoSistema2Fracao.current =
                                      await retornarValorAtualizado(
                                        valorSugeridoSistema.current,
                                        checkOutNovo,
                                        checkOutPeriodo.current,
                                        3
                                      );
                                  }

                                  break;
                                case 4:
                                case 5:
                                case 6:
                                  checkOutNovo = adicionarDiasData(
                                    checkInPeriodo.current,
                                    3
                                  );
                                  setSugestaoCheckOut(
                                    adicionarDiasData(checkInPeriodo.current, 3)
                                  );
                                  if (valorSugeridoSistema.current) {
                                    valorSugeridoSistema1Fracao.current =
                                      await retornarValorAtualizado(
                                        valorSugeridoSistema.current,
                                        checkInPeriodo.current,
                                        checkOutNovo,
                                        3
                                      );
                                    valorSugeridoSistema2Fracao.current =
                                      await retornarValorAtualizado(
                                        valorSugeridoSistema.current,
                                        checkOutNovo,
                                        checkOutPeriodo.current,
                                        3
                                      );
                                  }
                                  break;
                              }
                              // setOpenValor(true);
                              setOpenModalPerguntaFracaoCompleta(true);
                            } else {
                              if (situacaoAtual === "Alugar ou trocar") {
                                alugarOuTrocar.current = 2;
                                let dias = retornaDiaDaSemana(
                                  checkInPeriodo.current
                                );

                                let checkOutNovo;

                                switch (dias) {
                                  case 0:
                                    checkOutNovo = adicionarDiasData(
                                      checkInPeriodo.current,
                                      4
                                    );
                                    setSugestaoCheckOut(checkOutNovo);

                                    if (valorSugeridoSistema.current) {
                                      valorSugeridoSistema1Fracao.current =
                                        await retornarValorAtualizado(
                                          valorSugeridoSistema.current,
                                          checkInPeriodo.current,
                                          checkOutNovo,
                                          3
                                        );
                                      valorSugeridoSistema2Fracao.current =
                                        await retornarValorAtualizado(
                                          valorSugeridoSistema.current,
                                          checkOutNovo,
                                          checkOutPeriodo.current,
                                          3
                                        );
                                    }

                                    break;
                                  case 4:
                                  case 5:
                                  case 6:
                                    checkOutNovo = adicionarDiasData(
                                      checkInPeriodo.current,
                                      3
                                    );
                                    setSugestaoCheckOut(
                                      adicionarDiasData(
                                        checkInPeriodo.current,
                                        3
                                      )
                                    );
                                    if (valorSugeridoSistema.current) {
                                      valorSugeridoSistema1Fracao.current =
                                        await retornarValorAtualizado(
                                          valorSugeridoSistema.current,
                                          checkInPeriodo.current,
                                          checkOutNovo,
                                          3
                                        );
                                      valorSugeridoSistema2Fracao.current =
                                        await retornarValorAtualizado(
                                          valorSugeridoSistema.current,
                                          checkOutNovo,
                                          checkOutPeriodo.current,
                                          3
                                        );
                                    }
                                    break;
                                }
                                // setOpenValor(true);
                                setOpenModalPerguntaFracaoCompleta(true);
                              } else {
                                if (situacaoAtual !== undefined) {
                                  error(
                                    "Mude a situação para 'alugar' ou 'alugar ou trocar' para inserir o valor."
                                  );
                                }
                              }
                            }
                          } else {
                            if (situacao.current === "Alugar") {
                              alugarOuTrocar.current = 1;
                            } else {
                              if (situacao.current === "Alugar ou trocar") {
                                alugarOuTrocar.current = 2;
                              }
                            }

                            AbrirModalValor();
                          }
                        } else {
                          if (p.children) {
                            p.children.filter((q: any) => {
                              if (q.id === periodoUsuario.current) {
                                if (situacao.current === "Alugar") {
                                  alugarOuTrocar.current = 1;
                                } else {
                                  if (situacao.current === "Alugar ou trocar") {
                                    alugarOuTrocar.current = 2;
                                  }
                                }
                                AbrirModalValor();
                              }
                            });
                          }
                          // console.log(p);
                        }
                      });
                    } else {
                      periodoData.filter(async (p: any) => {
                        if (p.id === periodoUsuario.current) {
                          if (p.children) {
                            if (situacaoAtual === "Alugar") {
                              alugarOuTrocar.current = 1;
                              let dias = retornaDiaDaSemana(
                                checkInPeriodo.current
                              );

                              let checkOutNovo;

                              switch (dias) {
                                case 0:
                                  checkOutNovo = adicionarDiasData(
                                    checkInPeriodo.current,
                                    4
                                  );
                                  setSugestaoCheckOut(checkOutNovo);

                                  if (valorSugeridoSistema.current) {
                                    valorSugeridoSistema1Fracao.current =
                                      await retornarValorAtualizado(
                                        valorSugeridoSistema.current,
                                        checkInPeriodo.current,
                                        checkOutNovo,
                                        3
                                      );
                                    valorSugeridoSistema2Fracao.current =
                                      await retornarValorAtualizado(
                                        valorSugeridoSistema.current,
                                        checkOutNovo,
                                        checkOutPeriodo.current,
                                        3
                                      );
                                  }

                                  break;
                                case 4:
                                case 5:
                                case 6:
                                  checkOutNovo = adicionarDiasData(
                                    checkInPeriodo.current,
                                    3
                                  );
                                  setSugestaoCheckOut(
                                    adicionarDiasData(checkInPeriodo.current, 3)
                                  );
                                  if (valorSugeridoSistema.current) {
                                    valorSugeridoSistema1Fracao.current =
                                      await retornarValorAtualizado(
                                        valorSugeridoSistema.current,
                                        checkInPeriodo.current,
                                        checkOutNovo,
                                        3
                                      );
                                    valorSugeridoSistema2Fracao.current =
                                      await retornarValorAtualizado(
                                        valorSugeridoSistema.current,
                                        checkOutNovo,
                                        checkOutPeriodo.current,
                                        3
                                      );
                                  }
                                  break;
                              }
                              // setOpenValor(true);
                              setOpenModalPerguntaFracaoCompleta(true);
                            } else {
                              if (situacaoAtual === "Alugar ou trocar") {
                                alugarOuTrocar.current = 2;
                                let dias = retornaDiaDaSemana(
                                  checkInPeriodo.current
                                );

                                let checkOutNovo;

                                switch (dias) {
                                  case 0:
                                    checkOutNovo = adicionarDiasData(
                                      checkInPeriodo.current,
                                      4
                                    );
                                    setSugestaoCheckOut(checkOutNovo);

                                    if (valorSugeridoSistema.current) {
                                      valorSugeridoSistema1Fracao.current =
                                        await retornarValorAtualizado(
                                          valorSugeridoSistema.current,
                                          checkInPeriodo.current,
                                          checkOutNovo,
                                          3
                                        );
                                      valorSugeridoSistema2Fracao.current =
                                        await retornarValorAtualizado(
                                          valorSugeridoSistema.current,
                                          checkOutNovo,
                                          checkOutPeriodo.current,
                                          3
                                        );
                                    }

                                    break;
                                  case 4:
                                  case 5:
                                  case 6:
                                    checkOutNovo = adicionarDiasData(
                                      checkInPeriodo.current,
                                      3
                                    );
                                    setSugestaoCheckOut(
                                      adicionarDiasData(
                                        checkInPeriodo.current,
                                        3
                                      )
                                    );
                                    if (valorSugeridoSistema.current) {
                                      valorSugeridoSistema1Fracao.current =
                                        await retornarValorAtualizado(
                                          valorSugeridoSistema.current,
                                          checkInPeriodo.current,
                                          checkOutNovo,
                                          3
                                        );
                                      valorSugeridoSistema2Fracao.current =
                                        await retornarValorAtualizado(
                                          valorSugeridoSistema.current,
                                          checkOutNovo,
                                          checkOutPeriodo.current,
                                          3
                                        );
                                    }
                                    break;
                                }
                                // setOpenValor(true);
                                setOpenModalPerguntaFracaoCompleta(true);
                              } else {
                                if (situacaoAtual !== undefined) {
                                  error(
                                    "Mude a situação para 'alugar' ou 'alugar ou trocar' para inserir o valor."
                                  );
                                }
                              }
                            }
                          } else {
                            if (situacao.current === "Alugar") {
                              alugarOuTrocar.current = 1;
                            } else {
                              if (situacao.current === "Alugar ou trocar") {
                                alugarOuTrocar.current = 2;
                              }
                            }

                            AbrirModalValor();
                          }
                        } else {
                          if (p.children) {
                            p.children.filter((q: any) => {
                              if (q.id === periodoUsuario.current) {
                                if (situacao.current === "Alugar") {
                                  alugarOuTrocar.current = 1;
                                } else {
                                  if (situacao.current === "Alugar ou trocar") {
                                    alugarOuTrocar.current = 2;
                                  }
                                }
                                AbrirModalValor();
                              }
                            });
                          }
                        }
                      });
                    }
                  }
                }
              }
            }
          }

          break;

        case "16":
          //confirmar alterações

          //verificar se período do usuario é um periodo fracionado se for avisar que deve realizar as alteraçoes no periodo principal e fracionados mas confirmar no periodo principal
          const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
          if (Token) {
            try {
              const response = await axios.get(URL, {
                headers: { Authorization: Token.AuthStr },
              });

              if (response) {
                if (response.data.fracionamento === 0) {
                  //tratamento de um período usuario principal

                  if (
                    statusAtual.current === "ALTERANDO" ||
                    statusAtual.current === "alterado" ||
                    statusAtual.current === "FRACAO_FINALIZADA"
                  ) {
                    //confirmado e delegado
                    //1
                    if (
                      statusAtual.current === "ALTERANDO" ||
                      statusAtual.current === "FRACAO_FINALIZADA"
                    ) {
                      if (statusAnterior.current === "DELEGADO") {
                        //ver se período principal tem fracionados e trazê-los.
                        const URLPEUFrac = `${Globais.DOMINIOBACK}/periodo-usuario/fracionados/${periodoUsuario.current}`;

                        try {
                          const responsePEUFrac = await axios.get(URLPEUFrac, {
                            headers: { Authorization: Token.AuthStr },
                          });
                          let result;
                          let resultEmail;
                          let formDataEmail;
                          let fracionado = 0;
                          let resultPrincipal;
                          let formDataDelegado = {};

                          if (responsePEUFrac.data.length > 0) {
                            if (valorSugerido.current) {
                              resultPrincipal = confirmarPeriodo(
                                periodoUsuario.current,
                                valorSugerido.current,
                                "delegado"
                              );
                            } else {
                              formDataDelegado = {
                                status: statusAnterior.current,
                                alterado: 0,
                                caso: 2,
                                periodoUsuario: periodoUsuario.current,
                              };
                              resultPrincipal =
                                atualizarPeriodoUsuario(formDataDelegado);
                            }

                            if ((await resultPrincipal) === 1) {
                              responsePEUFrac.data.filter(async (p: any) => {
                                p.key = p.id;
                                if (periodoUsuario1Fracao.current === 0) {
                                  periodoUsuario1Fracao.current = p.id;
                                  valorSugeridoFracao.current = p.valorSugerido;
                                  if (p.statusAnterior === "NAO_FRACIONE") {
                                    fracionado = 1;
                                    return null;
                                  }
                                } else {
                                  periodoUsuario2Fracao.current = p.id;
                                  valorSugeridoFracao.current = p.valorSugerido;
                                  if (p.statusAnterior === "NAO_FRACIONE") {
                                    fracionado = 1;
                                    return null;
                                  }
                                }
                                if (valorSugeridoFracao.current) {
                                  result = confirmarPeriodo(
                                    p.id,
                                    valorSugeridoFracao.current,
                                    "delegado"
                                  );
                                } else {
                                  formDataDelegado = {
                                    status: statusAnterior.current,
                                    alterado: 0,
                                    caso: 2,
                                    periodoUsuario: p.id,
                                  };
                                  result =
                                    atualizarPeriodoUsuario(formDataDelegado);
                                }
                              });

                              if (fracionado === 1) {
                                result = naoFracione(
                                  periodoUsuario.current,
                                  0,
                                  0,
                                  0,
                                  false
                                );
                              }

                              if ((await result) === 1) {
                                if (fracionado === 1) {
                                  formDataEmail = {
                                    tipoEmail: 15,
                                    valorPrincipal: 2,
                                    valor1Fracao: 5,
                                    valor2Fracao: 0,
                                    periodoUsuarioId: periodoUsuario.current,
                                  };
                                } else {
                                  formDataEmail = {
                                    tipoEmail: 15,
                                    valorPrincipal: 2,
                                    valor1Fracao: 2,
                                    valor2Fracao: 2,
                                    periodoUsuarioId: periodoUsuario.current,
                                    periodoUsuarioId1Fracao:
                                      periodoUsuario1Fracao.current,
                                    periodoUsuarioId2Fracao:
                                      periodoUsuario2Fracao.current,
                                  };
                                }

                                resultEmail = enviarEmail(formDataEmail);
                                if (await resultEmail) {
                                  success(
                                    "Alterações confirmadas com sucesso!"
                                  );
                                  setTimeout(() => {
                                    document.location.reload();
                                  }, 2000);
                                } else {
                                  error(
                                    "Não poi possível enviar e-mail com as alterações para o proprietário."
                                  );
                                }
                              } else {
                                error("Erro ao atualizar período 4.");
                              }
                            }
                          } else {
                            result = confirmarPeriodo(
                              periodoUsuario.current,
                              valorSugerido.current,
                              "delegado"
                            );

                            if ((await result) === 1) {
                              formDataEmail = {
                                valorMin: valorSugerido.current,
                                tipoEmail: 9,

                                situacao: situacao.current,
                                periodoUsuarioId: periodoUsuario.current,
                              };
                              resultEmail = enviarEmail(formDataEmail);
                              if (await resultEmail) {
                                success("Alterações confirmadas com sucesso!");
                                setTimeout(() => {
                                  document.location.reload();
                                }, 2000);
                              } else {
                                error(
                                  "Não poi possível enviar e-mail com as alterações para o proprietário."
                                );
                              }
                            } else {
                              if ((await result) === 2) {
                                error("Não foi possível atualizar período.");
                              }
                            }
                          }
                        } catch (error) {
                          error("Período não encontrado.");
                        }
                      } else {
                        if (statusAnterior.current === "NAO_PERTUBE") {
                          //ver se período principal tem fracionados e trazê-los.
                          const URLPEUFrac = `${Globais.DOMINIOBACK}/periodo-usuario/fracionados/${periodoUsuario.current}`;

                          try {
                            const responsePEUFrac = await axios.get(
                              URLPEUFrac,
                              {
                                headers: { Authorization: Token.AuthStr },
                              }
                            );
                            let result;
                            let resultEmail;
                            let formDataEmail;
                            let fracionado = 0;
                            let resultPrincipal;
                            let formDataNaoPertube = {};

                            if (responsePEUFrac.data.length > 0) {
                              if (valorSugerido.current) {
                                if (alterando.current) {
                                  resultPrincipal = confirmarPeriodo(
                                    periodoUsuario.current,
                                    valorSugerido.current,
                                    "confirmado"
                                  );
                                } else {
                                  resultPrincipal = confirmarPeriodo(
                                    periodoUsuario.current,
                                    valorSugerido.current,
                                    "naoPertube"
                                  );
                                }
                              } else {
                                formDataNaoPertube = {
                                  status: statusAnterior.current,
                                  alterado: 0,
                                  caso: 2,
                                  periodoUsuario: periodoUsuario.current,
                                };
                                resultPrincipal =
                                  atualizarPeriodoUsuario(formDataNaoPertube);
                              }

                              if ((await resultPrincipal) === 1) {
                                responsePEUFrac.data.filter(async (p: any) => {
                                  p.key = p.id;
                                  if (periodoUsuario1Fracao.current === 0) {
                                    periodoUsuario1Fracao.current = p.id;
                                    valorSugeridoFracao.current =
                                      p.valorSugerido;
                                    if (p.statusAnterior === "NAO_FRACIONE") {
                                      fracionado = 1;
                                      return null;
                                    }
                                  } else {
                                    periodoUsuario2Fracao.current = p.id;
                                    valorSugeridoFracao.current =
                                      p.valorSugerido;
                                    if (p.statusAnterior === "NAO_FRACIONE") {
                                      fracionado = 1;
                                      return null;
                                    }
                                  }

                                  if (valorSugeridoFracao.current) {
                                    if (alterando.current) {
                                      result = confirmarPeriodo(
                                        p.id,
                                        valorSugeridoFracao.current,
                                        "confirmado"
                                      );
                                    } else {
                                      result = confirmarPeriodo(
                                        p.id,
                                        valorSugeridoFracao.current,
                                        "naoPertube"
                                      );
                                    }
                                  } else {
                                    formDataNaoPertube = {
                                      status: statusAnterior.current,
                                      alterado: 0,
                                      caso: 2,
                                      periodoUsuario: p.id,
                                    };
                                    result =
                                      atualizarPeriodoUsuario(
                                        formDataNaoPertube
                                      );
                                  }
                                });

                                if (fracionado === 1) {
                                  result = naoFracione(
                                    periodoUsuario.current,
                                    0,
                                    0,
                                    0,
                                    false
                                  );
                                }

                                if ((await result) === 1) {
                                  if (fracionado === 1) {
                                    formDataEmail = {
                                      tipoEmail: 15,
                                      valorPrincipal: 11,
                                      valor1Fracao: 5,
                                      valor2Fracao: 0,
                                      periodoUsuarioId: periodoUsuario.current,
                                    };
                                  } else {
                                    formDataEmail = {
                                      tipoEmail: 15,
                                      valorPrincipal: 11,
                                      valor1Fracao: 11,
                                      valor2Fracao: 11,
                                      periodoUsuarioId: periodoUsuario.current,
                                      periodoUsuarioId1Fracao:
                                        periodoUsuario1Fracao.current,
                                      periodoUsuarioId2Fracao:
                                        periodoUsuario2Fracao.current,
                                    };
                                  }

                                  resultEmail = enviarEmail(formDataEmail);
                                  if (await resultEmail) {
                                    success(
                                      "Alterações confirmadas com sucesso!"
                                    );
                                    setTimeout(() => {
                                      document.location.reload();
                                    }, 2000);
                                  } else {
                                    error(
                                      "Não poi possível enviar e-mail com as alterações para o proprietário."
                                    );
                                  }
                                } else {
                                  error("Erro ao atualizar período 4.");
                                }
                              }
                            } else {
                              let formDataNaoPertube = {
                                status: "NAO_PERTUBE",
                                periodoUsuario: periodoUsuarioId,
                                caso: 3,
                                alterado: 0,
                                valorMin: formatarMoeda(valorSugerido.current),
                              };
                              result =
                                atualizarPeriodoUsuario(formDataNaoPertube);

                              if ((await result) === 1) {
                                formDataEmail = {
                                  valorMin: valorSugerido.current,
                                  tipoEmail: 15,
                                  valorPrincipal: 10,
                                  valor1Fracao: 0,
                                  valor2Fracao: 0,

                                  situacao: situacao.current,
                                  periodoUsuarioId: periodoUsuario.current,
                                };
                                resultEmail = enviarEmail(formDataEmail);
                                if (await resultEmail) {
                                  success(
                                    "Alterações confirmadas com sucesso!"
                                  );
                                  setTimeout(() => {
                                    document.location.reload();
                                  }, 2000);
                                } else {
                                  error(
                                    "Não poi possível enviar e-mail com as alterações para o proprietário."
                                  );
                                }
                              } else {
                                if ((await result) === 2) {
                                  error("Não foi possível atualizar período.");
                                }
                              }
                            }
                          } catch (error) {
                            error("Período não encontrado.");
                          }
                        } else {
                          if (situacao.current === "Reservado pelo próprio") {
                            //apenas confirmado e situacao é reservado

                            let formData = {};

                            if (valorSugerido.current) {
                              formData = {
                                status: "FINALIZADO",
                                periodoUsuario: periodoUsuario.current,
                                valorMin: formatarMoeda(valorSugerido.current),
                                caso: 7,
                                divulgado: 0,
                                alterado: 0,
                              };
                            } else {
                              formData = {
                                status: "FINALIZADO",
                                periodoUsuario: periodoUsuario.current,

                                caso: 7,
                                divulgado: 0,
                                alterado: 0,
                              };
                            }

                            let resultReserva;

                            const URLPEUFrac = `${Globais.DOMINIOBACK}/periodo-usuario/fracionados/${periodoUsuario.current}`;
                            const responsePEUFrac = await axios.get(
                              URLPEUFrac,
                              {
                                headers: { Authorization: Token.AuthStr },
                              }
                            );
                            if (responsePEUFrac.data.length > 0) {
                              resultReserva = atualizarPeriodoUsuario(formData);
                              if ((await resultReserva) === 1) {
                                resultReserva = naoFracione(
                                  periodoUsuario.current,
                                  0,
                                  0,
                                  0,
                                  false
                                );
                                let formDataEmail = {
                                  tipoEmail: 13,
                                  situacao: "RESERVADO",
                                  periodoUsuarioId: periodoUsuario.current,
                                };

                                let resultEmailReserva =
                                  enviarEmail(formDataEmail);
                                if (await resultEmailReserva) {
                                  success(
                                    "Alterações confirmadas com sucesso!"
                                  );
                                  setTimeout(() => {
                                    document.location.reload();
                                  }, 2000);
                                } else {
                                  error(
                                    "Não poi possível enviar e-mail com as alterações para o proprietário."
                                  );
                                }
                              }
                            } else {
                              resultReserva = atualizarPeriodoUsuario(formData);
                              if ((await resultReserva) === 1) {
                                let formDataEmail = {
                                  tipoEmail: 13,
                                  situacao: "RESERVADO",
                                  periodoUsuarioId: periodoUsuario.current,
                                };

                                let resultEmailReserva =
                                  enviarEmail(formDataEmail);
                                if (await resultEmailReserva) {
                                  success(
                                    "Alterações confirmadas com sucesso!"
                                  );
                                  setTimeout(() => {
                                    document.location.reload();
                                  }, 2000);
                                } else {
                                  error(
                                    "Não poi possível enviar e-mail com as alterações para o proprietário."
                                  );
                                }
                              } else {
                                if ((await resultReserva) === 2) {
                                  error("Não foi possível atualizar período.");
                                }
                              }
                            }
                          } else {
                            if (situacao.current === "Trocar") {
                              let formData = {};
                              formData = {
                                status: "SEM_STATUS",
                                periodoUsuario: periodoUsuario.current,
                                caso: 7,
                                divulgado: 0,
                                alterado: 0,
                              };
                              let resultTrocar;

                              const URLPEUFrac = `${Globais.DOMINIOBACK}/periodo-usuario/fracionados/${periodoUsuario.current}`;
                              const responsePEUFrac = await axios.get(
                                URLPEUFrac,
                                {
                                  headers: { Authorization: Token.AuthStr },
                                }
                              );
                              if (responsePEUFrac.data.length > 0) {
                                resultTrocar =
                                  atualizarPeriodoUsuario(formData);
                                if ((await resultTrocar) === 1) {
                                  resultTrocar = naoFracione(
                                    periodoUsuario.current,
                                    0,
                                    0,
                                    0,
                                    false
                                  );
                                  let formDataEmail = {
                                    tipoEmail: 13,
                                    situacao: "Trocar",
                                    periodoUsuarioId: periodoUsuario.current,
                                  };

                                  let resultEmailReserva =
                                    enviarEmail(formDataEmail);
                                  if (await resultEmailReserva) {
                                    success(
                                      "Alterações confirmadas com sucesso!"
                                    );
                                    setTimeout(() => {
                                      document.location.reload();
                                    }, 2000);
                                  } else {
                                    error(
                                      "Não poi possível enviar e-mail com as alterações para o proprietário."
                                    );
                                  }
                                }
                              } else {
                                resultTrocar =
                                  atualizarPeriodoUsuario(formData);
                                if ((await resultTrocar) === 1) {
                                  let formDataEmail = {
                                    tipoEmail: 13,
                                    situacao: "Trocar",
                                    periodoUsuarioId: periodoUsuario.current,
                                  };

                                  let resultEmailReserva =
                                    enviarEmail(formDataEmail);
                                  if (await resultEmailReserva) {
                                    success(
                                      "Alterações confirmadas com sucesso!"
                                    );
                                    setTimeout(() => {
                                      document.location.reload();
                                    }, 2000);
                                  } else {
                                    error(
                                      "Não poi possível enviar e-mail com as alterações para o proprietário."
                                    );
                                  }
                                } else {
                                  if ((await resultTrocar) === 2) {
                                    error(
                                      "Não foi possível atualizar período."
                                    );
                                  }
                                }
                              }
                            } else {
                              if (situacao.current === "Será utilizado") {
                                //apenas confirmado e situacao é utilizado
                                let formData = {};
                                formData = {
                                  status: "FINALIZADO",
                                  periodoUsuario: periodoUsuario.current,
                                  caso: 7,
                                  divulgado: 0,
                                  alterado: 0,
                                };
                                let resultUtilizar;

                                const URLPEUFrac = `${Globais.DOMINIOBACK}/periodo-usuario/fracionados/${periodoUsuario.current}`;
                                const responsePEUFrac = await axios.get(
                                  URLPEUFrac,
                                  {
                                    headers: { Authorization: Token.AuthStr },
                                  }
                                );
                                if (responsePEUFrac.data.length > 0) {
                                  resultUtilizar =
                                    atualizarPeriodoUsuario(formData);
                                  if ((await resultUtilizar) === 1) {
                                    resultUtilizar = naoFracione(
                                      periodoUsuario.current,
                                      0,
                                      0,
                                      0,
                                      false
                                    );
                                    let formDataEmail = {
                                      tipoEmail: 13,
                                      situacao: "SERÁ UTILIZADO",
                                      periodoUsuarioId: periodoUsuario.current,
                                    };

                                    let resultEmailReserva =
                                      enviarEmail(formDataEmail);
                                    if (await resultEmailReserva) {
                                      success(
                                        "Alterações confirmadas com sucesso!"
                                      );
                                      setTimeout(() => {
                                        document.location.reload();
                                      }, 2000);
                                    } else {
                                      error(
                                        "Não poi possível enviar e-mail com as alterações para o proprietário."
                                      );
                                    }
                                  }
                                } else {
                                  resultUtilizar =
                                    atualizarPeriodoUsuario(formData);
                                  if ((await resultUtilizar) === 1) {
                                    let formDataEmail = {
                                      tipoEmail: 13,
                                      situacao: "SERÁ UTILIZADO",
                                      periodoUsuarioId: periodoUsuario.current,
                                    };

                                    let resultEmailReserva =
                                      enviarEmail(formDataEmail);
                                    if (await resultEmailReserva) {
                                      success(
                                        "Alterações confirmadas com sucesso!"
                                      );
                                      setTimeout(() => {
                                        document.location.reload();
                                      }, 2000);
                                    } else {
                                      error(
                                        "Não poi possível enviar e-mail com as alterações para o proprietário."
                                      );
                                    }
                                  } else {
                                    if ((await resultUtilizar) === 2) {
                                      error(
                                        "Não foi possível atualizar período."
                                      );
                                    }
                                  }
                                }
                              } else {
                                if (active.current === 3) {
                                  //confirmando períodos que foram cancelados.

                                  let resultCota = venderCota(
                                    true,
                                    periodoUsuario.current,
                                    0
                                  );
                                  if ((await resultCota) === 1) {
                                    success(
                                      "Alterações confirmadas com sucesso!"
                                    );
                                    setTimeout(() => {
                                      document.location.reload();
                                    }, 2000);
                                  } else {
                                    error(
                                      "Não foi possível atualizar período."
                                    );
                                  }
                                } else {
                                  if (active.current === 4) {
                                    let result = deletarSomentePeriodosUsuarios(
                                      periodoUsuario.current
                                    );
                                    if ((await result) === 1) {
                                      let formDataEmail = {
                                        tipoEmail: 19,
                                        usuarioId: nUserId.userId,
                                        checkIn: checkInPeriodo.current,
                                        checkOut: checkOutPeriodo.current,
                                      };
                                      const resultEmail =
                                        enviarEmail(formDataEmail);
                                      if (await resultEmail) {
                                        success(
                                          "Alterações confirmadas com sucesso!"
                                        );
                                        setTimeout(() => {
                                          document.location.reload();
                                        }, 2000);
                                      }
                                    }
                                  } else {
                                    if (
                                      situacao.current === "Alugar" ||
                                      situacao.current === "Alugar ou trocar"
                                    ) {
                                      const URLPEUFrac = `${Globais.DOMINIOBACK}/periodo-usuario/fracionados/${periodoUsuario.current}`;
                                      const responsePEUFrac = await axios.get(
                                        URLPEUFrac,
                                        {
                                          headers: {
                                            Authorization: Token.AuthStr,
                                          },
                                        }
                                      );
                                      let resultCasosNormais;
                                      let formDataEmail;
                                      let resultEmail;
                                      let resultPrincipal;
                                      let valorPrincipal = 3;
                                      let valor1Fracao = 3;
                                      let valor2Fracao = 3;
                                      let valorSugeridoPrincipal;
                                      let valorSugerido1Fracao = "";
                                      let valorSugerido2Fracao = "";
                                      let fracionado = 0;

                                      if (responsePEUFrac.data.length > 0) {
                                        if (
                                          statusAnterior.current === "REJEITADO"
                                        ) {
                                          resultPrincipal = confirmarPeriodo(
                                            periodoUsuario.current,
                                            valorSugerido.current,
                                            "rejeitado"
                                          );
                                          valorPrincipal = 5;
                                          valorSugeridoPrincipal =
                                            formatarMoeda(
                                              valorSugerido.current
                                            );
                                        } else {
                                          if (
                                            statusAnterior.current ===
                                            "NAO_PERTUBE"
                                          ) {
                                            resultPrincipal = confirmarPeriodo(
                                              periodoUsuario.current,
                                              valorSugerido.current,
                                              "naoPertube"
                                            );
                                            valorPrincipal = 6;
                                            valorSugeridoPrincipal =
                                              formatarMoeda(
                                                valorSugerido.current
                                              );
                                          } else {
                                            if (valorSugerido.current === "") {
                                              let formData = {
                                                periodoUsuario:
                                                  periodoUsuario.current,
                                                caso: 2,
                                                status: "SEM_STATUS",
                                                alterado: 0,
                                              };
                                              resultPrincipal =
                                                atualizarPeriodoUsuario(
                                                  formData
                                                );
                                            } else {
                                              resultPrincipal =
                                                confirmarPeriodo(
                                                  periodoUsuario.current,
                                                  valorSugerido.current,
                                                  "confirmado"
                                                );
                                            }
                                          }
                                        }

                                        if ((await resultPrincipal) === 1) {
                                          responsePEUFrac.data.filter(
                                            async (p: any) => {
                                              p.key = p.id;
                                              if (
                                                periodoUsuario1Fracao.current ===
                                                0
                                              ) {
                                                periodoUsuario1Fracao.current =
                                                  p.id;
                                                if (p.valorSugerido) {
                                                  valorSugerido1Fracao =
                                                    p.valorSugerido;
                                                  valorSugeridoFracao.current =
                                                    p.valorSugerido;
                                                }

                                                if (
                                                  p.statusAnterior ===
                                                  "REJEITADO"
                                                ) {
                                                  valor1Fracao = 6;
                                                  valorSugerido1Fracao =
                                                    p.valorSugerido;
                                                } else {
                                                  if (
                                                    p.statusAnterior ===
                                                    "NAO_FRACIONE"
                                                  ) {
                                                    fracionado = 1;
                                                    return null;
                                                  } else {
                                                    if (
                                                      p.trocar === 1 &&
                                                      p.alugar === 0
                                                    ) {
                                                      valor1Fracao = 10;
                                                    } else {
                                                      if (p.utilizar === 1) {
                                                        valor1Fracao = 9;
                                                      } else {
                                                        if (p.concluido === 1) {
                                                          valor1Fracao = 8;
                                                        } else {
                                                          valor1Fracao = 3;
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              } else {
                                                periodoUsuario2Fracao.current =
                                                  p.id;
                                                if (p.valorSugerido) {
                                                  valorSugerido2Fracao =
                                                    p.valorSugerido;
                                                  valorSugeridoFracao.current =
                                                    p.valorSugerido;
                                                }
                                                if (
                                                  p.statusAnterior ===
                                                  "REJEITADO"
                                                ) {
                                                  valor2Fracao = 6;
                                                  valorSugerido2Fracao =
                                                    p.valorSugerido;
                                                } else {
                                                  if (
                                                    p.statusAnterior ===
                                                    "NAO_FRACIONE"
                                                  ) {
                                                    fracionado = 1;
                                                    return null;
                                                  } else {
                                                    if (
                                                      p.trocar === 1 &&
                                                      p.alugar === 0
                                                    ) {
                                                      valor2Fracao = 10;
                                                    } else {
                                                      if (p.utilizar === 1) {
                                                        valor2Fracao = 9;
                                                      } else {
                                                        if (p.concluido === 1) {
                                                          valor2Fracao = 8;
                                                        } else {
                                                          valor2Fracao = 3;
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                              if (
                                                p.statusAnterior === "REJEITADO"
                                              ) {
                                                resultCasosNormais =
                                                  confirmarPeriodo(
                                                    p.id,
                                                    valorSugeridoFracao.current,
                                                    "rejeitado"
                                                  );
                                              } else {
                                                if (
                                                  p.trocar === 1 &&
                                                  p.alugar === 0
                                                ) {
                                                  resultCasosNormais =
                                                    atualizarSituacao(4, p.id);
                                                } else {
                                                  if (p.utilizar === 1) {
                                                    resultCasosNormais =
                                                      atualizarSituacao(
                                                        2,
                                                        p.id
                                                      );
                                                  } else {
                                                    if (p.concluido === 1) {
                                                      resultCasosNormais =
                                                        atualizarSituacao(
                                                          3,
                                                          p.id
                                                        );
                                                    } else {
                                                      if (
                                                        valorSugeridoFracao.current ===
                                                        ""
                                                      ) {
                                                        let formData = {
                                                          periodoUsuario: p.id,
                                                          caso: 2,
                                                          status: "SEM_STATUS",
                                                          alterado: 0,
                                                          divulgado: 0,
                                                        };

                                                        resultCasosNormais =
                                                          atualizarPeriodoUsuario(
                                                            formData
                                                          );
                                                      } else {
                                                        if (
                                                          periodoUsuario1Fracao.current ===
                                                          p.id
                                                        ) {
                                                          resultCasosNormais =
                                                            confirmarPeriodo(
                                                              p.id,
                                                              valorSugerido1Fracao,
                                                              "confirmado"
                                                            );
                                                        } else {
                                                          if (
                                                            periodoUsuario2Fracao.current ===
                                                            p.id
                                                          ) {
                                                            resultCasosNormais =
                                                              confirmarPeriodo(
                                                                p.id,
                                                                valorSugerido2Fracao,
                                                                "confirmado"
                                                              );
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          );
                                          if (fracionado === 1) {
                                            resultCasosNormais = naoFracione(
                                              periodoUsuario.current,
                                              0,
                                              0,
                                              0,
                                              false
                                            );
                                          }
                                          if (
                                            (await resultCasosNormais) === 1
                                          ) {
                                            if (fracionado === 1) {
                                              formDataEmail = {
                                                tipoEmail: 15,
                                                valorPrincipal: valorPrincipal,
                                                valor1Fracao: 5,

                                                periodoUsuarioId:
                                                  periodoUsuario.current,

                                                valorSugeridoPrincipal:
                                                  valorSugeridoPrincipal,
                                              };
                                            } else {
                                              formDataEmail = {
                                                tipoEmail: 15,
                                                valorPrincipal: valorPrincipal,
                                                valor1Fracao: valor1Fracao,
                                                valor2Fracao: valor2Fracao,
                                                periodoUsuarioId:
                                                  periodoUsuario.current,
                                                periodoUsuarioId1Fracao:
                                                  periodoUsuario1Fracao.current,
                                                periodoUsuarioId2Fracao:
                                                  periodoUsuario2Fracao.current,
                                                valorSugeridoPrincipal:
                                                  valorSugeridoPrincipal,
                                                valorSugerido1Fracao:
                                                  valorSugerido1Fracao,
                                                valorSugerido2Fracao:
                                                  valorSugerido2Fracao,
                                              };
                                            }

                                            resultEmail =
                                              enviarEmail(formDataEmail);
                                            if (await resultEmail) {
                                              success(
                                                "Alterações confirmadas com sucesso!"
                                              );
                                              setTimeout(() => {
                                                document.location.reload();
                                              }, 2000);
                                            } else {
                                              error(
                                                "Não poi possível enviar e-mail com as alterações para o proprietário."
                                              );
                                            }
                                          } else {
                                            error(
                                              "Erro ao atualizar período 5."
                                            );
                                          }
                                        }
                                      } else {
                                        resultPrincipal = confirmarPeriodo(
                                          periodoUsuario.current,
                                          valorSugerido.current,
                                          "confirmado"
                                        );
                                        formDataEmail = {
                                          valorMin: valorSugerido.current,
                                          tipoEmail: 10,
                                          situacao: situacao.current,
                                          periodoUsuarioId:
                                            periodoUsuario.current,
                                        };

                                        resultEmail =
                                          enviarEmail(formDataEmail);
                                        if (await resultEmail) {
                                          success(
                                            "Alterações confirmadas com sucesso!"
                                          );
                                          setTimeout(() => {
                                            document.location.reload();
                                          }, 2000);
                                        } else {
                                          error(
                                            "Não poi possível enviar e-mail com as alterações para o proprietário."
                                          );
                                        }
                                      }
                                    } else {
                                      //apenas confirmado e situacao não é reservado nem utilizado
                                      const URLPEUFrac = `${Globais.DOMINIOBACK}/periodo-usuario/fracionados/${periodoUsuario.current}`;
                                      const responsePEUFrac = await axios.get(
                                        URLPEUFrac,
                                        {
                                          headers: {
                                            Authorization: Token.AuthStr,
                                          },
                                        }
                                      );
                                      let valorPrincipal;
                                      let valor1Fracao;
                                      let valor2Fracao;
                                      let situacaoAtual;
                                      let situacaoNumero: number;

                                      let resultCasosNormais;

                                      if (responsePEUFrac.data.length > 0) {
                                        if (
                                          statusAnterior.current ===
                                          "FRACAO_FINALIZADA"
                                        ) {
                                          resultCasosNormais =
                                            atualizarSituacao(
                                              1,
                                              periodoUsuario.current
                                            );

                                          valorPrincipal = 7;
                                        }

                                        if ((await resultCasosNormais) === 1) {
                                          responsePEUFrac.data.filter(
                                            async (p: any) => {
                                              p.key = p.id;
                                              situacaoAtual = qualSituacao(
                                                p.alugar,
                                                p.trocar,
                                                p.concluido,
                                                p.utilizar,
                                                1,
                                                ""
                                              );
                                              switch (situacaoAtual) {
                                                case "ALUGAR":
                                                case "ALUGAR_TROCAR":
                                                  if (
                                                    periodoUsuario1Fracao.current ===
                                                    0
                                                  ) {
                                                    periodoUsuario1Fracao.current =
                                                      p.id;
                                                    valorSugeridoFracao.current =
                                                      p.valorSugerido;
                                                    valorSugerido1Fracao.current =
                                                      p.valorSugerido;
                                                    if (
                                                      p.statusAnterior ===
                                                      "DELEGADO"
                                                    ) {
                                                      valor1Fracao = 2;
                                                    } else {
                                                      if (
                                                        p.statusAnterior ===
                                                        "REJEITADO"
                                                      ) {
                                                        valor1Fracao = 6;
                                                      } else {
                                                        if (
                                                          p.statusAnterior ===
                                                          "NAO_PERTUBE"
                                                        ) {
                                                          valor1Fracao = 7;
                                                        } else {
                                                          valor1Fracao = 3;
                                                        }
                                                      }
                                                    }
                                                  } else {
                                                    periodoUsuario2Fracao.current =
                                                      p.id;
                                                    valorSugeridoFracao.current =
                                                      p.valorSugerido;
                                                    valorSugerido2Fracao.current =
                                                      p.valorSugerido;
                                                    if (
                                                      p.statusAnterior ===
                                                      "DELEGADO"
                                                    ) {
                                                      valor2Fracao = 2;
                                                    } else {
                                                      if (
                                                        p.statusAnterior ===
                                                        "REJEITADO"
                                                      ) {
                                                        valor2Fracao = 6;
                                                      } else {
                                                        if (
                                                          p.statusAnterior ===
                                                          "NAO_PERTUBE"
                                                        ) {
                                                          valor2Fracao = 7;
                                                        } else {
                                                          valor2Fracao = 3;
                                                        }
                                                      }
                                                    }
                                                  }
                                                  if (
                                                    p.statusAnterior ===
                                                    "DELEGADO"
                                                  ) {
                                                    resultCasosNormais =
                                                      confirmarPeriodo(
                                                        p.id,
                                                        valorSugeridoFracao.current,
                                                        "delegado"
                                                      );
                                                  } else {
                                                    if (
                                                      p.statusAnterior ===
                                                      "REJEITADO"
                                                    ) {
                                                      resultCasosNormais =
                                                        confirmarPeriodo(
                                                          p.id,
                                                          valorSugeridoFracao.current,
                                                          "rejeitado"
                                                        );
                                                    } else {
                                                      if (
                                                        p.statusAnterior ===
                                                        "NAO_PERTUBE"
                                                      ) {
                                                        resultCasosNormais =
                                                          confirmarPeriodo(
                                                            p.id,
                                                            valorSugeridoFracao.current,
                                                            "naoPertube"
                                                          );
                                                      } else {
                                                        resultCasosNormais =
                                                          confirmarPeriodo(
                                                            p.id,
                                                            valorSugeridoFracao.current,
                                                            "confirmado"
                                                          );
                                                      }
                                                    }
                                                  }

                                                  break;

                                                case "UTILIZADO":
                                                case "CONCLUIDO_PELO_PROPRIO":
                                                  if (
                                                    periodoUsuario1Fracao.current ===
                                                    0
                                                  ) {
                                                    periodoUsuario1Fracao.current =
                                                      p.id;

                                                    if (
                                                      situacaoAtual ===
                                                      "UTILIZADO"
                                                    ) {
                                                      valor1Fracao = 9;
                                                      situacaoNumero = 2;
                                                    } else {
                                                      if (
                                                        situacaoAtual ===
                                                        "CONCLUIDO_PELO_PROPRIO"
                                                      ) {
                                                        valor1Fracao = 8;
                                                        situacaoNumero = 3;
                                                        valorSugeridoFracao.current =
                                                          p.valorSugerido;
                                                      }
                                                    }
                                                  } else {
                                                    periodoUsuario2Fracao.current =
                                                      p.id;

                                                    if (
                                                      situacaoAtual ===
                                                      "UTILIZADO"
                                                    ) {
                                                      valor2Fracao = 9;
                                                      situacaoNumero = 2;
                                                    } else {
                                                      if (
                                                        situacaoAtual ===
                                                        "CONCLUIDO_PELO_PROPRIO"
                                                      ) {
                                                        valor2Fracao = 8;
                                                        situacaoNumero = 3;
                                                        valorSugeridoFracao.current =
                                                          p.valorSugerido;
                                                      }
                                                    }
                                                  }

                                                  resultCasosNormais =
                                                    atualizarSituacao(
                                                      situacaoNumero,
                                                      p.id
                                                    );
                                                  break;
                                              }
                                            }
                                          );
                                          if (
                                            (await resultCasosNormais) === 1
                                          ) {
                                            let formDataEmail = {
                                              tipoEmail: 15,
                                              valorPrincipal: valorPrincipal,
                                              valor1Fracao: valor1Fracao,
                                              valor2Fracao: valor2Fracao,
                                              periodoUsuarioId:
                                                periodoUsuario.current,
                                              periodoUsuarioId1Fracao:
                                                periodoUsuario1Fracao.current,
                                              periodoUsuarioId2Fracao:
                                                periodoUsuario2Fracao.current,
                                              valorSugeridoPrincipal:
                                                valorSugerido.current,
                                              valorSugerido1Fracao:
                                                valorSugerido1Fracao.current,
                                              valorSugerido2Fracao:
                                                valorSugerido2Fracao.current,
                                            };
                                            let resultEmail =
                                              enviarEmail(formDataEmail);
                                            if (await resultEmail) {
                                              success(
                                                "Alterações confirmadas com sucesso!"
                                              );
                                              setTimeout(() => {
                                                document.location.reload();
                                              }, 2000);
                                            } else {
                                              error(
                                                "Não poi possível enviar e-mail com as alterações para o proprietário."
                                              );
                                            }
                                          } else {
                                            error(
                                              "Erro ao atualizar período 1."
                                            );
                                          }
                                        }
                                      } else {
                                        let formDataEmail = {
                                          valorMin: valorSugerido.current,
                                          tipoEmail: 10,
                                          situacao: situacao.current,
                                          periodoUsuarioId:
                                            periodoUsuario.current,
                                        };

                                        let resultEmail =
                                          enviarEmail(formDataEmail);
                                        if (await resultEmail) {
                                          success(
                                            "Alterações confirmadas com sucesso!"
                                          );
                                          setTimeout(() => {
                                            document.location.reload();
                                          }, 2000);
                                        } else {
                                          error(
                                            "Não poi possível enviar e-mail com as alterações para o proprietário."
                                          );
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    } else {
                      if (statusAtual.current === "alterado") {
                        let temFracoes = false;
                        let formDataAlteradoPrincipal = {
                          alterado: 0,
                          caso: 9,
                          periodoUsuario: periodoUsuario.current,
                        };
                        let formDataAlterado1 = {};
                        let formDataAlterado2 = {};
                        if (nCotaUsuarioId.cotaUsuarioId === 0) {
                          Aluguel.filter((p: any) => {
                            if (p.id === periodoUsuario.current) {
                              if (p.children) {
                                temFracoes = true;
                                p.children.filter((q: any) => {
                                  if (periodoUsuario1Fracao.current === 0) {
                                    formDataAlterado1 = {
                                      alterado: 0,
                                      caso: 9,
                                      periodoUsuario: q.id,
                                    };

                                    periodoUsuario1Fracao.current = q.id;
                                    return p;
                                  } else {
                                    formDataAlterado2 = {
                                      alterado: 0,
                                      caso: 9,
                                      periodoUsuario: q.id,
                                    };

                                    periodoUsuario2Fracao.current = q.id;
                                    return p;
                                  }
                                });
                              } else {
                                return p;
                              }
                            }
                          });
                        } else {
                          periodoData.filter((p: any) => {
                            if (p.id === periodoUsuario.current) {
                              if (p.children) {
                                temFracoes = true;
                                p.children.filter((q: any) => {
                                  if (periodoUsuario1Fracao.current === 0) {
                                    formDataAlterado1 = {
                                      alterado: 0,
                                      caso: 9,
                                      periodoUsuario: q.id,
                                    };

                                    periodoUsuario1Fracao.current = q.id;
                                    return p;
                                  } else {
                                    formDataAlterado2 = {
                                      alterado: 0,
                                      caso: 9,
                                      periodoUsuario: q.id,
                                    };

                                    periodoUsuario2Fracao.current = q.id;
                                    return p;
                                  }
                                });
                              } else {
                                return p;
                              }
                            }
                          });
                        }

                        let resultadoPrincipal = atualizarPeriodoUsuario(
                          formDataAlteradoPrincipal
                        );

                        if (periodoUsuarioId !== 0 && resultadoPrincipal) {
                          if (await resultadoPrincipal) {
                            if (temFracoes) {
                              let resultado1 =
                                atualizarPeriodoUsuario(formDataAlterado1);

                              if (await resultado1) {
                                let resultado2 =
                                  atualizarPeriodoUsuario(formDataAlterado2);

                                if (await resultado2) {
                                  success("Períodos atualizados com sucesso");
                                  setTimeout(() => {
                                    document.location.reload();
                                  }, 2000);
                                } else {
                                  error(
                                    "Não foi possível atualziar a segunda fração."
                                  );
                                }
                              } else {
                                error(
                                  "Não foi possível atualziar a primeira fração."
                                );
                              }
                            } else {
                              success("Períodos atualizados com sucesso");
                              setTimeout(() => {
                                document.location.reload();
                              }, 2000);
                            }
                          } else {
                            error(
                              "Não foi possível atualizar período principal."
                            );
                          }
                        } else {
                          if (await resultadoPrincipal) {
                            success("Período atualizado com sucesso");
                            setTimeout(() => {
                              document.location.reload();
                            }, 2000);
                          } else {
                            error(
                              "Não foi possível atualizar período principal"
                            );
                          }
                        }
                      }
                    }

                    //2
                  } else {
                    error(
                      "Para confirmar as alterações, o período precisa estar com status 'Alterado'."
                    );
                  }
                } else {
                  //tratamento de um período fracionado.
                  errorLongaDuracao(
                    "Para confirmar as alterações de um período fracionado deverá confirmar no periodo principal. Lembre-se de verificar não só o principal, mas também os fracionados e só depois confirmar as alterações no principal."
                  );
                }
              } else {
                error("Algo deu errado!");
              }
            } catch (error) {
              error("Algo deu errado!");
            }
          } else {
            document.location.href = "/login";
          }

          break;
        case "17":
          //valor a ser anunciado
          setOpenValoresAnunciado(true);

          break;
        case "18":
          document.location.href = `/gerenciarReserva?periodoUsuarioId=${periodoUsuario.current}`;

          break;
        case "19":
          const periodousuario = {
            tipoEmail: 13,
            caso: 9,
            periodoUsuarioId: periodoUsuario.current,
            trocar: 0,
            alugar: 0,
            utilizar: 0,
            concluido: 1,
            status: "FINALIZADO",
            situacao: "RESERVADO",
          };
          const tipoEmail = { tipoEmail: 13 };
          const reservadoPeloProprio = await atualizarPeriodoUsuario(
            periodousuario
          );

          if (reservadoPeloProprio) {
            const envioMail = await enviarEmail(periodousuario);
            if (envioMail) {
              success("Período atualizado com sucesso");
              setTimeout(() => {
                document.location.reload();
              }, 3000);
            } else {
              error("Algo deu errado!");
            }
          } else {
            error("Algo deu errado!");
          }

          break;
        case "20":
          const temPeriodoDivulgado = await verificarSeTemPeriodoDivulgado(
            periodoUsuario.current
          );

          if (temPeriodoDivulgado) {
            warning("Período sendo divulgado. Favor retirar anúncio.");
            break;
          }

          const periodoParaUtilizar = {
            tipoEmail: 13,
            caso: 9,
            periodoUsuarioId: periodoUsuario.current,
            trocar: 0,
            alugar: 0,
            utilizar: 1,
            concluido: 0,
            status: "FINALIZADO",
            situacao: "Utilizar",
          };
          const possuiFracionados = await deletarSomenteFracionados(
            periodoUsuario.current
          );

          // if (!possuiFracionados) {
          //   warning(
          //     "Nenhum período fracionado encontrado para apagar. Continuando..."
          //   );
          // }

          // Continua com a atualização normalmente
          const atualizou = await atualizarPeriodoUsuario(periodoParaUtilizar);
          const enviouEmail =
            atualizou && (await enviarEmail(periodoParaUtilizar));

          if (!enviouEmail) {
            error("Algo deu errado!");
            break;
          }

          success("Período atualizado com sucesso");
          setTimeout(() => {
            document.location.reload();
          }, 3000);

          break;
      }
    }
  };

  const items: MenuProps["items"] = [
    getItem("Mudar situação", "sub2", <AppstoreOutlined />, [
      // getItem("Não definido", "1"),
      getItem("Alugar", "2"),
      getItem("Trocar", "3"),
      getItem("Alugar ou trocar", "4"),
      getItem("Alterar valor", "12"),
      // getItem("Será utilizado", "5"),
      // getItem("Reservado pelo próprio", "6"),
      getItem("Reservado pelo próprio", "19"),
      getItem("Reservado por MC", "7"),
      getItem("Utilizar", "20"),
    ]),
    getItem("Mudar divulgação", "sub3", <AppstoreOutlined />, [
      getItem("Não divulgado", "8"),
      getItem("Divulgado", "9"),
    ]),
    { key: "10", label: "Excluir" },

    { key: "16", label: "Confirmar alterações" },
    { key: "17", label: "Valor a ser anunciado" },
    { key: "18", label: "Reserva" },

    getItem("Mandar mensagem", "sub4", <AppstoreOutlined />, [
      getItem("Genérica", "11"),
    ]),
  ];

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };
  const hoje = new Date().toLocaleDateString("pt-BR", {
    timeZone: "UTC",
  });

  useEffect(() => {
    const fetch = async () => {
      const Token = validateToken();

      let obj = localStorage.getItem("filtrosGerPeriodoUsuario");
      let page = localStorage.getItem("pageGerPeriodoUsuario");
      if (obj) {
        let novoFiltro = JSON.parse(obj);
        if (nCotaUsuarioId.cotaUsuarioId === 0) {
          setFilteredInfo({
            nomeUs: novoFiltro.nomeUs,
            nomeEP: novoFiltro.nomeEP,
            checkIn: novoFiltro.checkIn,
            checkOut: novoFiltro.checkOut,
            divulgado: novoFiltro.divulgado,
            valorMin: novoFiltro.valorMin,
            valorSugerido: novoFiltro.valorSugerido,
            valorSugeridoSistema: novoFiltro.valorSugeridoSistema,
            icone: novoFiltro.icone,
            situacao: novoFiltro.situacao,
          });
        } else {
          setFilteredInfo({
            checkIn: novoFiltro.checkIn,
            checkOut: novoFiltro.checkOut,
            dataEspecial: novoFiltro.dataEspecial,
            situacao: novoFiltro.situacao,
            divulgado: novoFiltro.divulgado,
            valorMin: novoFiltro.valorMin,
            valorSugerido: novoFiltro.valorSugerido,
            valorSugeridoSistema: novoFiltro.valorSugeridoSistema,
            icone: novoFiltro.icone,
          });
        }

        setSemFiltros(false);
      }
      if (page) {
        setCurrentPage(+page);
        setSemFiltros(false);
      }

      if (Token) {
        if (Token.nda === 0) {
          document.location.href = "/sempermissao";
        } else {
          const hoje = new Date().toLocaleDateString("pt-BR", {
            timeZone: "UTC",
          });

          if (Token) {
            let props = {};
            let URL;
            let arrayVelho = [{}];
            if (nCotaUsuarioId.cotaUsuarioId === 0) {
              URL = `${Globais.DOMINIOBACK}/periodo-usuario/alugueis/disponiveis/`;
              try {
                const response = await axios.post(URL, props, {
                  headers: { Authorization: Token.AuthStr },
                });
                if (response) {
                  arrayVelho = response.data;
                }
              } catch (error) {
                console.log(error);
              }
            } else {
              URL = `${Globais.DOMINIOBACK}/periodo-usuario/periodousuario/0/${nCotaUsuarioId.cotaUsuarioId}`;
              try {
                const response = await axios.get(URL, {
                  headers: { Authorization: Token.AuthStr },
                });
                if (response) {
                  arrayVelho = response.data;
                }
              } catch (error) {
                console.log(error);
              }
            }

            if (arrayVelho) {
              let divulgando = 0;
              let ArrayNovo = arrayVelho.filter(async (p: any) => {
                if (p.active === 0) {
                  return null;
                } else {
                  if (p.fracionamento === 0) {
                    p.key = nCotaUsuarioId.cotaUsuarioId === 0 ? p.idPEU : p.id;
                    p.id = nCotaUsuarioId.cotaUsuarioId === 0 ? p.idPEU : p.id;
                    p.periodoUsuarioId =
                      nCotaUsuarioId.cotaUsuarioId === 0 ? p.idPEU : p.id;
                    p.periodoId =
                      nCotaUsuarioId.cotaUsuarioId === 0
                        ? p.idPE
                        : p.PeriodoTable.id;
                    p.nomeUs = `${p.nomeUs} ${p.sobrenome}`;
                    p.checkIn =
                      nCotaUsuarioId.cotaUsuarioId === 0
                        ? formatarData(p.checkIn)
                        : formatarData(p.PeriodoTable.checkIn);
                    p.checkOut =
                      nCotaUsuarioId.cotaUsuarioId === 0
                        ? formatarData(p.checkOut)
                        : formatarData(p.PeriodoTable.checkOut);
                    p.valorSugerido = exibirMoeda(p.valorSugerido);

                    p.dataConfirmacao = p.dataConfirmacao
                      ? formatarData(p.dataConfirmacao)
                      : "";

                    if (nCotaUsuarioId.cotaUsuarioId === 0) {
                      if (p.valor) {
                        p.valorSugeridoSistema = await retornarValorAtualizado(
                          p.valor,
                          p.checkIn,
                          p.checkOut,
                          3
                        );
                      } else {
                        p.valorSugeridoSistema = "";
                        p.icone = "VERIFICAR";
                        contadorVerificar.current++;
                      }
                      switch (
                        VerificarPeriodo(
                          p.checkIn,
                          p.checkOut,
                          p.status,
                          p.alugar,
                          p.trocar,
                          p.concluido,
                          p.utilizar,
                          p.fase,
                          p.dataSugestao
                        )
                      ) {
                        case "VerificarNaoDefinido":
                          p.icone = "VERIFICAR";
                          contadorVerificar.current++;

                          break;
                        case "VerificarValor":
                          if (
                            p.valorSugeridoSistema !== "" &&
                            p.valorMin !== ""
                          ) {
                            let valorSomado =
                              +formatarMoeda(p.valorSugeridoSistema) + 51.0;
                            let valorReferencia =
                              +formatarMoeda(p.valorMin) + 1.0;

                            if (valorSomado < valorReferencia) {
                              p.icone = "VERIFICAR";
                              contadorVerificar.current++;
                            } else {
                            }
                          }

                          break;
                        case "ok":
                          break;
                      }

                      if (p.dataEspecial === null || p.dataEspecial === "") {
                        p.especial = "Data_normal";
                      } else {
                        p.especial = "Data_especial";
                      }

                      p.dataEspecial === null
                        ? (p.dataEspecial = "Data normal")
                        : (p.dataEspecial = p.dataEspecial);
                    } else {
                      if (p.PeriodoTable.valor) {
                        p.valorSugeridoSistema = await retornarValorAtualizado(
                          p.PeriodoTable.valor,
                          p.checkIn,
                          p.checkOut,
                          3
                        );
                      } else {
                        p.valorSugeridoSistema = "";
                      }
                      switch (
                        VerificarPeriodo(
                          p.checkIn,
                          p.checkOut,
                          p.status,
                          p.alugar,
                          p.trocar,
                          p.concluido,
                          p.utilizar,
                          p.fase,
                          p.dataSugestao
                        )
                      ) {
                        case "VerificarNaoDefinido":
                          p.icone = "VERIFICAR";
                          contadorVerificar.current++;

                          break;
                        case "VerificarValor":
                          if (
                            p.valorSugeridoSistema !== "" &&
                            p.valorMin !== ""
                          ) {
                            let valorSomado =
                              +formatarMoeda(p.valorSugeridoSistema) + 51.0;
                            let valorReferencia =
                              +formatarMoeda(p.valorMin) + 1.0;

                            if (valorSomado < valorReferencia) {
                              p.icone = "VERIFICAR";
                              contadorVerificar.current++;
                            } else {
                            }
                          }

                          break;
                        case "ok":
                          break;
                      }

                      if (
                        p.PeriodoTable.dataEspecial === null ||
                        p.PeriodoTable.dataEspecial === ""
                      ) {
                        p.especial = "Data_normal";
                      } else {
                        p.especial = "Data_especial";
                      }

                      p.PeriodoTable.dataEspecial === null
                        ? (p.dataEspecial = "Data normal")
                        : (p.dataEspecial = p.PeriodoTable.dataEspecial);
                    }
                    return p;
                  } else {
                    return null;
                  }
                }
              });

              ArrayNovo = arrayVelho.filter((p: any) => {
                if (p.active === 0) {
                  return null;
                } else {
                  if (p.fracionamento === 0) {
                    p.key = nCotaUsuarioId.cotaUsuarioId === 0 ? p.idPEU : p.id;
                    p.periodoUsuarioId =
                      nCotaUsuarioId.cotaUsuarioId === 0 ? p.idPEU : p.id;
                    if (validateDataCheckOutMaior(p.checkOut, hoje)) {
                      if (
                        p.status !== "FINALIZADO" &&
                        p.status !== "ALTERANDO"
                      ) {
                        let formData = {
                          status: "FINALIZADO",
                          periodoUsuario: p.id,
                          caso: 1,
                        };
                        atualizarPeriodoUsuario(formData);
                        p.status = "FINALIZADO";
                      }

                      if (p.concluido === 3) {
                        p.situacao = "Períodos fracionados reservados";
                        let formData = {
                          status: "FINALIZADO",
                          periodoUsuario:
                            nCotaUsuarioId.cotaUsuarioId === 0 ? p.idPEU : p.id,
                          caso: 1,
                        };
                        atualizarPeriodoUsuario(formData);
                        p.valorMin = "";
                      } else {
                        if (p.concluido === 2) {
                          p.situacao = "Reservado por MC";
                          p.valorMin = exibirMoeda(p.valorMin);
                          p.valorSugerido = "";
                        } else {
                          if (p.concluido === 1) {
                            p.situacao = "Reservado pelo próprio";
                            p.valorMin = exibirMoeda(p.valorMin);
                          } else {
                            if (p.utilizar === 1) {
                              p.situacao = "Será utilizado";
                              p.valorMin = "";
                              p.valorSugerido = "";
                            } else {
                              if (p.alugar === 1 && p.trocar === 1) {
                                p.situacao = "Alugar ou trocar";
                                p.valorMin = exibirMoeda(p.valorMin);
                              } else {
                                if (p.alugar === 0 && p.trocar === 1) {
                                  p.situacao = "Trocar";
                                  p.valorMin = "";
                                  p.valorSugerido = "";
                                } else {
                                  if (p.alugar === 1 && p.trocar === 0) {
                                    p.situacao = "Alugar";
                                    p.valorMin = exibirMoeda(p.valorMin);
                                  } else {
                                    p.situacao = "Não definido";
                                    p.valorMin = "";
                                    p.valorSugerido = "";
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    } else {
                      if (
                        (p.status === "ALTERANDO" &&
                          p.statusAnterior === "FRACAO_FINALIZADA") ||
                        p.status === "FRACAO_FINALIZADA"
                      ) {
                        p.situacao = "Alugado ou utilizado parcialmente";
                        p.valorMin = "";
                        p.valorSugerido = "";
                        p.icone = "PARCIAL";
                        p.tarefa = "Alugado ou utilizado parcialmente";
                      } else {
                        if (p.concluido === 3) {
                          p.situacao = "Períodos fracionados reservados";
                          let formData = {
                            status: "FINALIZADO",
                            periodoUsuario:
                              nCotaUsuarioId.cotaUsuarioId === 0
                                ? p.idPEU
                                : p.id,
                            caso: 1,
                          };
                          atualizarPeriodoUsuario(formData);
                          p.valorMin = "";
                        } else {
                          if (p.concluido === 2) {
                            p.situacao = "Reservado por MC";
                            p.valorMin = exibirMoeda(p.valorMin);
                            p.valorSugerido = "";
                          } else {
                            if (p.concluido === 1) {
                              p.situacao = "Reservado pelo próprio";
                              p.valorMin = exibirMoeda(p.valorMin);
                              // p.valorSugerido = exibirMoeda(p.valorSugerido);
                            } else {
                              if (p.utilizar === 1) {
                                p.situacao = "Será utilizado";
                                p.valorMin = "";
                                p.valorSugerido = "";
                              } else {
                                if (p.alugar === 1 && p.trocar === 1) {
                                  p.situacao = "Alugar ou trocar";
                                  if (
                                    p.alterado === 1 &&
                                    p.status !== "ALTERANDO" &&
                                    !(
                                      p.status === "AGUARDANDO_SUGESTAO" ||
                                      p.status === "AGUARDANDO_PEDIDO"
                                    )
                                  ) {
                                    p.status = "alterado";
                                    p.valorMin = exibirMoeda(p.valorMin);
                                    // p.valorSugerido = exibirMoeda(
                                    //   p.valorSugerido
                                    // );
                                    p.tarefa = "Período recém alterado";
                                  } else {
                                    if (
                                      p.status === "AGUARDANDO_SUGESTAO" ||
                                      p.status === "AGUARDANDO_PEDIDO"
                                    ) {
                                      p.valorMin = exibirMoeda(p.valorMin);
                                      // p.valorSugerido = exibirMoeda(
                                      //   p.valorSugerido
                                      // );
                                    } else {
                                      p.valorMin = exibirMoeda(p.valorMin);
                                      // p.valorSugerido = exibirMoeda(
                                      //   p.valorSugerido
                                      // );
                                    }
                                  }
                                } else {
                                  if (p.alugar === 1 && p.trocar === 0) {
                                    p.situacao = "Alugar";
                                    if (
                                      p.alterado === 1 &&
                                      p.status !== "ALTERANDO"
                                    ) {
                                      p.status = "alterado";
                                      p.valorMin = exibirMoeda(p.valorMin);
                                      // p.valorSugerido = exibirMoeda(
                                      //   p.valorSugerido
                                      // );
                                      p.tarefa = "Período recém alterado";
                                    } else {
                                      if (
                                        p.status === "AGUARDANDO_SUGESTAO" ||
                                        p.status === "AGUARDANDO_PEDIDO"
                                      ) {
                                        p.valorMin = exibirMoeda(p.valorMin);
                                        // p.valorSugerido = exibirMoeda(
                                        //   p.valorSugerido
                                        // );
                                      } else {
                                        p.valorMin = exibirMoeda(p.valorMin);
                                        // p.valorSugerido = exibirMoeda(
                                        //   p.valorSugerido
                                        // );
                                      }
                                    }
                                  } else {
                                    if (p.alugar === 0 && p.trocar === 1) {
                                      p.situacao = "Trocar";
                                      p.valorMin = "";
                                      p.valorSugerido = "";
                                    } else {
                                      p.situacao = "Não definido";
                                      p.valorMin = "";
                                      p.valorSugerido = "";
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                    if (p.status === "ALTERANDO") {
                      if (
                        p.statusAnterior === "REJEITADO" ||
                        p.statusAnterior === "NAO_PERTUBE"
                      ) {
                        p.tarefa =
                          "Proposta recusada. Não precisa fazer nada. Verifique outros períodos e clique em confirmar. ";
                      } else {
                        if (
                          p.concluido === 1 ||
                          p.utilizar === 1 ||
                          p.statusAnterior === "NAO_FRACIONE"
                        ) {
                          if (p.divulgado === "Não" || p.divulgado === 0) {
                            p.tarefa =
                              "Período não divulgado. Não precisa fazer nada. Verifique outros períodos e clique em confirmar.";
                          } else {
                            p.tarefa =
                              "Retirar anúncio e APÓS clique em confirmar alterações.";
                          }
                        } else {
                          if (p.active === 3) {
                            p.tarefa =
                              "Retirar anúncio e APÓS clique em confirmar alterações.";
                          } else {
                            if (
                              p.situacao === "Alugado ou utilizado parcialmente"
                            ) {
                              if (p.divulgado === "Sim" || p.divulgado === 1) {
                                p.tarefa =
                                  "Retirar o anúncio para os 7 dias, pois o proprietário, agora, só está alugando parte do período.";
                              } else {
                                p.tarefa =
                                  "Período não divulgado. Não precisa fazer nada. Verifique outros períodos e clique em confirmar.";
                              }
                            } else {
                              if (p.divulgado === "Não" || p.divulgado === 0) {
                                p.tarefa =
                                  "Proposta aceita, mas período não divulgado. Verifique se com o novo valor o período deve ser anunciado. APÓS clique em confirmar alterações.";
                              } else {
                                p.tarefa =
                                  "Proposta aceita e período divulgado. Altere valor anunciado e APÓS clique em confirmar alterações.";
                              }
                            }
                          }
                        }
                      }
                    }
                    if (p.divulgado === 0) {
                      p.divulgado = "Não";
                    } else {
                      if (p.divulgado === 1) {
                        p.divulgado = "Sim";
                      }
                    }
                    if (
                      p.status === "AGUARDANDO_SUGESTAO" ||
                      p.status === "AGUARDANDO_PEDIDO"
                    ) {
                      // p.valorSugerido = exibirMoeda(p.valorSugerido);
                    }
                    if (p.valorSugerido === "0") {
                      p.valorSugerido = "";
                    }
                    if (nCotaUsuarioId.cotaUsuarioId !== 0) {
                      if (p.PeriodoTable.valor) {
                        p.valor = p.PeriodoTable.valor;
                      }
                    }

                    //quando está prestes a cancelar período. Quando o proprietário informa que vendeu a cota e basta o administrador confirmar as alterções.
                    if (p.active === 3) {
                      p.situacao = "Cancelando";
                      contador.current++;
                    }
                    //quando está prestes a cancelar período. Quando o proprietário, de empreendimento sem cronograma retira período que estava divulgado.
                    if (p.active === 4) {
                      p.situacao = "Cancelando";
                      contador.current++;
                    }
                    if (p.status === "ALTERANDO" && p.divulgado === "Sim") {
                      p.icone = "ALTERANDO_DIVULGADO";
                      contadorAlterando.current++;
                      divulgando = 1;
                    } else {
                      if (p.status === "ALTERANDO" && p.divulgado === "Não") {
                        p.icone = "ALTERADO";
                        contadorAlterado.current++;
                      } else {
                        if (p.alterado === 1) {
                          p.icone = "ALTERADO";
                          contadorAlterado.current++;
                        } else {
                          if (nCotaUsuarioId.cotaUsuarioId !== 0) {
                            if (p.PeriodoTable.valor) {
                              p.valor = p.PeriodoTable.valor;
                            }
                          }

                          if (
                            p.status === "AGUARDANDO_SUGESTAO" ||
                            p.status === "AGUARDANDO_PEDIDO"
                          ) {
                            if (p.status === "AGUARDANDO_PEDIDO") {
                              p.icone = "AGUARDANDO_PEDIDO";
                              contadorAguardando.current++;
                              p.tarefa =
                                "Aguardando confirmação de pedido do proprietário";
                            } else {
                              if (p.status === "AGUARDANDO_SUGESTAO") {
                                p.icone = "AGUARDANDO_SUGESTAO";
                                contadorAguardando.current++;
                                p.tarefa = `Aguardando confirmação de sugestão ao proprietário - Data: ${formatarData(
                                  p.dataSugestao
                                )}`;
                              }
                            }
                          } else {
                            if (p.status === "DELEGADO") {
                              p.icone = "DELEGADO";
                            } else {
                              if (p.status === "NAO_PERTUBE") {
                                p.icone = "NAO_PERTUBE";
                              } else {
                                if (p.status === "FINALIZADO") {
                                  p.icone = "FINALIZADO";
                                } else {
                                  if (p.status === "SEM_STATUS") {
                                    p.icone = "SEM_STATUS";
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                    let contadorUtilizado = 0;
                    let contadorTrocar = 0;
                    let contadorReservados = 0;
                    let ArrayChildren = arrayVelho.filter(async (q: any) => {
                      if (
                        q.fracionamento === p.periodoUsuarioId &&
                        q.active !== 0
                      ) {
                        let valorSugeridoSistema;
                        q.key =
                          nCotaUsuarioId.cotaUsuarioId === 0 ? q.idPEU : q.id;
                        q.id =
                          nCotaUsuarioId.cotaUsuarioId === 0 ? q.idPEU : q.id;

                        if (nCotaUsuarioId.cotaUsuarioId === 0) {
                          if (p.valor) {
                            valorSugeridoSistema =
                              await retornarValorAtualizado(
                                p.valor,
                                p.checkIn,
                                p.checkOut,
                                3
                              );
                          }

                          if (
                            p.dataEspecial === null ||
                            p.dataEspecial === ""
                          ) {
                            q.especial = "Data_normal";
                            q.dataEspecial = "Data_normal";
                          } else {
                            q.especial = "Data_especial";
                            q.dataEspecial = p.dataEspecial;
                          }
                        } else {
                          if (p.PeriodoTable.valor) {
                            valorSugeridoSistema =
                              await retornarValorAtualizado(
                                p.PeriodoTable.valor,
                                p.checkIn,
                                p.checkOut,
                                3
                              );
                          }

                          if (
                            p.PeriodoTable.dataEspecial === null ||
                            p.PeriodoTable.dataEspecial === ""
                          ) {
                            q.especial = "Data_normal";
                            q.dataEspecial = "Data_normal";
                          } else {
                            q.especial = "Data_especial";
                            q.dataEspecial = p.dataEspecial;
                          }
                        }
                        if (valorSugeridoSistema) {
                          q.valorSugeridoSistema =
                            await retornarValorAtualizado(
                              valorSugeridoSistema,
                              q.checkIn,
                              q.checkOut,
                              3
                            );
                        }
                        switch (
                          VerificarPeriodo(
                            q.checkIn,
                            q.checkOut,
                            q.status,
                            q.alugar,
                            q.trocar,
                            q.concluido,
                            q.utilizar,
                            q.fase,
                            q.dataSugestao
                          )
                        ) {
                          case "VerificarNaoDefinido":
                            q.icone = "VERIFICAR";
                            break;
                          case "VerificarValor":
                            if (
                              q.valorSugeridoSistema !== "" &&
                              q.valorMin !== ""
                            ) {
                              let valorSomado =
                                +formatarMoeda(q.valorSugeridoSistema) + 51.0;
                              let valorReferencia =
                                +formatarMoeda(q.valorMin) + 1.0;

                              if (valorSomado < valorReferencia) {
                                q.icone = "VERIFICAR";
                              } else {
                              }
                            }

                            break;
                          case "ok":
                            break;
                        }

                        if (
                          validateDataCheckOutMaior(
                            formatarData(q.checkOut),
                            hoje
                          )
                        ) {
                          if (
                            q.status !== "FINALIZADO" &&
                            q.status !== "ALTERANDO"
                          ) {
                            let formData = {
                              status: "FINALIZADO",
                              periodoUsuario: q.id,
                              caso: 1,
                            };

                            atualizarPeriodoUsuario(formData);
                            q.status = "FINALIZADO";
                          }
                        }

                        return q;
                      } else {
                        return null;
                      }
                    });

                    ArrayChildren = arrayVelho.filter((q: any) => {
                      if (
                        q.fracionamento === p.periodoUsuarioId &&
                        q.active !== 0
                      ) {
                        q.key =
                          nCotaUsuarioId.cotaUsuarioId === 0 ? q.idPEU : q.id;
                        q.id =
                          nCotaUsuarioId.cotaUsuarioId === 0 ? q.idPEU : q.id;
                        q.nomeUs = `${q.nomeUs} ${q.sobrenome}`;
                        q.valorMin = exibirMoeda(q.valorMin);
                        q.valorSugerido = exibirMoeda(q.valorSugerido);
                        q.periodoId =
                          nCotaUsuarioId.cotaUsuarioId === 0
                            ? q.idPE
                            : q.PeriodoTable.id;
                        q.periodoUsuarioId =
                          nCotaUsuarioId.cotaUsuarioId === 0 ? q.idPEU : q.id;
                        q.valorMinNumber = q.valorMin;
                        q.checkIn =
                          nCotaUsuarioId.cotaUsuarioId === 0
                            ? formatarData(q.checkIn)
                            : formatarData(q.PeriodoTable.checkIn);
                        q.checkOut =
                          nCotaUsuarioId.cotaUsuarioId === 0
                            ? formatarData(q.checkOut)
                            : formatarData(q.PeriodoTable.checkOut);
                        if (q.concluido === 2) {
                          q.situacao = "Reservado por MC";
                          contadorReservados++;
                          q.valorSugerido = "";
                          if (
                            q.status !== "FINALIZADO" &&
                            q.status !== "ALTERANDO"
                          ) {
                            let formData = {
                              status: "FINALIZADO",
                              periodoUsuario:
                                nCotaUsuarioId.cotaUsuarioId === 0
                                  ? q.idPEU
                                  : q.id,
                            };

                            atualizarPeriodoUsuario(formData);
                            q.status = "FINALIZADO";
                          }
                        } else {
                          if (q.concluido === 1) {
                            q.situacao = "Reservado pelo próprio";
                            contadorReservados++;
                            q.valorSugerido = "";
                            if (
                              q.status !== "FINALIZADO" &&
                              q.status !== "ALTERANDO"
                            ) {
                              let formData = {
                                status: "FINALIZADO",
                                periodoUsuario:
                                  nCotaUsuarioId.cotaUsuarioId === 0
                                    ? q.idPEU
                                    : q.id,
                                caso: 1,
                              };

                              atualizarPeriodoUsuario(formData);
                              q.status = "FINALIZADO";
                            }
                          } else {
                            if (q.utilizar === 1) {
                              q.situacao = "Será utilizado";
                              q.valorMin = "";
                              q.valorSugerido = "";
                              contadorUtilizado++;
                              if (
                                q.status !== "FINALIZADO" &&
                                q.status !== "ALTERANDO"
                              ) {
                                let formData = {
                                  status: "FINALIZADO",
                                  periodoUsuario:
                                    nCotaUsuarioId.cotaUsuarioId === 0
                                      ? q.idPEU
                                      : q.id,
                                  caso: 1,
                                };

                                atualizarPeriodoUsuario(formData);
                                q.status = "FINALIZADO";
                              }
                            } else {
                              if (q.alugar === 1 && q.trocar === 1) {
                                q.situacao = "Alugar ou trocar";
                                if (
                                  q.alterado === 1 &&
                                  q.status !== "ALTERANDO"
                                ) {
                                  q.status = "alterado";
                                } else {
                                  if (
                                    q.status === "AGUARDANDO_SUGESTAO" ||
                                    q.status === "AGUARDANDO_PEDIDO"
                                  ) {
                                  } else {
                                  }
                                }
                              } else {
                                if (q.alugar === 1 && q.trocar === 0) {
                                  q.situacao = "Alugar";
                                  if (
                                    q.alterado === 1 &&
                                    q.status !== "ALTERANDO"
                                  ) {
                                    q.status = "alterado";
                                  } else {
                                    if (
                                      q.status === "AGUARDANDO_SUGESTAO" ||
                                      q.status === "AGUARDANDO_PEDIDO"
                                    ) {
                                    } else {
                                    }
                                  }
                                } else {
                                  if (q.alugar === 0 && q.trocar === 1) {
                                    q.situacao = "Trocar";
                                    q.valorMin = "";
                                    q.valorSugerido = "";
                                    contadorTrocar++;
                                  } else {
                                    q.situacao = "Não definido";
                                    q.valorMin = "";
                                    q.valorSugerido = "";
                                  }
                                }
                              }
                            }
                          }
                        }
                        if (q.status === "ALTERANDO") {
                          if (
                            q.statusAnterior === "REJEITADO" ||
                            q.statusAnterior === "NAO_PERTUBE"
                          ) {
                            q.tarefa =
                              "Proposta recusada. Não precisa fazer nada. Verifique outros períodos e clique em confirmar. ";
                          } else {
                            if (q.statusAnterior === "NAO_FRACIONE") {
                              if (q.divulgado === "Não" || q.divulgado === 0) {
                                q.tarefa =
                                  "Período não divulgado. Não precisa fazer nada. Verifique outros períodos e clique em confirmar.";
                                q.situacao = "Cancelando";
                              } else {
                                q.tarefa =
                                  "Retirar anúncio e APÓS clique em confirmar alterações.";
                                q.situacao = "Cancelando";
                              }
                            } else {
                              if (q.divulgado === "Não" || q.divulgado === 0) {
                                q.tarefa =
                                  "Proposta aceita, mas período não divulgado. Verifique se, com o novo valor, ele deverá ser anunciado e APÓS clique em confirmar alterações.";
                              } else {
                                if (q.active === 3) {
                                  q.tarefa =
                                    "Retirar anúncio e APÓS clique em confirmar alterações.";
                                  q.situacao = "cancelando";
                                } else {
                                  q.tarefa =
                                    "Proposta aceita e período divulgado. Altere valor anunciado e APÓS clique em confirmar alterações.";
                                }
                              }
                              if (q.active === 3) {
                                q.situacao = "Cancelando";
                                contador.current++;
                              }
                            }
                          }
                        }
                        if (q.divulgado === 0) {
                          q.divulgado = "Não";
                        } else {
                          if (q.divulgado === 1) {
                            q.divulgado = "Sim";
                          }
                        }
                        if (q.valorSugerido === "0") {
                          q.valorSugerido = "";
                        }
                        if (nCotaUsuarioId.cotaUsuarioId !== 0) {
                          q.dataEspecial = q.PeriodoTable.dataEspecial;
                        }
                        if (
                          q.status === "ALTERANDO" &&
                          (q.divulgado === "Sim" ||
                            p.icone === "ALTERANDO_DIVULGADO" ||
                            divulgando === 1)
                        ) {
                          q.icone = "ALTERANDO_DIVULGADO";
                          p.icone = "ALTERANDO_DIVULGADO";

                          divulgando = 1;
                        } else {
                          if (
                            q.status === "ALTERANDO" &&
                            q.divulgado === "Não" &&
                            p.icone !== "ALTERANDO_DIVULGADO"
                          ) {
                            q.icone = "ALTERADO";
                          } else {
                            if (
                              q.alterado === 1 &&
                              p.icone !== "ALTERANDO_DIVULGADO"
                            ) {
                              q.icone = "ALTERADO";
                            } else {
                              if (nCotaUsuarioId.cotaUsuarioId !== 0) {
                                if (q.PeriodoTable.valor) {
                                  q.valor = q.PeriodoTable.valor;
                                }
                              }

                              if (
                                q.status === "AGUARDANDO_SUGESTAO" ||
                                q.status === "AGUARDANDO_PEDIDO"
                              ) {
                                if (q.status === "AGUARDANDO_PEDIDO") {
                                  q.icone = "AGUARDANDO_PEDIDO";
                                  q.tarefa =
                                    "Aguardando confirmação de pedido do proprietário";
                                } else {
                                  if (q.status === "AGUARDANDO_SUGESTAO") {
                                    q.icone = "AGUARDANDO_SUGESTAO";
                                    q.tarefa =
                                      "Aguardando confirmação de sugestão ao proprietário";
                                  }
                                }
                              } else {
                                if (q.status === "DELEGADO") {
                                  q.icone = "DELEGADO";
                                } else {
                                  if (q.status === "NAO_PERTUBE") {
                                    q.icone = "NAO_PERTUBE";
                                  } else {
                                    if (q.status === "FINALIZADO") {
                                      q.icone = "FINALIZADO";
                                    } else {
                                      if (q.status === "SEM_STATUS") {
                                        q.icone = "SEM_STATUS";
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                        return q;
                      } else {
                        return null;
                      }
                    });
                    if (ArrayChildren.length !== 0) {
                      p.children = ArrayChildren;
                      if (p.status !== "ALTERANDO") {
                        if (contadorReservados === 2) {
                          p.situacao = "Períodos fracionados reservados";
                          let formData = {
                            status: "FINALIZADO",
                            periodoUsuario:
                              nCotaUsuarioId.cotaUsuarioId === 0
                                ? p.idPEU
                                : p.id,
                            caso: 1,
                          };

                          atualizarPeriodoUsuario(formData);
                          p.valorMin = "";
                          p.valorSugerido = "";
                          p.status = "FINALIZADO";
                        } else {
                          if (contadorUtilizado === 2) {
                            p.situacao = "Será utilizado";
                            let formData = {
                              status: "FINALIZADO",
                              periodoUsuario:
                                nCotaUsuarioId.cotaUsuarioId === 0
                                  ? p.idPEU
                                  : p.id,
                              caso: 1,
                            };

                            atualizarPeriodoUsuario(formData);
                            p.valorMin = "";
                            p.valorSugerido = "";
                            p.status = "FINALIZADO";
                          } else {
                            if (contadorTrocar === 2) {
                              p.situacao = "Trocar";
                              p.valorMin = "";
                              p.valorSugerido = "";
                            } else {
                              if (
                                contadorUtilizado === 1 ||
                                contadorReservados === 1
                              ) {
                                p.situacao =
                                  "Alugado ou utilizado parcialmente";
                                p.valorMin = "";
                                p.valorSugerido = "";
                              } else {
                                if (contadorTrocar === 1) {
                                  p.situacao = "Há frações com situação troca";
                                  p.valorMin = "";
                                  p.valorSugerido = "";
                                }
                              }
                            }
                          }
                        }
                      }
                      if (p.icone === "ALTERANDO_DIVULGADO") {
                        p.children.filter((z: any) => {
                          z.icone = "ALTERANDO_DIVULGADO";
                          return z;
                        });
                      }
                    }

                    return p;
                  } else {
                    return null;
                  }
                }
              });

              nCotaUsuarioId.cotaUsuarioId === 0
                ? setAluguel(ArrayNovo)
                : setPeriodoData(ArrayNovo);

              setIsLoading(false);
            }
          } else {
            document.location.href = "/login";
          }
        }
      }
    };

    fetch();
  }, []);

  const showModal = () => {
    setOpenExcluir(true);
  };

  const hideModal = () => {
    setOpenExcluir(false);
  };

  const CollectionCreateFormValoresAnunciado: React.FC<
    CollectionCreateFormPropsValoresAnunciado
  > = ({ open, onCreate, onCancel }) => {
    const [form] = Form.useForm();

    const dias = CalcularDiferencaDias(
      AlterarFormatoData(checkOutPeriodo.current),
      AlterarFormatoData(checkInPeriodo.current)
    );

    let valorAntigo;
    let novoValor;
    let valorAntigo2;

    if (statusAtual.current === "ALTERANDO") {
      valorAntigo = valorSugerido.current;
    } else {
      valorAntigo = valor.current;
    }
    if (valorAntigo) {
      valorAntigo2 = valorAntigo.replace(".", "");
    }

    if (valorAntigo2) {
      novoValor = parseInt(valorAntigo2);
    }

    let diaria;
    if (novoValor) {
      diaria = novoValor / dias;
    }

    let valorDiariaAjustada;
    if (novoValor) {
      diariaExibida.current = `R$ ${exibirMoeda(
        (novoValor / dias).toString()
      )}`;
    }

    if (diaria) {
      valorDiariaAjustada = diaria * (1 + 0.181);
    }

    if (valorDiariaAjustada) {
      valorDiariaAjustadaExibida.current = `R$ ${exibirMoeda(
        valorDiariaAjustada.toString()
      )}`;
    }
    if (novoValor) {
      novoValorAirbnb.current = novoValor * (1 + 0.3386);
      diariaAirbnb.current = novoValorAirbnb.current / dias;

      // Ajuste com acréscimo de 41,7079% para campanhas de marketing
      novoValorParcelado.current = (novoValor * (1 + 0.47392)) / 12;

      novoValorBooking.current = novoValor * (1 + 0.3131);
      diariaBooking.current = novoValorBooking.current / dias;

      novoValorDecolar.current = novoValor * (1 + 0.3386);
      diariaDecolar.current = novoValorDecolar.current / dias;

      novoValorExpedia.current = novoValor * (1 + 0.3506);
      diariaExpedia.current = novoValorExpedia.current / dias;
    }

    const onChange = (e: RadioChangeEvent) => {
      setValueValoresAnunciado(e.target.value);
    };

    return (
      <Modal
        open={openValoresAnunciado}
        title="Valores"
        okText="Ok"
        cancelText="Cancelar"
        onCancel={onCancel}
        onOk={onCancel}
      >
        <Form form={form} layout="vertical">
          <Row gutter={[16, 16]} align="middle">
            <Col span={6}>
              <p style={{ textAlign: "center", fontWeight: "bold" }}>
                Valor Cotista
              </p>
              <p style={{ textAlign: "center" }}>{`R$ ${valorAntigo}`}</p>
            </Col>

            <Col span={6}>
              <p style={{ textAlign: "center", fontWeight: "bold" }}>
                Parcelado 12x
              </p>
              <p style={{ textAlign: "center" }}>{`R$ ${exibirMoeda(
                novoValorParcelado.current.toString()
              )}`}</p>
            </Col>

            <Col span={4}>
              <p style={{ textAlign: "center", fontWeight: "bold" }}>
                Qtd Dias
              </p>
              <p style={{ textAlign: "center" }}>{dias}</p>
            </Col>

            <Col span={8}>
              <p style={{ textAlign: "center", fontWeight: "bold" }}>
                Valor na Stays
              </p>
              <p style={{ textAlign: "center" }}>
                {valorDiariaAjustadaExibida.current}
              </p>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={20}>
              <p>Valor Diária</p>
              <p>{` ${diariaExibida.current}`}</p>
            </Col>
            <Col span={4}></Col>
          </Row>
          <Row
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            gutter={17}
          >
            <Radio.Group onChange={onChange} value={valueValoresAnunciado}>
              <Radio value={1}>Airbnb</Radio>
              <Radio value={2}>Booking</Radio>
              <Radio value={3}>Decolar</Radio>
              <Radio value={4}>Expedia</Radio>
            </Radio.Group>
          </Row>
          <Row gutter={16}>
            {valueValoresAnunciado === 1 ? (
              <>
                <Col span={2}></Col>
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  span={11}
                >
                  <p>Valor Airbnb</p>
                  <p>{`R$ ${exibirMoeda(
                    novoValorAirbnb.current.toString()
                  )}`}</p>
                </Col>
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  span={6}
                >
                  <p>Diária Airbnb</p>
                  <p>{`R$ ${exibirMoeda(diariaAirbnb.current.toString())}`}</p>
                </Col>
                <Col span={6}></Col>
              </>
            ) : valueValoresAnunciado === 2 ? (
              <>
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  span={12}
                >
                  <p>Valor Booking</p>
                  <p>{`R$ ${exibirMoeda(
                    novoValorBooking.current.toString()
                  )}`}</p>
                </Col>
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  span={10}
                >
                  <p>Diária Booking</p>
                  <p>{`R$ ${exibirMoeda(diariaBooking.current.toString())}`}</p>
                </Col>
              </>
            ) : valueValoresAnunciado === 3 ? (
              <>
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  span={12}
                >
                  <p>Valor Decolar</p>
                  <p>{`R$ ${exibirMoeda(
                    novoValorDecolar.current.toString()
                  )}`}</p>
                </Col>
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  span={10}
                >
                  <p>Diária Decolar</p>
                  <p>{`R$ ${exibirMoeda(diariaDecolar.current.toString())}`}</p>
                </Col>
              </>
            ) : valueValoresAnunciado === 4 ? (
              <>
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  span={12}
                >
                  <p>Valor Expedia </p>
                  <p>{`R$ ${exibirMoeda(
                    novoValorExpedia.current.toString()
                  )}`}</p>
                </Col>
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  span={10}
                >
                  <p>Diária Expedia</p>
                  <p>{`R$ ${exibirMoeda(diariaExpedia.current.toString())}`}</p>
                </Col>
              </>
            ) : null}
          </Row>
        </Form>
      </Modal>
    );
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): ColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 100 }}
          >
            Pesquisar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Limpar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  // const filteredInfo = {
  //   icone: ['ALTERANDO_DIVULGADO'],
  // }

  // console.log(filtered.icone);
  // console.log(filtered.icone);

  const columns: ColumnsType<DataType> = [
    {
      title: "Check-In",
      dataIndex: "checkIn",
      key: "checkIn",
      filteredValue: filteredInfo.checkIn,

      ...getColumnSearchProps("checkIn"),
    },

    {
      title: "Check-Out",
      dataIndex: "checkOut",
      key: "checkOut",
      filteredValue: filteredInfo.checkOut,

      ...getColumnSearchProps("checkOut"),
    },
    {
      title: "",
      dataIndex: "especial",
      key: "especial",
      width: "5%",
      align: "center",
      filteredValue: filteredInfo.especial,
      filters: [
        { text: "Data especial", value: "Data_especial" },

        { text: "Data normal", value: "Data_normal" },
      ],

      onFilter: (value: any, record) => record.especial.includes(value),
      filterSearch: true,

      render: (item, row) =>
        row.especial === "Data_especial" ? (
          <Tooltip title={row.dataEspecial}>
            <StarsIcon color="warning" />
          </Tooltip>
        ) : row.especial === "Data_normal" ? (
          <Tooltip title={"Não é uma data especial."}>
            <HideSourceIcon sx={{ color: grey[500] }} />
          </Tooltip>
        ) : null,
    },

    {
      title: "Situação",
      dataIndex: "situacao",
      key: "situacao",
      width: "15%",
      filteredValue: filteredInfo.situacao,

      filters: [
        { text: "Alugar", value: "Alugar" },
        { text: "Trocar", value: "Trocar" },
        { text: "Alugar ou Trocar", value: "Alugar ou trocar" },
        { text: "Será utilizado", value: "Será utilizado" },
        { text: "Reservado por MC", value: "Reservado por MC" },
        { text: "Reservado pelo próprio", value: "Reservado pelo próprio" },
        { text: "Não definido", value: "Não definido" },
        {
          text: "Alugado ou utilizado parcialmente",
          value: "Alugado ou utilizado parcialmente",
        },
        {
          text: "Períodos fracionados reservados",
          value: "Períodos fracionados reservados",
        },
        {
          text: "NÃO alterar valor anunciado",
          value: "NÃO alterar valor anunciado",
        },
        {
          text: "Alterar valor anunciado",
          value: "Alterar valor anunciado",
        },
        {
          text: "Retirar anúncio",
          value: "Retirar anúncio",
        },
      ],
      onFilter: (value: any, record) => record.situacao.includes(value),
      filterSearch: true,
    },
    {
      title: "Divulgado",
      dataIndex: "divulgado",
      key: "divulgado",
      width: "10%",
      filteredValue: filteredInfo.divulgado,

      filters: [
        { text: "Sim", value: "Sim" },
        { text: "Não", value: "Não" },
      ],
      onFilter: (value: any, record) => record.divulgado.includes(value),
      filterSearch: true,
    },

    {
      title: "Valor confirmado",
      dataIndex: "valorMin",
      key: "valorMin",
      width: "10%",
      filteredValue: filteredInfo.valorMin,
    },
    {
      title: "Data Confirmação",
      dataIndex: "dataConfirmacao",
      key: "dataConfirmacao",
      width: "10%",
      filteredValue: filteredInfo.dataConfirmacao,
    },
    {
      title: "Valor prévio",
      dataIndex: "valorSugerido",
      key: "valorSugerido",
      width: "10%",
      filteredValue: filteredInfo.valorSugerido,
    },
    {
      title: "Valor sugerido",
      dataIndex: "valorSugeridoSistema",
      key: "valorSugeridoSistema",
      width: "10%",
      filteredValue: filteredInfo.valorSugeridoSistema,
    },

    {
      title: "Status",
      dataIndex: "icone",
      key: "icone",
      width: "8%",

      filters: [
        { text: "Sem status", value: "SEM_STATUS" },
        { text: "Alterando", value: "ALTERANDO_DIVULGADO" },

        {
          text: "Aguardando confirmação de sugestão",
          value: "AGUARDANDO_SUGESTAO",
        },
        {
          text: "Aguardando confirmação de pedido",
          value: "AGUARDANDO_PEDIDO",
        },
        { text: "Delegado", value: "DELEGADO" },
        { text: "Não pertube", value: "NAO_PERTUBE" },
        { text: "Verificar", value: "VERIFICAR" },
        { text: "Finalizado", value: "FINALIZADO" },
        { text: "Alterado", value: "ALTERADO" },
        { text: "Alugado Parcialmente", value: "FRACAO_FINALIZADA" },
      ],
      onFilter: (value: any, record) => record.icone.includes(value),
      filterSearch: true,
      filteredValue: filteredInfo.icone,
      render: (item, row) =>
        row.icone === "ALTERANDO_DIVULGADO" ? (
          <Tooltip title={row.tarefa}>
            <ChangeCircleIcon style={{ color: "red" }} />
          </Tooltip>
        ) : row.icone === "AGUARDANDO_SUGESTAO" ||
          row.icone === "AGUARDANDO_PEDIDO" ? (
          <Tooltip title={row.tarefa}>
            <PauseCircleOutlineIcon color="warning" />
          </Tooltip>
        ) : row.icone === "DELEGADO" ? (
          <Tooltip title="Proprietário delegou a gestão ao Multicotas">
            <PersonOffIcon color="primary" />
          </Tooltip>
        ) : row.icone === "SEM_STATUS" ? (
          <Tooltip title="Período sem status">
            <SentimentVeryDissatisfiedIcon sx={{ color: grey[900] }} />
          </Tooltip>
        ) : row.icone === "NAO_PERTUBE" ? (
          <Tooltip title="Não devemos fazer sugestões">
            {/* <SentimentVeryDissatisfiedIcon color="primary" /> */}
            <DoDisturbOnIcon sx={{ color: red[900] }} />
          </Tooltip>
        ) : row.icone === "VERIFICAR" ? (
          <Tooltip title="Esse período deve ser verificado">
            <WarningAmberIcon sx={{ color: red[900] }} />
          </Tooltip>
        ) : row.icone === "FINALIZADO" ? (
          <Tooltip title="Finalizado">
            <CheckCircleOutlineIcon color="success" />
          </Tooltip>
        ) : row.icone === "ALTERADO" ? (
          <Tooltip title={row.tarefa}>
            <CloudSyncTwoToneIcon color="success" />
          </Tooltip>
        ) : row.icone === "PARCIAL" ? (
          <Tooltip title={row.tarefa}>
            <BatteryCharging50Icon color="success" />
          </Tooltip>
        ) : null,
    },

    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",

      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                situacao.current = row.situacao;
                divulgado.current = row.divulgado;
                periodoUsuario.current = row.id;
                periodo.current = row.periodoId;
                valor.current = row.valorMin;
                valorSugerido.current = row.valorSugerido;
                valorSugeridoSistema.current = row.valorSugeridoSistema;
                fracionamento.current = row.fracionamento;
                statusAtual.current = row.status;
                statusAnterior.current = row.statusAnterior;
                dataSugestao.current = row.dataSugestao;
                active.current = +row.active;
                specialDate.current = row.especial;
                checkInPeriodo.current = row.checkIn;
                alterando.current = row.alterado;

                checkOutPeriodo.current = row.checkOut;
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];

  const onChange: TableProps<DataType>["onChange"] = (
    pagination,
    filters,
    sorter,
    extra
  ) => {
    setFilteredInfo({
      checkIn: filters.checkIn,
      checkOut: filters.checkOut,
      dataEspecial: filters.dataEspecial,
      situacao: filters.situacao,
      divulgado: filters.divulgado,
      valorMin: filters.valorMin,
      valorSugerido: filters.valorSugerido,
      valorSugeridoSistema: filters.valorSugeridoSistema,
      icone: filters.icone,
    });
    if (pagination.current) {
      let page = pagination.current.toString();
      localStorage.setItem("pageGerPeriodoUsuario", page);
    }

    localStorage.setItem("filtrosGerPeriodoUsuario", JSON.stringify(filters));
    setSemFiltros(false);
  };
  const onChangeAlugueis: TableProps<DataType>["onChange"] = (
    pagination,
    filters,
    sorter,
    extra
  ) => {
    setFilteredInfo({
      nomeUs: filters.nomeUs,
      nomeEP: filters.nomeEP,
      checkIn: filters.checkIn,
      checkOut: filters.checkOut,
      dataEspecial: filters.dataEspecial,
      situacao: filters.situacao,
      divulgado: filters.divulgado,
      valorMin: filters.valorMin,
      valorSugerido: filters.valorSugerido,
      valorSugeridoSistema: filters.valorSugeridoSistema,
      icone: filters.icone,
    });

    if (pagination.current) {
      let page = pagination.current.toString();
      localStorage.setItem("pageGerPeriodoUsuario", page);
    }

    localStorage.setItem("filtrosGerPeriodoUsuario", JSON.stringify(filters));
    setSemFiltros(false);
  };

  const criarPeriodosFracionados = async (valuesFracao: any) => {
    setOpenFracao(false);
    const Token = validateToken();

    if (valuesFracao.checkIn1 === undefined) {
      valuesFracao.checkIn1 = checkInPeriodo.current;
    }
    if (valuesFracao.checkOut1 === undefined) {
      valuesFracao.checkOut1 = sugestaoCheckOut;
    }
    if (valuesFracao.checkIn2 === undefined) {
      valuesFracao.checkIn2 = sugestaoCheckOut;
    }
    if (valuesFracao.checkOut2 === undefined) {
      valuesFracao.checkOut2 = checkOutPeriodo.current;
    }
    checkInPrimeiroPeriodo.current = valuesFracao.checkIn1;
    checkOutPrimeiroPeriodo.current = valuesFracao.checkOut1;
    checkInSegundoPeriodo.current = valuesFracao.checkIn2;
    checkOutSegundoPeriodo.current = valuesFracao.checkOut2;
    valorPrimeiroPeriodo.current = valuesFracao.valorMin1;
    valorSegundoPeriodo.current = valuesFracao.valorMin2;

    let situacaoAnterior;
    switch (situacao.current) {
      case "Alugar":
        situacaoAnterior = "ALUGAR";
        break;
      case "Alugar ou trocar":
        situacaoAnterior = "ALUGAR_TROCAR";
        break;
      case "Trocar":
        situacaoAnterior = "TROCAR";
        break;
      case "Não definido":
        situacaoAnterior = "NAO_DEFINIDO";
        break;
      case "Reservado pelo próprio":
        situacaoAnterior = "CONCLUIDO_PELO_PROPRIO";
        break;
      case "Será utilizado":
        situacaoAnterior = "UTILIZADO";
        break;
    }

    //  const valorMin = valor.current;

    if (Token) {
      // console.log("periodo.current");
      // console.log(periodo.current);
      const URLPeriodoGet = `${Globais.DOMINIOBACK}/periodo/${periodo.current}`;

      try {
        const responsePeriodoGet = await axios.get(URLPeriodoGet, {
          headers: { Authorization: Token.AuthStr },
        });
        if (responsePeriodoGet) {
          const URLPeriodo = `${Globais.DOMINIOBACK}/periodo/`;

          let formDataPeriodo1 = {
            cotaId: responsePeriodoGet.data.cotaId,
            checkIn: AlterarFormatoData(checkInPrimeiroPeriodo.current),
            checkOut: AlterarFormatoData(checkOutPrimeiroPeriodo.current),

            origem: Token.id,
          };

          try {
            const responseCriarPeriodo1 = await axios.post(
              URLPeriodo,
              formDataPeriodo1,
              {
                headers: { Authorization: Token.AuthStr },
              }
            );
            if (responseCriarPeriodo1) {
              // console.log("cheguei aqui agora");
              // console.log(valueStatus);
              let formDataPeriodoUsuario1 = {};
              const URLPeriodoUsuario = `${Globais.DOMINIOBACK}/periodo-usuario/`;
              if (alugarOuTrocar.current === 1) {
                if (valueStatus === "AGUARDANDO_SUGESTAO") {
                  if (statusAtual.current === "DELEGADO") {
                    formDataPeriodoUsuario1 = {
                      alugar: 1,
                      trocar: 0,
                      concluido: 0,
                      utilizar: 0,

                      valorMin: valorPrimeiroPeriodo.current,
                      periodoId: responseCriarPeriodo1.data.id,
                      cotasUsuariosId:
                        nCotaUsuarioId.cotaUsuarioId === 0
                          ? cotaUsuarioId.current
                          : nCotaUsuarioId.cotaUsuarioId,
                      fracionamento: periodoUsuario.current,

                      situacaoAnterior: situacaoAnterior,
                    };
                  } else {
                    formDataPeriodoUsuario1 = {
                      alugar: 1,
                      trocar: 0,
                      concluido: 0,
                      utilizar: 0,
                      dataSugestao: AlterarFormatoData(
                        new Date().toLocaleDateString()
                      ),
                      valorSugerido: valorPrimeiroPeriodo.current,
                      periodoId: responseCriarPeriodo1.data.id,
                      cotasUsuariosId:
                        nCotaUsuarioId.cotaUsuarioId === 0
                          ? cotaUsuarioId.current
                          : nCotaUsuarioId.cotaUsuarioId,
                      fracionamento: periodoUsuario.current,
                      status: valueStatus,
                      situacaoAnterior: situacaoAnterior,
                    };
                  }
                } else {
                  if (valueStatus === "AGUARDANDO_PEDIDO") {
                    formDataPeriodoUsuario1 = {
                      alugar: 1,
                      trocar: 0,
                      concluido: 0,
                      utilizar: 0,
                      valorSugerido: valorPrimeiroPeriodo.current,
                      periodoId: responseCriarPeriodo1.data.id,
                      cotasUsuariosId:
                        nCotaUsuarioId.cotaUsuarioId === 0
                          ? cotaUsuarioId.current
                          : nCotaUsuarioId.cotaUsuarioId,
                      fracionamento: periodoUsuario.current,
                      status: valueStatus,
                      situacaoAnterior: situacaoAnterior,
                    };
                  }
                }
              } else {
                if (alugarOuTrocar.current === 2) {
                  if (valueStatus === "AGUARDANDO_SUGESTAO") {
                    if (statusAtual.current === "DELEGADO") {
                      formDataPeriodoUsuario1 = {
                        alugar: 1,
                        trocar: 1,
                        concluido: 0,
                        utilizar: 0,

                        valorMin: valorPrimeiroPeriodo.current,
                        periodoId: responseCriarPeriodo1.data.id,
                        cotasUsuariosId:
                          nCotaUsuarioId.cotaUsuarioId === 0
                            ? cotaUsuarioId.current
                            : nCotaUsuarioId.cotaUsuarioId,
                        fracionamento: periodoUsuario.current,

                        situacaoAnterior: situacaoAnterior,
                      };
                    } else {
                      formDataPeriodoUsuario1 = {
                        alugar: 1,
                        trocar: 1,
                        concluido: 0,
                        utilizar: 0,
                        dataSugestao: AlterarFormatoData(
                          new Date().toLocaleDateString()
                        ),
                        valorSugerido: valorPrimeiroPeriodo.current,
                        periodoId: responseCriarPeriodo1.data.id,
                        cotasUsuariosId:
                          nCotaUsuarioId.cotaUsuarioId === 0
                            ? cotaUsuarioId.current
                            : nCotaUsuarioId.cotaUsuarioId,
                        fracionamento: periodoUsuario.current,
                        status: valueStatus,
                        situacaoAnterior: situacaoAnterior,
                      };
                    }
                  } else {
                    if (valueStatus === "AGUARDANDO_PEDIDO") {
                      formDataPeriodoUsuario1 = {
                        alugar: 1,
                        trocar: 1,
                        concluido: 0,
                        utilizar: 0,

                        valorSugerido: valorPrimeiroPeriodo.current,
                        periodoId: responseCriarPeriodo1.data.id,
                        cotasUsuariosId:
                          nCotaUsuarioId.cotaUsuarioId === 0
                            ? cotaUsuarioId.current
                            : nCotaUsuarioId.cotaUsuarioId,
                        fracionamento: periodoUsuario.current,
                        status: valueStatus,
                        situacaoAnterior: situacaoAnterior,
                      };
                    }
                  }
                }
              }

              const responseCriarPeriodoUsuario1 = await axios.post(
                URLPeriodoUsuario,
                formDataPeriodoUsuario1,
                {
                  headers: { Authorization: Token.AuthStr },
                }
              );
              if (responseCriarPeriodoUsuario1) {
                let formDataPeriodo2 = {
                  cotaId: responsePeriodoGet.data.cotaId,
                  checkIn: AlterarFormatoData(checkInSegundoPeriodo.current),
                  checkOut: AlterarFormatoData(checkOutSegundoPeriodo.current),

                  origem: Token.id,
                };
                try {
                  const responseCriarPeriodo2 = await axios.post(
                    URLPeriodo,
                    formDataPeriodo2,
                    {
                      headers: { Authorization: Token.AuthStr },
                    }
                  );
                  if (responseCriarPeriodo2) {
                    let formDataPeriodoUsuario2 = {};
                    if (alugarOuTrocar.current === 1) {
                      if (valueStatus === "AGUARDANDO_SUGESTAO") {
                        if (statusAtual.current === "DELEGADO") {
                          formDataPeriodoUsuario2 = {
                            alugar: 1,
                            trocar: 0,
                            concluido: 0,
                            utilizar: 0,

                            valorMin: valorSegundoPeriodo.current,
                            periodoId: responseCriarPeriodo2.data.id,
                            cotasUsuariosId:
                              nCotaUsuarioId.cotaUsuarioId === 0
                                ? cotaUsuarioId.current
                                : nCotaUsuarioId.cotaUsuarioId,
                            fracionamento: periodoUsuario.current,
                          };
                        } else {
                          formDataPeriodoUsuario2 = {
                            alugar: 1,
                            trocar: 0,
                            concluido: 0,
                            utilizar: 0,
                            dataSugestao: AlterarFormatoData(
                              new Date().toLocaleDateString()
                            ),
                            valorSugerido: valorSegundoPeriodo.current,
                            periodoId: responseCriarPeriodo2.data.id,
                            cotasUsuariosId:
                              nCotaUsuarioId.cotaUsuarioId === 0
                                ? cotaUsuarioId.current
                                : nCotaUsuarioId.cotaUsuarioId,
                            fracionamento: periodoUsuario.current,
                            status: valueStatus,
                          };
                        }
                      } else {
                        if (valueStatus === "AGUARDANDO_PEDIDO") {
                          formDataPeriodoUsuario2 = {
                            alugar: 1,
                            trocar: 0,
                            concluido: 0,
                            utilizar: 0,

                            valorSugerido: valorSegundoPeriodo.current,
                            periodoId: responseCriarPeriodo2.data.id,
                            cotasUsuariosId:
                              nCotaUsuarioId.cotaUsuarioId === 0
                                ? cotaUsuarioId.current
                                : nCotaUsuarioId.cotaUsuarioId,
                            fracionamento: periodoUsuario.current,
                            status: valueStatus,
                          };
                        }
                      }
                    } else {
                      if (alugarOuTrocar.current === 2) {
                        if (valueStatus === "AGUARDANDO_SUGESTAO") {
                          if (statusAtual.current === "DELEGADO") {
                            formDataPeriodoUsuario2 = {
                              alugar: 1,
                              trocar: 1,
                              concluido: 0,
                              utilizar: 0,

                              valorMin: valorSegundoPeriodo.current,
                              periodoId: responseCriarPeriodo2.data.id,
                              cotasUsuariosId:
                                nCotaUsuarioId.cotaUsuarioId === 0
                                  ? cotaUsuarioId.current
                                  : nCotaUsuarioId.cotaUsuarioId,
                              fracionamento: periodoUsuario.current,
                            };
                          } else {
                            formDataPeriodoUsuario2 = {
                              alugar: 1,
                              trocar: 1,
                              concluido: 0,
                              utilizar: 0,
                              dataSugestao: AlterarFormatoData(
                                new Date().toLocaleDateString()
                              ),
                              valorSugerido: valorSegundoPeriodo.current,
                              periodoId: responseCriarPeriodo2.data.id,
                              cotasUsuariosId:
                                nCotaUsuarioId.cotaUsuarioId === 0
                                  ? cotaUsuarioId.current
                                  : nCotaUsuarioId.cotaUsuarioId,
                              fracionamento: periodoUsuario.current,
                              status: valueStatus,
                            };
                          }
                        } else {
                          if (valueStatus === "AGUARDANDO_PEDIDO") {
                            formDataPeriodoUsuario2 = {
                              alugar: 1,
                              trocar: 1,
                              concluido: 0,
                              utilizar: 0,

                              valorSugerido: valorSegundoPeriodo.current,
                              periodoId: responseCriarPeriodo2.data.id,
                              cotasUsuariosId:
                                nCotaUsuarioId.cotaUsuarioId === 0
                                  ? cotaUsuarioId.current
                                  : nCotaUsuarioId.cotaUsuarioId,
                              fracionamento: periodoUsuario.current,
                              status: valueStatus,
                            };
                          }
                        }
                      }
                    }

                    try {
                      const responseCriarPeriodoUsuario2 = await axios.post(
                        URLPeriodoUsuario,
                        formDataPeriodoUsuario2,
                        {
                          headers: { Authorization: Token.AuthStr },
                        }
                      );
                      if (responseCriarPeriodoUsuario2) {
                        return true;
                      } else {
                        error("Algo deu errado!");
                        return false;
                      }
                    } catch (error) {
                      console.log(
                        "Não foi possível criar o segundo período do usuário"
                      );
                      error("Algo deu errado!");
                      return false;
                    }
                  }
                } catch (error) {
                  console.log("Não foi possível criar o segundo período");
                  error("Algo deu errado!");
                  return false;
                }
              }
            }
          } catch (error) {
            console.log("Não foi possível criar a fração de período");
            error("Algo deu errado!");
            return false;
          }
        }
      } catch (error) {
        console.log("Não foi possível saber qual período pai.");
        error("Algo deu errado!");
        return false;
      }
    }
  };
  const atualizarPeriodosFracionados = async (valuesFracao: any) => {
    const Token = validateToken();

    if (valuesFracao.checkIn1 === undefined) {
      valuesFracao.checkIn1 = checkInPeriodo.current;
    }
    if (valuesFracao.checkOut1 === undefined) {
      valuesFracao.checkOut1 = sugestaoCheckOut;
    }
    if (valuesFracao.checkIn2 === undefined) {
      valuesFracao.checkIn2 = sugestaoCheckOut;
    }
    if (valuesFracao.checkOut2 === undefined) {
      valuesFracao.checkOut2 = checkOutPeriodo.current;
    }
    checkInPrimeiroPeriodo.current = valuesFracao.checkIn1;
    checkOutPrimeiroPeriodo.current = valuesFracao.checkOut1;
    checkInSegundoPeriodo.current = valuesFracao.checkIn2;
    checkOutSegundoPeriodo.current = valuesFracao.checkOut2;
    valorPrimeiroPeriodo.current = valuesFracao.valorMin1;
    valorSegundoPeriodo.current = valuesFracao.valorMin2;

    switch (situacao.current) {
      case "Alugar":
        situacaoAnterior.current = "ALUGAR";
        break;
      case "Alugar ou trocar":
        situacaoAnterior.current = "ALUGAR_TROCAR";
        break;
      case "Trocar":
        situacaoAnterior.current = "TROCAR";
        break;
      case "Não definido":
        situacaoAnterior.current = "NAO_DEFINIDO";
        break;
      case "Reservado pelo próprio":
        situacaoAnterior.current = "CONCLUIDO_PELO_PROPRIO";
        break;
      case "Será utilizado":
        situacaoAnterior.current = "UTILIZADO";
        break;
    }

    //  const valorMin = valor.current;

    if (Token) {
      if (nCotaUsuarioId.cotaUsuarioId === 0) {
        Aluguel.filter(async (p: any) => {
          if (p.id === periodoUsuario.current) {
            if (await p.children) {
              p.children.filter(async (q: any) => {
                if ((await q.fracionamento) === (await p.id)) {
                  const URLGetPeriodoUsuario = `${Globais.DOMINIOBACK}/periodo-usuario/${q.id}`;

                  try {
                    const responsePeriodoUsuarioGet = await axios.get(
                      URLGetPeriodoUsuario,
                      {
                        headers: { Authorization: Token.AuthStr },
                      }
                    );
                    if (responsePeriodoUsuarioGet) {
                      const URLGetPeriodo = `${Globais.DOMINIOBACK}/periodo/${responsePeriodoUsuarioGet.data.periodoId}`;
                      const responsePeriodoGet = await axios.get(
                        URLGetPeriodo,
                        {
                          headers: { Authorization: Token.AuthStr },
                        }
                      );
                      if (responsePeriodoGet) {
                        if (
                          formatarData(responsePeriodoGet.data.checkIn) ===
                          checkInPrimeiroPeriodo.current
                        ) {
                          let formDataPeriodoUsuario1 = {};
                          if (alugarOuTrocar.current === 1) {
                            if (valueStatus === "AGUARDANDO_SUGESTAO") {
                              if (statusAtual.current === "DELEGADO") {
                                formDataPeriodoUsuario1 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorMin: valorPrimeiroPeriodo.current,
                                };
                              } else {
                                formDataPeriodoUsuario1 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorSugerido: valorPrimeiroPeriodo.current,
                                  statusAnterior:
                                    statusAtual.current === "alterado"
                                      ? "SEM_STATUS"
                                      : statusAtual.current,
                                  status: valueStatus,
                                  dataSugestao: AlterarFormatoData(
                                    new Date().toLocaleDateString()
                                  ),
                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              }
                            } else {
                              if (valueStatus === "AGUARDANDO_PEDIDO") {
                                formDataPeriodoUsuario1 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorSugerido: valorPrimeiroPeriodo.current,
                                  statusAnterior:
                                    statusAtual.current === "alterado"
                                      ? "SEM_STATUS"
                                      : statusAtual.current,
                                  status: valueStatus,

                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              }
                            }
                          } else {
                            if (alugarOuTrocar.current === 2) {
                              if (valueStatus === "AGUARDANDO_SUGESTAO") {
                                if (statusAtual.current === "DELEGADO") {
                                  formDataPeriodoUsuario1 = {
                                    alugar: 1,
                                    trocar: 1,
                                    utilizar: 0,
                                    concluido: 0,
                                    valorMin: valorPrimeiroPeriodo.current,
                                  };
                                } else {
                                  formDataPeriodoUsuario1 = {
                                    alugar: 1,
                                    trocar: 1,
                                    utilizar: 0,
                                    concluido: 0,
                                    valorSugerido: valorPrimeiroPeriodo.current,
                                    statusAnterior:
                                      statusAtual.current === "alterado"
                                        ? "SEM_STATUS"
                                        : statusAtual.current,
                                    status: valueStatus,
                                    dataSugestao: AlterarFormatoData(
                                      new Date().toLocaleDateString()
                                    ),
                                    situacaoAnterior: situacaoAnterior.current,
                                  };
                                }
                              } else {
                                if (valueStatus === "AGUARDANDO_PEDIDO") {
                                  if (statusAtual.current === "DELEGADO") {
                                    formDataPeriodoUsuario1 = {
                                      alugar: 1,
                                      trocar: 1,
                                      utilizar: 0,
                                      concluido: 0,
                                      valorMin: valorPrimeiroPeriodo.current,
                                    };
                                  } else {
                                    formDataPeriodoUsuario1 = {
                                      alugar: 1,
                                      trocar: 1,
                                      utilizar: 0,
                                      concluido: 0,
                                      valorSugerido:
                                        valorPrimeiroPeriodo.current,
                                      statusAnterior:
                                        statusAtual.current === "alterado"
                                          ? "SEM_STATUS"
                                          : statusAtual.current,
                                      status: valueStatus,

                                      situacaoAnterior:
                                        situacaoAnterior.current,
                                    };
                                  }
                                }
                              }
                            }
                          }

                          const responsePeriodoUsuarioPut = await axios.put(
                            URLGetPeriodoUsuario,
                            formDataPeriodoUsuario1,
                            {
                              headers: { Authorization: Token.AuthStr },
                            }
                          );
                          if (responsePeriodoUsuarioPut) {
                          } else {
                            error("Algo deu errado");
                          }
                        } else {
                          let formDataPeriodoUsuario2 = {};
                          if (alugarOuTrocar.current === 1) {
                            if (valueStatus === "AGUARDANDO_SUGESTAO") {
                              if (statusAtual.current === "DELEGADO") {
                                formDataPeriodoUsuario2 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorMin: valorSegundoPeriodo.current,
                                };
                              } else {
                                formDataPeriodoUsuario2 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorSugerido: valorSegundoPeriodo.current,
                                  statusAnterior:
                                    statusAtual.current === "alterado"
                                      ? "SEM_STATUS"
                                      : statusAtual.current,
                                  status: valueStatus,
                                  dataSugestao: AlterarFormatoData(
                                    new Date().toLocaleDateString()
                                  ),
                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              }
                            } else {
                              if (valueStatus === "AGUARDANDO_PEDIDO") {
                                formDataPeriodoUsuario2 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorSugerido: valorSegundoPeriodo.current,
                                  statusAnterior:
                                    statusAtual.current === "alterado"
                                      ? "SEM_STATUS"
                                      : statusAtual.current,
                                  status: valueStatus,
                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              }
                            }
                          } else {
                            if (alugarOuTrocar.current === 2) {
                              if (valueStatus === "AGUARDANDO_SUGESTAO") {
                                if (statusAtual.current === "DELEGADO") {
                                  formDataPeriodoUsuario2 = {
                                    alugar: 1,
                                    trocar: 1,
                                    utilizar: 0,
                                    concluido: 0,
                                    valorMin: valorSegundoPeriodo.current,
                                  };
                                } else {
                                  formDataPeriodoUsuario2 = {
                                    alugar: 1,
                                    trocar: 1,
                                    utilizar: 0,
                                    concluido: 0,
                                    valorSugerido: valorSegundoPeriodo.current,
                                    statusAnterior:
                                      statusAtual.current === "alterado"
                                        ? "SEM_STATUS"
                                        : statusAtual.current,
                                    status: valueStatus,
                                    dataSugestao: AlterarFormatoData(
                                      new Date().toLocaleDateString()
                                    ),
                                    situacaoAnterior: situacaoAnterior.current,
                                  };
                                }
                              } else {
                                if (valueStatus === "AGUARDANDO_PEDIDO") {
                                  formDataPeriodoUsuario2 = {
                                    alugar: 1,
                                    trocar: 1,
                                    utilizar: 0,
                                    concluido: 0,
                                    valorSugerido: valorSegundoPeriodo.current,
                                    statusAnterior:
                                      statusAtual.current === "alterado"
                                        ? "SEM_STATUS"
                                        : statusAtual.current,
                                    status: valueStatus,

                                    situacaoAnterior: situacaoAnterior.current,
                                  };
                                }
                              }
                            }
                          }

                          const responsePeriodoUsuarioPut2 = await axios.put(
                            URLGetPeriodoUsuario,
                            formDataPeriodoUsuario2,
                            {
                              headers: { Authorization: Token.AuthStr },
                            }
                          );
                          if (responsePeriodoUsuarioPut2) {
                          } else {
                            error("Algo deu errado");
                          }
                        }
                      }
                    }
                  } catch (e) {
                    error("Algo deu errado");
                  }
                }
              });
            }
          }
        });
        return true;
      } else {
        periodoData.filter(async (p: any) => {
          if (p.id === periodoUsuario.current) {
            if (await p.children) {
              p.children.filter(async (q: any) => {
                if ((await q.fracionamento) === (await p.id)) {
                  const URLGetPeriodoUsuario = `${Globais.DOMINIOBACK}/periodo-usuario/${q.id}`;

                  try {
                    const responsePeriodoUsuarioGet = await axios.get(
                      URLGetPeriodoUsuario,
                      {
                        headers: { Authorization: Token.AuthStr },
                      }
                    );
                    if (responsePeriodoUsuarioGet) {
                      const URLGetPeriodo = `${Globais.DOMINIOBACK}/periodo/${responsePeriodoUsuarioGet.data.periodoId}`;
                      const responsePeriodoGet = await axios.get(
                        URLGetPeriodo,
                        {
                          headers: { Authorization: Token.AuthStr },
                        }
                      );
                      if (responsePeriodoGet) {
                        if (
                          formatarData(responsePeriodoGet.data.checkIn) ===
                          checkInPrimeiroPeriodo.current
                        ) {
                          let formDataPeriodoUsuario1 = {};
                          if (alugarOuTrocar.current === 1) {
                            if (valueStatus === "AGUARDANDO_SUGESTAO") {
                              if (statusAtual.current === "DELEGADO") {
                                formDataPeriodoUsuario1 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorMin: valorPrimeiroPeriodo.current,
                                };
                              } else {
                                formDataPeriodoUsuario1 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorSugerido: valorPrimeiroPeriodo.current,
                                  statusAnterior:
                                    statusAtual.current === "alterado"
                                      ? "SEM_STATUS"
                                      : statusAtual.current,
                                  status: valueStatus,
                                  dataSugestao: AlterarFormatoData(
                                    new Date().toLocaleDateString()
                                  ),
                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              }
                            } else {
                              if (valueStatus === "AGUARDANDO_PEDIDO") {
                                formDataPeriodoUsuario1 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorSugerido: valorPrimeiroPeriodo.current,
                                  statusAnterior:
                                    statusAtual.current === "alterado"
                                      ? "SEM_STATUS"
                                      : statusAtual.current,
                                  status: valueStatus,

                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              }
                            }
                          } else {
                            if (alugarOuTrocar.current === 2) {
                              if (valueStatus === "AGUARDANDO_SUGESTAO") {
                                if (statusAtual.current === "DELEGADO") {
                                  formDataPeriodoUsuario1 = {
                                    alugar: 1,
                                    trocar: 1,
                                    utilizar: 0,
                                    concluido: 0,
                                    valorMin: valorPrimeiroPeriodo.current,
                                  };
                                } else {
                                  formDataPeriodoUsuario1 = {
                                    alugar: 1,
                                    trocar: 1,
                                    utilizar: 0,
                                    concluido: 0,
                                    valorSugerido: valorPrimeiroPeriodo.current,
                                    statusAnterior:
                                      statusAtual.current === "alterado"
                                        ? "SEM_STATUS"
                                        : statusAtual.current,
                                    status: valueStatus,
                                    dataSugestao: AlterarFormatoData(
                                      new Date().toLocaleDateString()
                                    ),
                                    situacaoAnterior: situacaoAnterior.current,
                                  };
                                }
                              } else {
                                if (valueStatus === "AGUARDANDO_PEDIDO") {
                                  if (statusAtual.current === "DELEGADO") {
                                    formDataPeriodoUsuario1 = {
                                      alugar: 1,
                                      trocar: 1,
                                      utilizar: 0,
                                      concluido: 0,
                                      valorMin: valorPrimeiroPeriodo.current,
                                    };
                                  } else {
                                    formDataPeriodoUsuario1 = {
                                      alugar: 1,
                                      trocar: 1,
                                      utilizar: 0,
                                      concluido: 0,
                                      valorSugerido:
                                        valorPrimeiroPeriodo.current,
                                      statusAnterior:
                                        statusAtual.current === "alterado"
                                          ? "SEM_STATUS"
                                          : statusAtual.current,
                                      status: valueStatus,

                                      situacaoAnterior:
                                        situacaoAnterior.current,
                                    };
                                  }
                                }
                              }
                            }
                          }

                          const responsePeriodoUsuarioPut = await axios.put(
                            URLGetPeriodoUsuario,
                            formDataPeriodoUsuario1,
                            {
                              headers: { Authorization: Token.AuthStr },
                            }
                          );
                          if (responsePeriodoUsuarioPut) {
                          } else {
                            error("Algo deu errado");
                          }
                        } else {
                          let formDataPeriodoUsuario2 = {};
                          if (alugarOuTrocar.current === 1) {
                            if (valueStatus === "AGUARDANDO_SUGESTAO") {
                              if (statusAtual.current === "DELEGADO") {
                                formDataPeriodoUsuario2 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorMin: valorSegundoPeriodo.current,
                                };
                              } else {
                                formDataPeriodoUsuario2 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorSugerido: valorSegundoPeriodo.current,
                                  statusAnterior:
                                    statusAtual.current === "alterado"
                                      ? "SEM_STATUS"
                                      : statusAtual.current,
                                  status: valueStatus,
                                  dataSugestao: AlterarFormatoData(
                                    new Date().toLocaleDateString()
                                  ),
                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              }
                            } else {
                              if (valueStatus === "AGUARDANDO_PEDIDO") {
                                formDataPeriodoUsuario2 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorSugerido: valorSegundoPeriodo.current,
                                  statusAnterior:
                                    statusAtual.current === "alterado"
                                      ? "SEM_STATUS"
                                      : statusAtual.current,
                                  status: valueStatus,
                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              }
                            }
                          } else {
                            if (alugarOuTrocar.current === 2) {
                              if (valueStatus === "AGUARDANDO_SUGESTAO") {
                                if (statusAtual.current === "DELEGADO") {
                                  formDataPeriodoUsuario2 = {
                                    alugar: 1,
                                    trocar: 1,
                                    utilizar: 0,
                                    concluido: 0,
                                    valorMin: valorSegundoPeriodo.current,
                                  };
                                } else {
                                  formDataPeriodoUsuario2 = {
                                    alugar: 1,
                                    trocar: 1,
                                    utilizar: 0,
                                    concluido: 0,
                                    valorSugerido: valorSegundoPeriodo.current,
                                    statusAnterior:
                                      statusAtual.current === "alterado"
                                        ? "SEM_STATUS"
                                        : statusAtual.current,
                                    status: valueStatus,
                                    dataSugestao: AlterarFormatoData(
                                      new Date().toLocaleDateString()
                                    ),
                                    situacaoAnterior: situacaoAnterior.current,
                                  };
                                }
                              } else {
                                if (valueStatus === "AGUARDANDO_PEDIDO") {
                                  formDataPeriodoUsuario2 = {
                                    alugar: 1,
                                    trocar: 1,
                                    utilizar: 0,
                                    concluido: 0,
                                    valorSugerido: valorSegundoPeriodo.current,
                                    statusAnterior:
                                      statusAtual.current === "alterado"
                                        ? "SEM_STATUS"
                                        : statusAtual.current,
                                    status: valueStatus,

                                    situacaoAnterior: situacaoAnterior.current,
                                  };
                                }
                              }
                            }
                          }

                          const responsePeriodoUsuarioPut2 = await axios.put(
                            URLGetPeriodoUsuario,
                            formDataPeriodoUsuario2,
                            {
                              headers: { Authorization: Token.AuthStr },
                            }
                          );
                          if (responsePeriodoUsuarioPut2) {
                          } else {
                            error("Algo deu errado");
                          }
                        }
                      }
                    }
                  } catch (e) {
                    error("Algo deu errado");
                  }
                }
              });
            }
          }
        });
        return true;
      }
    }
  };
  const ControlarPeriodosFracionadosEPrincipal = async (
    valuesFracaoCompleta: any
  ) => {
    setOpenFracaoCompleta(false);
    setOpenModalFracaoCompletaAtualizar(false);

    // const Token = validateToken();
    if (valueStatus === "AGUARDANDO_PEDIDO") {
      tipoEmail.current = 5;
    } else {
      if (valueStatus === "AGUARDANDO_SUGESTAO") {
        tipoEmail.current = 6;
      }
    }

    if (valuesFracaoCompleta.checkInPrincipal === undefined) {
      valuesFracaoCompleta.checkInPrincipal = checkInPeriodo.current;
    }

    if (valuesFracaoCompleta.checkOutPrincipal === undefined) {
      valuesFracaoCompleta.checkOutPrincipal = checkOutPeriodo.current;
    }

    if (valuesFracaoCompleta.checkIn1 === undefined) {
      valuesFracaoCompleta.checkIn1 = checkInPeriodo.current;
    }
    if (valuesFracaoCompleta.checkOut1 === undefined) {
      valuesFracaoCompleta.checkOut1 = sugestaoCheckOut;
    }
    if (valuesFracaoCompleta.checkIn2 === undefined) {
      valuesFracaoCompleta.checkIn2 = sugestaoCheckOut;
    }
    if (valuesFracaoCompleta.checkOut2 === undefined) {
      valuesFracaoCompleta.checkOut2 = checkOutPeriodo.current;
    }

    checkInPrimeiroPeriodo.current = valuesFracaoCompleta.checkIn1;
    checkOutPrimeiroPeriodo.current = valuesFracaoCompleta.checkOut1;
    checkInSegundoPeriodo.current = valuesFracaoCompleta.checkIn2;
    checkOutSegundoPeriodo.current = valuesFracaoCompleta.checkOut2;
    valorPrimeiroPeriodo.current = valuesFracaoCompleta.valorMin1;
    valorSegundoPeriodo.current = valuesFracaoCompleta.valorMin2;
    valor.current = valuesFracaoCompleta.valorMinPrincipal;
    const result = atualizarValorAluguel(
      periodoUsuario.current,
      alugarOuTrocar.current
    );

    if (await result) {
      const resultFracionados = atualizando.current
        ? atualizarPeriodosFracionados(valuesFracaoCompleta)
        : criarPeriodosFracionados(valuesFracaoCompleta);

      if (await resultFracionados) {
        prepararEmail();
      } else {
        error("Há algo de errado. Entre em contato conosco 1.");
      }
    } else {
      error("Há algo de errado. Entre em contato conosco.");
    }
  };
  const adicionarPeriodos = async () => {
    setOpenMaisPeriodo(false);
    const Token = validateToken();

    if (
      checkInPeriodoAdicionado.current === "" ||
      checkOutPeriodoAdicionado.current === ""
    ) {
      error("Favor acertar período.");
    } else {
      if (Token) {
        const URLCotaUsuarioGet = `${Globais.DOMINIOBACK}/cota-usuario/${nCotaUsuarioId.cotaUsuarioId}`;

        try {
          const responseCotaUsuarioGet = await axios.get(URLCotaUsuarioGet, {
            headers: { Authorization: Token.AuthStr },
          });
          if (responseCotaUsuarioGet) {
            const URLPeriodo = `${Globais.DOMINIOBACK}/periodo/`;

            let formDataPeriodo1 = {
              cotaId: responseCotaUsuarioGet.data.cotaId,
              checkIn: AlterarFormatoData(checkInPeriodoAdicionado.current),
              checkOut: AlterarFormatoData(checkOutPeriodoAdicionado.current),

              origem: Token.id,
            };

            try {
              const responseCriarPeriodo1 = await axios.post(
                URLPeriodo,
                formDataPeriodo1,
                {
                  headers: { Authorization: Token.AuthStr },
                }
              );
              if (responseCriarPeriodo1) {
                const URLPeriodoUsuario = `${Globais.DOMINIOBACK}/periodo-usuario/`;
                let formDataPeriodoUsuario1 = {
                  alugar: 0,
                  trocar: 0,
                  concluido: 0,
                  utilizar: 0,

                  periodoId: responseCriarPeriodo1.data.id,
                  cotasUsuariosId: nCotaUsuarioId.cotaUsuarioId,
                };
                try {
                  const responseCriarPeriodoUsuario1 = await axios.post(
                    URLPeriodoUsuario,
                    formDataPeriodoUsuario1,
                    {
                      headers: { Authorization: Token.AuthStr },
                    }
                  );
                  if (responseCriarPeriodoUsuario1) {
                    success("Período adicionado com sucesso!");
                    setTimeout(() => {
                      document.location.reload();
                    }, 2000);
                  } else {
                    error("Algo deu errado!");
                  }
                } catch (error) {
                  console.log("Não foi possível criar o período do usuário");
                  error("Algo deu errado!");
                }
              }
            } catch (error) {
              console.log("Não foi possível criar o período");
              error("Algo deu errado!");
            }
          } else {
            console.log("Não foi possível identificar a cota");
            error("Algo deu errado!");
          }
        } catch (error) {
          console.log("Não foi possível identificar a cota");
          error("Algo deu errado!");
        }
      } else {
        error("Favor fazer o login novamente!.");
        document.location.reload();
      }
    }
  };

  const prepararEmail = async () => {
    if (alugarOuTrocar.current === 1) {
      if (valueStatus === "AGUARDANDO_PEDIDO") {
        console.log("1");
        let formPeriodoUsuarioData = {
          tipoEmail: tipoEmail.current,
          periodoUsuarioId: periodoUsuario.current,
          valorSugerido: valor.current,
          situacaoDesejada: "ALUGAR",
        };

        try {
          // Chamada para a função assíncrona que envia o email
          const result = await enviarEmail(formPeriodoUsuarioData);

          // Verifica se o resultado é um objeto válido
          if (result && result === "Mensagens enviadas com sucesso.") {
            success("Período atualizado com sucesso!"); // Exibe mensagem de sucesso
            setTimeout(() => {
              document.location.reload();
            }, 2000);
          } else {
            if (
              result &&
              result === "Falha ao enviar WhatsApp. Mas e-mail enviado."
            ) {
              warning(result.toString());
              setTimeout(() => {
                document.location.reload();
              }, 2000);
            } else if (
              result &&
              result === "Falha. Não foi enviado E-mail e Whatsapp."
            ) {
              error(result.toString());
              setTimeout(() => {
                document.location.reload();
              }, 2000);
            } else {
              error(
                result
                  ? result.toString()
                  : "Período não atualizado. Deu algo errado."
              );
            }
          }
        } catch (error) {
          // Captura e trata erros inesperados
          console.log(error);

          // Exibe a mensagem de erro com base na estrutura da resposta
          error(error?.response?.data?.message || "Erro inesperado.");
        }
      } else {
        if (valueStatus === "AGUARDANDO_SUGESTAO") {
          let formPeriodoUsuarioData = {};
          let result;
          if (statusAtual.current === "DELEGADO") {
            result = 1;
          } else {
            formPeriodoUsuarioData = {
              tipoEmail: tipoEmail.current,
              periodoUsuarioId: periodoUsuario.current,
              valorSugerido: valor.current,
              situacaoDesejada: "ALUGAR",
            };

            try {
              // Chamada para a função assíncrona que envia o email
              const result = await enviarEmail(formPeriodoUsuarioData);

              // Verifica se o resultado é um objeto válido
              if (result && result === "Mensagens enviadas com sucesso.") {
                success("Período atualizado com sucesso!"); // Exibe mensagem de sucesso
                setTimeout(() => {
                  document.location.reload();
                }, 2000);
              } else {
                if (
                  result &&
                  result === "Falha ao enviar WhatsApp. Mas e-mail enviado."
                ) {
                  warning(result.toString());
                  setTimeout(() => {
                    document.location.reload();
                  }, 2000);
                } else if (
                  result &&
                  result === "Falha. Não foi enviado E-mail e Whatsapp."
                ) {
                  error(result.toString());
                  setTimeout(() => {
                    document.location.reload();
                  }, 2000);
                } else {
                  error(
                    result
                      ? result.toString()
                      : "Período não atualizado. Deu algo errado."
                  );
                }
              }
            } catch (error) {
              // Captura e trata erros inesperados
              console.log(error);

              // Exibe a mensagem de erro com base na estrutura da resposta
              error(error?.response?.data?.message || "Erro inesperado.");
            }
          }
        }
      }
    } else {
      if (alugarOuTrocar.current === 2) {
        if (valueStatus === "AGUARDANDO_PEDIDO") {
          let formPeriodoUsuarioData = {
            tipoEmail: tipoEmail.current,
            periodoUsuarioId: periodoUsuario.current,
            valorSugerido: valor.current,
            situacaoDesejada: "ALUGAR OU TROCAR",
          };

          try {
            // Chamada para a função assíncrona que envia o email
            const result = await enviarEmail(formPeriodoUsuarioData);

            // Verifica se o resultado é um objeto válido
            if (result && result === "Mensagens enviadas com sucesso.") {
              success("Período atualizado com sucesso!"); // Exibe mensagem de sucesso
              setTimeout(() => {
                document.location.reload();
              }, 2000);
            } else {
              if (result && result.toString === "Falha no envio de e-mail.") {
                warning(result.toString());
              } else if (
                result &&
                result.toString === "Falha no envio de mensagem pelo WhatsApp."
              ) {
                warning(result.toString());
                setTimeout(() => {
                  document.location.reload();
                }, 2000);
              } else {
                error(
                  result
                    ? result.toString()
                    : "Período não atualizado. Deu algo errado."
                );
              }
            }
          } catch (error) {
            // Captura e trata erros inesperados
            console.log(error);

            // Exibe a mensagem de erro com base na estrutura da resposta
            error(error?.response?.data?.message || "Erro inesperado.");
          }
        } else {
          if (valueStatus === "AGUARDANDO_SUGESTAO") {
            let formPeriodoUsuarioData = {};
            let result;
            if (statusAtual.current === "DELEGADO") {
              result = 1;
            } else {
              formPeriodoUsuarioData = {
                tipoEmail: tipoEmail.current,
                periodoUsuarioId: periodoUsuario.current,
                valorSugerido: valor.current,
                situacaoDesejada: "ALUGAR OU TROCAR",
              };
              try {
                // Chamada para a função assíncrona que envia o email
                const result = await enviarEmail(formPeriodoUsuarioData);

                // Verifica se o resultado é um objeto válido
                if (result && result === "Mensagens enviadas com sucesso.") {
                  success("Período atualizado com sucesso!"); // Exibe mensagem de sucesso
                  setTimeout(() => {
                    document.location.reload();
                  }, 2000);
                } else {
                  if (
                    result &&
                    result.toString === "Falha no envio de e-mail."
                  ) {
                    warning(result.toString());
                  } else if (
                    result &&
                    result.toString ===
                      "Falha no envio de mensagem pelo WhatsApp."
                  ) {
                    warning(result.toString());
                    setTimeout(() => {
                      document.location.reload();
                    }, 2000);
                  } else {
                    error(
                      result
                        ? result.toString()
                        : "Período não atualizado. Deu algo errado."
                    );
                  }
                }
              } catch (error) {
                // Captura e trata erros inesperados
                console.log(error);

                // Exibe a mensagem de erro com base na estrutura da resposta
                error(error?.response?.data?.message || "Erro inesperado.");
              }
            }
          }
        }
      }
    }
  };

  const removerFiltros = () => {
    localStorage.removeItem("filtrosGerPeriodoUsuario");
    localStorage.removeItem("pageGerPeriodoUsuario");
  };

  const handleFilter = () => {
    removerFiltros();
    setSemFiltros(true);
    document.location.reload();
  };

  const AbriModalFracaoCompleta = () => {
    setOpenModalPerguntaFracaoCompleta(false);

    // console.log(atualizando.current);
    if (atualizando.current) {
      setOpenModalFracaoCompletaAtualizar(true);
    } else {
      setOpenModalFracaoCompleta(true);
    }
  };

  const FecharPerguntaFracaoCompleta = () => {
    setOpenModalPerguntaFracaoCompleta(false);
  };

  const AbrirModalValor = () => {
    setOpenModalPerguntaFracaoCompleta(false);

    setOpenValor(true);
  };
  const columnsAlugueis: ColumnsType<DataType> = [
    {
      title: "Usuário",
      dataIndex: "nomeUs",
      key: "nomeUs",
      width: "20%",
      ...getColumnSearchProps("nomeUs"),

      filteredValue: filteredInfo.nomeUs,
    },

    {
      title: "Empreendimento",
      dataIndex: "nomeEP",
      key: "nomeEP",
      width: "18%",
      ...getColumnSearchProps("nomeEP"),
      filteredValue: filteredInfo.nomeEP,
    },

    {
      title: "CheckIn",
      dataIndex: "checkIn",
      key: "checkIn",
      width: "10%",
      ...getColumnSearchProps("checkIn"),

      filteredValue: filteredInfo.checkIn,
    },
    {
      title: "CheckOut",
      dataIndex: "checkOut",
      key: "checkOut",
      width: "10%",
      ...getColumnSearchProps("checkOut"),
      filteredValue: filteredInfo.checkOut,
    },
    {
      title: "",
      dataIndex: "especial",
      key: "especial",
      width: "5%",
      align: "center",
      filteredValue: filteredInfo.especial,
      filters: [
        { text: "Data especial", value: "Data_especial" },

        { text: "Data normal", value: "Data_normal" },
      ],

      onFilter: (value: any, record) => record.especial.includes(value),
      filterSearch: true,

      render: (item, row) =>
        row.especial === "Data_especial" ? (
          <Tooltip title={row.dataEspecial}>
            <StarsIcon color="warning" />
          </Tooltip>
        ) : row.especial === "Data_normal" ? (
          <Tooltip title={"Não é uma data especial."}>
            <HideSourceIcon sx={{ color: grey[500] }} />
          </Tooltip>
        ) : null,
    },
    {
      title: "",
      dataIndex: "situacao",
      key: "situacao",
      width: "5%",
      align: "center",
      filteredValue: filteredInfo.situacao,

      filters: [
        { text: "Não definido", value: "Não definido" },

        { text: "Alugar", value: "Alugar " },
        { text: "Alugar ou trocar", value: "Alugar ou trocar" },
      ],

      onFilter: (value: any, record) => record.situacao.includes(value),
      filterSearch: true,

      render: (item, row) =>
        row.situacao === "Não definido" ? (
          //aqui
          <Tooltip title={row.situacao}>
            <HelpIcon color="warning" />
          </Tooltip>
        ) : row.situacao === "Alugar" || row.situacao === "Alugar ou trocar" ? (
          <Tooltip title={row.situacao}>
            <PaidIcon color="success" />
          </Tooltip>
        ) : null,
    },
    {
      title: "Divulgado",
      dataIndex: "divulgado",
      key: "divulgado",
      // width: "13%",
      filteredValue: filteredInfo.divulgado,

      filters: [
        { text: "Sim", value: "Sim" },
        { text: "Não", value: "Não" },
      ],
      onFilter: (value: any, record) => record.divulgado.includes(value),
      filterSearch: true,
    },

    {
      title: "Valor confirmado",
      dataIndex: "valorMin",
      key: "valorMin",
      width: "10%",
      filteredValue: filteredInfo.valorMin,
    },
    {
      title: "Data Confirmação",
      dataIndex: "dataConfirmacao",
      key: "dataConfirmacao",
      width: "10%",
      filteredValue: filteredInfo.dataConfirmacao,
    },
    {
      title: "Valor prévio",
      dataIndex: "valorSugerido",
      key: "valorSugerido",
      width: "10%",
      filteredValue: filteredInfo.valorSugerido,
    },
    {
      title: "Valor sugerido",
      dataIndex: "valorSugeridoSistema",
      key: "valorSugeridoSistema",
      width: "10%",
      filteredValue: filteredInfo.valorSugeridoSistema,
    },

    {
      title: "Status",
      dataIndex: "icone",
      key: "icone",
      width: "5%",
      filteredValue: filteredInfo.icone,

      filters: [
        { text: "Sem status", value: "SEM_STATUS" },
        { text: "Alterado/divulgado", value: "ALTERANDO_DIVULGADO" },

        {
          text: "Aguardando confirmação de sugestão",
          value: "AGUARDANDO_SUGESTAO",
        },
        {
          text: "Aguardando confirmação de pedido",
          value: "AGUARDANDO_PEDIDO",
        },
        { text: "Delegado", value: "DELEGADO" },
        { text: "Não pertube", value: "NAO_PERTUBE" },
        { text: "Verificar", value: "VERIFICAR" },
        { text: "Finalizado", value: "FINALIZADO" },
        { text: "Alterado", value: "ALTERADO" },
        { text: "Alugado Parcialmente", value: "FRACAO_FINALIZADA" },
      ],
      onFilter: (value: any, record) => record.icone.includes(value),
      filterSearch: true,

      render: (item, row) =>
        row.icone === "ALTERANDO_DIVULGADO" ? (
          <Tooltip title={row.tarefa}>
            <ChangeCircleIcon style={{ color: "red" }} />
          </Tooltip>
        ) : row.icone === "AGUARDANDO_SUGESTAO" ||
          row.icone === "AGUARDANDO_PEDIDO" ? (
          <Tooltip title={row.tarefa}>
            <PauseCircleOutlineIcon color="warning" />
          </Tooltip>
        ) : row.icone === "DELEGADO" ? (
          <Tooltip title="Proprietário delegou a gestão ao Multicotas">
            <PersonOffIcon color="primary" />
          </Tooltip>
        ) : row.icone === "SEM_STATUS" ? (
          <Tooltip title="Período sem status">
            <SentimentVeryDissatisfiedIcon sx={{ color: grey[900] }} />
          </Tooltip>
        ) : row.icone === "NAO_PERTUBE" ? (
          <Tooltip title="Não devemos fazer sugestões">
            {/* <SentimentVeryDissatisfiedIcon color="primary" /> */}
            <DoDisturbOnIcon sx={{ color: red[900] }} />
          </Tooltip>
        ) : row.icone === "VERIFICAR" ? (
          <Tooltip title="Esse período deve ser verificado">
            <WarningAmberIcon sx={{ color: red[900] }} />
          </Tooltip>
        ) : row.icone === "FINALIZADO" ? (
          <Tooltip title="Finalizado">
            <CheckCircleOutlineIcon color="success" />
          </Tooltip>
        ) : row.icone === "ALTERADO" ? (
          <Tooltip title={row.tarefa}>
            <CloudSyncTwoToneIcon color="success" />
          </Tooltip>
        ) : row.icone === "PARCIAL" ? (
          <Tooltip title={row.tarefa}>
            <BatteryCharging50Icon color="success" />
          </Tooltip>
        ) : null,
    },
    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              //aqui
              onClick={() => {
                situacao.current = row.situacao;
                divulgado.current = row.divulgado;
                periodoUsuario.current = row.id;
                periodo.current = row.periodoId;
                valor.current = row.valorMin;
                valorSugerido.current = row.valorSugerido;
                fracionamento.current = row.fracionamento;
                valorSugeridoSistema.current = row.valorSugeridoSistema;
                statusAtual.current = row.status;
                statusAnterior.current = row.statusAnterior;
                dataSugestao.current = row.dataSugestao;
                active.current = +row.active;
                cotaUsuarioId.current = +row.idCTU;
                specialDate.current = row.especial;
                checkInPeriodo.current = row.checkIn;
                alterando.current = row.alterado;

                checkOutPeriodo.current = row.checkOut;
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    if (openModalFracaoCompletaAtualizar || openModalFracaoCompleta) {
      if (specialDate.current === "Data_especial") {
        showWarning(
          "Fique atento ao fracionar este período pois ele contém um feriado!"
        );
      }
    }
  }, [
    openModalFracaoCompletaAtualizar,
    specialDate,
    openModalFracaoCompleta,
    showWarning,
  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState<any>({
    situacao: null,
    divulgado: null,
    periodoUsuario: null,
    periodo: null,
    valor: null,
    valorSugerido: null,
    fracionamento: null,
    valorSugeridoSistema: null,
    statusAtual: null,
    statusAnterior: null,
    dataSugestao: null,
    active: null,
    cotaUsuarioId: null,
    specialDate: null,
    checkInPeriodo: null,
    alterando: null,
    checkOutPeriodo: null,
  });

  const showModalAcoes = (data: any) => {
    setSelectedData(data); // Define os dados da linha selecionada
    setIsModalOpen(true);
  };

  // Funçao para fechar o modal excluir assinatura
  const handleFechar = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : isDesktop ? (
        <Container>
          {contextHolder}

          <Row>
            <Col span={5}>
              <Flex align="center" justify="center" style={{ marginTop: 15 }}>
                <a
                  href={`/gerenciarPropriedades/?userId=${nUserId.userId}&&nomeProp=${nNome.nomeProp}`}
                >
                 
                </a>
              </Flex>
            </Col>
            <Col span={12}>
              <Flex align="center" justify="center">
                <AttachMoneyIcon color="primary" fontSize="large" />
                {nCotaUsuarioId.cotaUsuarioId === 0 ? (
                  <Title
                    level={4} // Usa o level para tamanho base
                    style={{
                      marginLeft: 10,
                      marginTop: 10,
                      color: "rgb(0, 54, 68)",
                      fontSize: isMobile ? "1.2rem" : "1.8rem", // Ajuste fino só pra garantir responsividade
                    }}
                  >
                    Gerenciar aluguéis
                  </Title>
                ) : (
                  <Title
                    level={3} // Usa level menor que h1 pra não ficar gigante
                    style={{
                      marginLeft: 10,
                      marginTop: 10,
                      color: "rgb(0, 54, 68)",
                      fontSize: isMobile ? "1.2rem" : "1.8rem", // Mesmo ajuste
                    }}
                  >
                    {`Períodos de ${nNome.nomeProp} em ${nNomeEmpreend.nomeEmpreend} / ${nNumeroCota.numeroCota}`}
                  </Title>
                )}
              </Flex>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Flex
                justify="space-between"
                align="center"
                style={{
                  width: "90%",
                  gap: "20px",
                }}
              >
                {/* ESQUERDA */}
                <Flex align="center" style={{ gap: "20px" }}>
                  <Space size="middle" style={{ marginLeft: 40 }}>
                    <Dropdown menu={{ items, onClick }} trigger={["click"]}>
                      <BotoesAcoes
                        onClick={() => {
                          emLote.current = 1;
                        }}
                      >
                        <Space>
                          <SettingsIcon />
                        </Space>
                      </BotoesAcoes>
                    </Dropdown>
                  </Space>
                  <span style={{ marginLeft: 8 }}>
                    {hasSelected
                      ? `Selecionado ${selectedRowKeys.length} período(s)`
                      : ""}
                  </span>
                </Flex>

                {/* DIREITA */}
                <Flex align="center" style={{ gap: "20px" }}>
                  <Badge count={contadorVerificar.current}>
                    <Avatar
                      shape="square"
                      style={{
                        backgroundColor: "transparent",
                        border: "1px solid grey",
                      }}
                      size="large"
                    >
                      <WarningAmberIcon sx={{ color: red[900] }} />
                    </Avatar>
                  </Badge>

                  <Badge count={contadorAlterando.current}>
                    <Avatar
                      shape="square"
                      style={{
                        backgroundColor: "transparent",
                        border: "1px solid grey",
                      }}
                      size="large"
                    >
                      <ChangeCircleIcon style={{ color: "red" }} />
                    </Avatar>
                  </Badge>

                  <Badge count={contadorAlterado.current}>
                    <Avatar
                      shape="square"
                      style={{
                        backgroundColor: "transparent",
                        border: "1px solid grey",
                      }}
                      size="large"
                    >
                      <CloudSyncTwoToneIcon color="success" />
                    </Avatar>
                  </Badge>

                  <Badge count={contadorAguardando.current}>
                    <Avatar
                      shape="square"
                      style={{
                        backgroundColor: "transparent",
                        border: "1px solid grey",
                      }}
                      size="large"
                    >
                      <PauseCircleOutlineIcon color="warning" />
                    </Avatar>
                  </Badge>

                  {semFiltros ? (
                    <Button
                      onClick={handleFilter}
                      type="primary"
                      disabled={true}
                      style={{ marginBottom: 16 }}
                    >
                      <FilterAltIcon />
                    </Button>
                  ) : (
                    <Button
                      onClick={handleFilter}
                      type="primary"
                      style={{ marginBottom: 16 }}
                    >
                      <FilterAltOffIcon />
                    </Button>
                  )}
                </Flex>
              </Flex>
            </Col>

            <Col
              span={22}
              style={{
                marginTop: isMobile ? 15 : 15,
                marginBottom: isMobile ? 30 : 50,
              }}
            >
              <Flex
                style={{
                  width: isMobile ? "auto" : "100%",
                  overflow: "auto",
                  marginLeft: 30,
                }}
              >
                {" "}
                {nCotaUsuarioId.cotaUsuarioId === 0 ? (
                  <Table
                    columns={columnsAlugueis}
                    dataSource={Aluguel}
                    onChange={onChangeAlugueis}
                    bordered
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      width: isMobile ? "auto" : "100%",
                      maxWidth: isMobile ? "none" : "100%",
                    }}
                    pagination={{ defaultCurrent: currentPage }}
                    rowSelection={{ ...rowSelection }}
                  />
                ) : (
                  <Table
                    columns={columns}
                    dataSource={periodoData}
                    onChange={onChange}
                    bordered
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      width: isMobile ? "auto" : "100%",
                      maxWidth: isMobile ? "none" : "100%",
                    }}
                    pagination={{ defaultCurrent: currentPage }}
                    rowSelection={{ ...rowSelection }}
                  />
                )}
              </Flex>
            </Col>
          </Row>

          <Modal
            title="Tem certeza que deseja excluir?"
            open={openExcluir}
            onOk={excluirPeriodo}
            onCancel={hideModal}
            okText="Sim, quero excluir"
            cancelText="Não"
          >
            <p>
              Essa ação não poderá ser desfeita. Será necessário criar outro
              período.
            </p>
          </Modal>
          <CollectionCreateForm
            open={open}
            onCreate={async function (values: Values): Promise<void> {
              // console.log(values);
              let resposta = enviarEmail({
                userId: userId.current,
                tipoEmail: 1,
                subjectEmail: values.title,
                bodyEmail: values.description,
              });
              if (await resposta) {
                setOpen(false);
                success("Mensagem enviada com sucesso!");
              } else {
                error("Algo deu errado!");
              }
            }}
            onCancel={function (): void {
              setOpen(false);
            }}
          />
          <CollectionCreateFormValoresAnunciado
            open={openValoresAnunciado}
            onCreate={async function (
              valuesValoresAnunciado: ValuesValoresAnunciado
            ): Promise<void> {}}
            onCancel={function (): void {
              setOpenValoresAnunciado(false);
            }}
          />
          <CollectionCreateFormValor
            open={openValor}
            onCreate={async function (valuesValor: ValuesValor): Promise<void> {
              valor.current = valuesValor.valorMin;
              if (emLote.current === 0) {
                if (valueStatus === "AGUARDANDO_PEDIDO") {
                  tipoEmail.current = 3;
                } else {
                  if (valueStatus === "AGUARDANDO_SUGESTAO") {
                    tipoEmail.current = 4;
                  }
                }
                if (
                  valueStatus === "AGUARDANDO_SUGESTAO" &&
                  statusAtual.current === "NAO_PERTUBE"
                ) {
                  error(
                    "Esse período não pode receber sugestões por decisão do proprietário"
                  );
                } else {
                  const result = atualizarValorAluguel(
                    periodoUsuario.current,
                    alugarOuTrocar.current
                  );

                  if (await result) {
                    prepararEmail();
                  } else {
                    error("Não foi possível atualizar período.");
                  }
                }
              } else {
                if (emLote.current === 1) {
                  // atualizarValorAluguelEmLote(
                  //   periodoUsuario.current,
                  //   alugarOuTrocar.current
                  // );
                }
              }
            }}
            onCancel={function (): void {
              setOpenValor(false);
            }}
          />
          <CollectionCreateFormFracao
            open={openFracao}
            onCreate={async function (
              valuesFracao: ValuesFracao
            ): Promise<void> {
              alugarOuTrocar.current = 1;
              const results = criarPeriodosFracionados(valuesFracao);
              if (await results) {
                if (valueStatus === "AGUARDANDO_PEDIDO") {
                  tipoEmail.current = 7;

                  prepararEmail();
                } else {
                  if (valueStatus === "AGUARDANDO_SUGESTAO") {
                    tipoEmail.current = 8;

                    prepararEmail();
                  }
                }
              } else {
                error("Há algo errado. Entre em contato conosco.");
              }
            }}
            onCancel={function (): void {
              setOpenFracao(false);
            }}
          />
          <CollectionCreateFormFracaoCompleta
            open={openFracaoCompleta}
            onCreate={async function (
              valuesFracaoCompleta: ValuesFracaoCompleta
            ): Promise<void> {
              if (
                valueStatus === "AGUARDANDO_SUGESTAO" &&
                statusAtual.current === "NAO_PERTUBE"
              ) {
                error(
                  "Esse período não pode receber sugestões por decisão do proprietário"
                );
              } else {
                ControlarPeriodosFracionadosEPrincipal(valuesFracaoCompleta);
              }
            }}
            onCancel={function (): void {
              setOpenFracaoCompleta(false);
            }}
          />
          <CollectionCreateFormFracaoCompletaAtualizar
            open={openModalFracaoCompletaAtualizar}
            onCreate={async function (
              valuesFracaoCompletaAtualizar: ValuesFracaoCompletaAtualizar
            ): Promise<void> {
              if (
                valueStatus === "AGUARDANDO_SUGESTAO" &&
                statusAtual.current === "NAO_PERTUBE"
              ) {
                error(
                  "Esse período não pode receber sugestões por decisão do proprietário"
                );
              } else {
                ControlarPeriodosFracionadosEPrincipal(
                  valuesFracaoCompletaAtualizar
                );
              }
            }}
            onCancel={function (): void {
              atualizando.current = false;
              setOpenModalFracaoCompletaAtualizar(false);
            }}
          />
          <CollectionCreateFormMaisPeriodo
            open={openMaisPeriodo}
            onCreate={async function (
              valuesMaisPeriodo: ValuesMaisPeriodo
            ): Promise<void> {
              adicionarPeriodos();
            }}
            onCancel={function (): void {
              setOpenMaisPeriodo(false);
            }}
          />
          <Modal
            open={openModalPerguntaFracaoCompleta}
            title={
              titleFracaoCompleta
                ? "Deseja atualizar os fracionados também?"
                : "Deseja fracionar também?"
            }
            onOk={AbriModalFracaoCompleta}
            onCancel={FecharPerguntaFracaoCompleta}
            cancelText="Cancelar"
            okText="Sim"
            footer={(_, { OkBtn, CancelBtn }) => (
              <>
                <CancelBtn />
                <Button onClick={AbrirModalValor}>Não</Button>
                <OkBtn />
              </>
            )}
          ></Modal>
        </Container>
      ) : isMobile ? (
        <Container>
          {contextHolder}
          <Row>
            {nCotaUsuarioId.cotaUsuarioId === 0 ? (
              <>
                <Col span={3}></Col>
                <Col span={18}>
                  <Flex justify="center" align="center">
                    <AttachMoneyIcon color="primary" fontSize="large" />
                    <Title level={4}>Gerenciar aluguéis</Title>
                  </Flex>
                </Col>
                <Col span={3}></Col>
              </>
            ) : (
              <>
                <Col span={3}>
                  <ContainerSeta>
                    <a
                      href={`/gerenciarPropriedades/?userId=${nUserId.userId}&&nomeProp=${nNome.nomeProp}`}
                    >
                      <ArrowBackIcon color="primary" />
                    </a>
                  </ContainerSeta>
                </Col>
                <Col span={18}>
                  <ContainerTitulo>
                    <CalendarMonthIcon color="primary" fontSize="large" />

                    <Title
                      level={4}
                    >{`Períodos de ${nNome.nomeProp} em ${nNomeEmpreend.nomeEmpreend} / ${nNumeroCota.numeroCota}`}</Title>
                  </ContainerTitulo>
                </Col>
                <Col></Col>
              </>
            )}
          </Row>
          <Flex
            align="center"
            wrap="wrap"
            style={{ width: "100%", justifyContent: "space-between" }}
          >
            {/* Dropdown Configurações */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 8,
              }}
            >
              <Dropdown menu={{ items, onClick }} trigger={["click"]}>
                <BotoesAcoes
                  onClick={() => {
                    emLote.current = 1;
                  }}
                >
                  <Space>
                    <SettingsIcon />
                  </Space>
                </BotoesAcoes>
              </Dropdown>
              <span style={{ marginLeft: 8 }}>
                {hasSelected
                  ? `Selecionado ${selectedRowKeys.length} período(s)`
                  : ""}
              </span>
            </div>

            {/* Badges com ícones */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 8,
                marginBottom: 8,
              }}
            >
              <Badge
                count={contadorVerificar.current}
                style={{ marginRight: 10 }}
              >
                <Avatar
                  shape="square"
                  style={{
                    backgroundColor: "transparent",
                    border: "1px solid grey",
                  }}
                  size="large"
                >
                  <WarningAmberIcon sx={{ color: red[900] }} />
                </Avatar>
              </Badge>
              <Badge
                count={contadorAlterando.current}
                style={{ marginRight: 10 }}
              >
                <Avatar
                  shape="square"
                  style={{
                    backgroundColor: "transparent",
                    border: "1px solid grey",
                  }}
                  size="large"
                >
                  <ChangeCircleIcon style={{ color: "red" }} />
                </Avatar>
              </Badge>
              <Badge
                count={contadorAlterado.current}
                style={{ marginRight: 10 }}
              >
                <Avatar
                  shape="square"
                  style={{
                    backgroundColor: "transparent",
                    border: "1px solid grey",
                  }}
                  size="large"
                >
                  <CloudSyncTwoToneIcon color="success" />
                </Avatar>
              </Badge>
              <Badge
                count={contadorAguardando.current}
                style={{ marginRight: 10 }}
              >
                <Avatar
                  shape="square"
                  style={{
                    backgroundColor: "transparent",
                    border: "1px solid grey",
                  }}
                  size="large"
                >
                  <PauseCircleOutlineIcon color="warning" />
                </Avatar>
              </Badge>
            </div>

            {/* Botão de Filtro */}
            <div style={{ marginBottom: 8 }}>
              {semFiltros ? (
                <Button
                  onClick={handleFilter}
                  type="primary"
                  disabled
                  style={{ marginBottom: 16 }}
                >
                  <FilterAltIcon />
                </Button>
              ) : (
                <Button
                  onClick={handleFilter}
                  type="primary"
                  style={{ marginBottom: 16 }}
                >
                  <FilterAltOffIcon />
                </Button>
              )}
            </div>
            {nCotaUsuarioId.cotaUsuarioId === 0
              ? Aluguel
              : periodoData.map((row: any, index: number) => (
                  <Row
                    key={`${row.key}-${index}`}
                    style={{
                      width: "100%",
                      margin: 0,
                      padding: 0,
                    }}
                  >
                    <Col span={24}>
                      <DropdownMobile
                        style={{
                          width: "100%",
                          borderBottom: "3px solid #C3CDC7",
                        }}
                      >
                        <DropdownMobile.Item
                          key={row.key}
                          style={{
                            width: "100%",
                            padding: "10px 15px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            textAlign: "left",
                          }}
                          title={
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "58px", // espaço entre os elementos
                                padding: "8px 0",
                              }}
                            >
                              <div style={{ whiteSpace: "nowrap" }}>
                                De {row.checkIn} a {row.checkOut}
                              </div>

                              <Button
                                type="primary"
                                onClick={(e) => {
                                  e.stopPropagation(); // Isso impede que o clique feche/abra o dropdown
                                  showModalAcoes({
                                    situacao: row.situacao,
                                    divulgado: row.divulgado,
                                    periodoUsuario: row.id,
                                    periodo: row.periodoId,
                                    valor: row.valorMin,
                                    valorSugerido: row.valorSugerido,
                                    fracionamento: row.fracionamento,
                                    valorSugeridoSistema:
                                      row.valorSugeridoSistema,
                                    statusAtual: row.status,
                                    statusAnterior: row.statusAnterior,
                                    dataSugestao: row.dataSugestao,
                                    active: +row.active,
                                    cotaUsuarioId: +row.idCTU,
                                    specialDate: row.especial,
                                    checkInPeriodo: row.checkIn,
                                    alterando: row.alterado,
                                    checkOutPeriodo: row.checkOut,
                                  });
                                }}
                                style={{
                                  backgroundColor: "#003644",
                                  borderColor: "#003644",
                                  color: "white",
                                  padding: "4px 12px",
                                }}
                              >
                                Ações
                              </Button>
                            </div>
                          }
                        >
                          <ContainerItems>
                            <Items>
                              <strong>Situação:</strong>{" "}
                              <Icon>{row.situacao}</Icon>
                            </Items>
                            <Items>
                              <strong>Divulgado:</strong>{" "}
                              <Icon>{row.divulgado}</Icon>
                            </Items>
                            <Items>
                              <strong>Valor Confirmado:</strong>{" "}
                              <Icon>{row.valorMin}</Icon>
                            </Items>
                            <Items>
                              <strong>Valor Sugerido:</strong>{" "}
                              <Icon>{row.valorSugerido}</Icon>
                            </Items>
                            <Items>
                              <strong>Status:</strong> <Icon>{row.icone}</Icon>
                            </Items>
                            {/* <Items>
                              
                            </Items> */}
                          </ContainerItems>
                        </DropdownMobile.Item>
                      </DropdownMobile>
                    </Col>
                  </Row>
                ))}
          </Flex>
        </Container>
      ) : null}
      <ModalAcoes
        isModalOpen={isModalOpen}
        handleFechar={handleFechar}
        onClick={onClick}
        data={selectedData}
        selectedRowKeys={selectedRowKeys} // Substitua com o valor real
        emLote={emLote.current} // Substitua com o valor real
      />
    </>
  );
}
